/* eslint-disable */
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailSkuDtoDTOBuilder = exports.EligibleDTOBuilder = exports.DurationUnitDTOBuilder = exports.DurationDTOBuilder = exports.DisplayPreviewDTOBuilder = exports.DiscountedPricingDTOBuilder = exports.DiscountInfoDTOBuilder = exports.DisclaimerInfoDTOBuilder = exports.DigitalGoodsPriceDTOBuilder = exports.CycleUnitTypeDTOBuilder = exports.CycleTypeDTOBuilder = exports.CyclePricingOldDTOBuilder = exports.CyclePricingDTOBuilder = exports.CyclePriceDTOBuilder = exports.CycleDisplayPropertiesDTOBuilder = exports.CycleChangeDTOBuilder = exports.CurrentSubscriptionInfoDTOBuilder = exports.CurrencySettingsDTOBuilder = exports.CurrencyFormattingKeyValueDTOBuilder = exports.CurrencyFormattingKeyDTOBuilder = exports.CurrencyCodeDTOBuilder = exports.CreateWixCheckoutResponseDTOBuilder = exports.CreateWixCheckoutRequestDTOBuilder = exports.CreateOrderPageResponseDTOBuilder = exports.CreateOrderPageRequestDTOBuilder = exports.CouponsTypeEligibilityDTOBuilder = exports.CouponPricingDTOBuilder = exports.CouponInfoDTOBuilder = exports.CouponDTOBuilder = exports.ContractSwitchTypeDTOBuilder = exports.CommonV1CycleDTOBuilder = exports.CatalogReferenceDTOBuilder = exports.CandidateSubscriptionDTOBuilder = exports.CancelResponseDTOBuilder = exports.CancelRequestDTOBuilder = exports.BooleanFeatureDTOBuilder = exports.BoSbsCatalogProductDTOBuilder = exports.BillingReferenceDTOBuilder = exports.BillingCycleDTOBuilder = exports.BillingAddressDTOBuilder = exports.ApplicationPricesDTOBuilder = exports.ApiV1CycleDTOBuilder = exports.AmountsDTOBuilder = exports.AllowedActionsDTOBuilder = exports.AllCurrenciesFormattingResponseDTOBuilder = exports.AllCurrenciesFormattingRequestDTOBuilder = exports.resetBuilderConfig = exports.builderConfig = exports.defaultMinArraySize = exports.defaultMaxArraySize = void 0;
exports.ListLineItemsPricesResponseDTOBuilder = exports.ListLineItemsPricesRequestDTOBuilder = exports.ListDigitalGoodsPricesResponseDTOBuilder = exports.ListDigitalGoodsPricesRequestDTOBuilder = exports.LineItemPricesDTOBuilder = exports.LineItemEntryDTOBuilder = exports.LineItemDTOBuilder = exports.ItemDataDTOBuilder = exports.ItemDTOBuilder = exports.IntervalUnitDTOBuilder = exports.IntervalDTOBuilder = exports.ImageDTOBuilder = exports.GetUserOfferingResponseDTOBuilder = exports.GetUserOfferingRequestDTOBuilder = exports.GetUserCouponsTypeEligibilityResponseDTOBuilder = exports.GetUserCouponsTypeEligibilityRequestDTOBuilder = exports.GetTaxSettingsResponseDTOBuilder = exports.GetTaxSettingsRequestDTOBuilder = exports.GetSaleResponseDTOBuilder = exports.GetSaleRequestDTOBuilder = exports.GetProductInfoResponseDTOBuilder = exports.GetProductInfoRequestDTOBuilder = exports.GetProductDisplayAttributesResponseDTOBuilder = exports.GetProductDisplayAttributesRequestDTOBuilder = exports.GetPackagePickerPricingResponseDTOBuilder = exports.GetPackagePickerPricingRequestDTOBuilder = exports.GetOrderPreviewResponseDTOBuilder = exports.GetOrderPreviewRequestDTOBuilder = exports.GetMailboxSaleTypeResponseDTOBuilder = exports.GetMailboxSaleTypeForUserRequestDTOBuilder = exports.GetMailboxSaleTypeForSiteRequestDTOBuilder = exports.GetMailboxSaleTypeForDomainRequestDTOBuilder = exports.GetItemsResponseDTOBuilder = exports.GetItemsRequestDTOBuilder = exports.GetInfoResponseDTOBuilder = exports.GetInfoRequestDTOBuilder = exports.GetFreeTrialEligibilityResponseDTOBuilder = exports.GetFreeTrialEligibilityRequestDTOBuilder = exports.GetCurrencySettingsResponseDTOBuilder = exports.GetCurrencySettingsRequestDTOBuilder = exports.GetB2BUserOfferingResponseDTOBuilder = exports.GetB2BUserOfferingRequestDTOBuilder = exports.GetAllowedActionsV2RequestDTOBuilder = exports.FreeTrialIneligibilityReasonEnumDTOBuilder = exports.FreeTrialEligibilityDTOBuilder = exports.FreeTrialDTOBuilder = exports.FieldDTOBuilder = exports.FeaturePeriodDTOBuilder = exports.FeatureDisplayAttributesDTOBuilder = exports.FeatureDTOBuilder = void 0;
exports.SalePricingDTOBuilder = exports.SaleDetailsDTOBuilder = exports.SaleCouponDTOBuilder = exports.SaleDTOBuilder = exports.RequestedProductDTOBuilder = exports.RequestedApplicationDTOBuilder = exports.RecurringPaymentDTOBuilder = exports.QuotaFeatureDTOBuilder = exports.PurchaseScenarioDTOBuilder = exports.PurchaseRuleDTOBuilder = exports.PurchaseReturnUrlsDTOBuilder = exports.PurchaseLineItemDTOBuilder = exports.PurchaseDisplayPropertiesDTOBuilder = exports.PurchaseDisclaimerDTOBuilder = exports.PurchaseDetailsDTOBuilder = exports.ProvisionProductsResponseDTOBuilder = exports.ProvisionProductsRequestDTOBuilder = exports.ProductPricingResultDTOBuilder = exports.ProductPricesDTOBuilder = exports.ProductInfoDTOBuilder = exports.ProductDisplayAttributesDTOBuilder = exports.ProductDataDTOBuilder = exports.ProductCyclePriceDTOBuilder = exports.ProductCouponDTOBuilder = exports.ProductChangeDTOBuilder = exports.ProductDTOBuilder = exports.PricingInfoDTOBuilder = exports.PriceAmountsDTOBuilder = exports.PremiumProductPriceDTOBuilder = exports.PremiumProductCatalogProductPricesDTOBuilder = exports.PremiumProductDTOBuilder = exports.PremiumCurrencySettingsDTOBuilder = exports.PersonalCouponDTOBuilder = exports.PaymentTypeDTOBuilder = exports.PaymentFiltersDTOBuilder = exports.PaymentCycleDTOBuilder = exports.OrderPreviewItemDTOBuilder = exports.OrderPreviewDTOBuilder = exports.OneTimeDTOBuilder = exports.NonCouponUsageDTOBuilder = exports.NewSubscriptionDTOBuilder = exports.MultiLingualTextDTOBuilder = exports.MailboxSaleTypeDTOBuilder = exports.MailboxOldSaleTypeDTOBuilder = exports.ListTpaPricesResponseDTOBuilder = exports.ListTpaPricesRequestDTOBuilder = exports.ListProductPricesResponseDTOBuilder = exports.ListProductPricesRequestDTOBuilder = exports.ListPremiumProductCatalogPricesResponseDTOBuilder = exports.ListPremiumProductCatalogPricesRequestDTOBuilder = void 0;
exports.aCouponsTypeEligibility = exports.aCouponPricing = exports.aCouponInfo = exports.aCoupon = exports.aContractSwitchType = exports.aCommonV1Cycle = exports.aCatalogReference = exports.aCandidateSubscription = exports.aCancelResponse = exports.aCancelRequest = exports.aBooleanFeature = exports.aBoSbsCatalogProduct = exports.aBillingReference = exports.aBillingCycle = exports.aBillingAddress = exports.anApplicationPrices = exports.anApiV1Cycle = exports.anAmounts = exports.anAllowedActions = exports.anAllCurrenciesFormattingResponse = exports.anAllCurrenciesFormattingRequest = exports.VendorProductPricesDTOBuilder = exports.ValidateNoPreviousPurchaseTypeDTOBuilder = exports.ValidateNoPreviousPurchaseResponseDTOBuilder = exports.ValidateNoPreviousPurchaseRequestDTOBuilder = exports.V1PendingChangesDTOBuilder = exports.V1FreeTrialDataDTOBuilder = exports.UserCouponDTOBuilder = exports.UpgradeSubscriptionDTOBuilder = exports.UnknownFieldSetDTOBuilder = exports.TransferDataDTOBuilder = exports.TaxTypeConfigurationTaxTypeDTOBuilder = exports.TaxSettingsTaxTypeDTOBuilder = exports.TaxSettingsDTOBuilder = exports.TaxAmountDTOBuilder = exports.TaxDTOBuilder = exports.SwitchContractDTOBuilder = exports.SupportedPaymentTypesFilterDTOBuilder = exports.SubscriptionUpgradeTypeDTOBuilder = exports.SubmitResponseDTOBuilder = exports.SubmitRequestDTOBuilder = exports.StreetAddressDTOBuilder = exports.StoreMailboxProductPricesDtoDTOBuilder = exports.StoreMailboxProductPriceDtoDTOBuilder = exports.ServicedataPendingChangesDTOBuilder = exports.ServicedataFreeTrialDataDTOBuilder = exports.ServiceStatusDTOBuilder = exports.ServiceRecurringTypeDTOBuilder = exports.ServiceDataDTOBuilder = exports.ServiceCouponDataDTOBuilder = void 0;
exports.aGetPackagePickerPricingRequest = exports.aGetOrderPreviewResponse = exports.aGetOrderPreviewRequest = exports.aGetMailboxSaleTypeResponse = exports.aGetMailboxSaleTypeForUserRequest = exports.aGetMailboxSaleTypeForSiteRequest = exports.aGetMailboxSaleTypeForDomainRequest = exports.aGetItemsResponse = exports.aGetItemsRequest = exports.aGetInfoResponse = exports.aGetInfoRequest = exports.aGetFreeTrialEligibilityResponse = exports.aGetFreeTrialEligibilityRequest = exports.aGetCurrencySettingsResponse = exports.aGetCurrencySettingsRequest = exports.aGetB2BUserOfferingResponse = exports.aGetB2BUserOfferingRequest = exports.aGetAllowedActionsV2Request = exports.aFreeTrialIneligibilityReasonEnum = exports.aFreeTrialEligibility = exports.aFreeTrial = exports.aField = exports.aFeaturePeriod = exports.aFeatureDisplayAttributes = exports.aFeature = exports.anEmailSkuDto = exports.anEligible = exports.aDurationUnit = exports.aDuration = exports.aDisplayPreview = exports.aDiscountedPricing = exports.aDiscountInfo = exports.aDisclaimerInfo = exports.aDigitalGoodsPrice = exports.aCycleUnitType = exports.aCycleType = exports.aCyclePricingOld = exports.aCyclePricing = exports.aCyclePrice = exports.aCycleDisplayProperties = exports.aCycleChange = exports.aCurrentSubscriptionInfo = exports.aCurrencySettings = exports.aCurrencyFormattingKeyValue = exports.aCurrencyFormattingKey = exports.aCurrencyCode = exports.aCreateWixCheckoutResponse = exports.aCreateWixCheckoutRequest = exports.aCreateOrderPageResponse = exports.aCreateOrderPageRequest = void 0;
exports.aProduct = exports.aPricingInfo = exports.aPriceAmounts = exports.aPremiumProductPrice = exports.aPremiumProductCatalogProductPrices = exports.aPremiumProduct = exports.aPremiumCurrencySettings = exports.aPersonalCoupon = exports.aPaymentType = exports.aPaymentFilters = exports.aPaymentCycle = exports.anOrderPreviewItem = exports.anOrderPreview = exports.anOneTime = exports.aNonCouponUsage = exports.aNewSubscription = exports.aMultiLingualText = exports.aMailboxSaleType = exports.aMailboxOldSaleType = exports.aListTpaPricesResponse = exports.aListTpaPricesRequest = exports.aListProductPricesResponse = exports.aListProductPricesRequest = exports.aListPremiumProductCatalogPricesResponse = exports.aListPremiumProductCatalogPricesRequest = exports.aListLineItemsPricesResponse = exports.aListLineItemsPricesRequest = exports.aListDigitalGoodsPricesResponse = exports.aListDigitalGoodsPricesRequest = exports.aLineItemPrices = exports.aLineItemEntry = exports.aLineItem = exports.anItemData = exports.anItem = exports.anIntervalUnit = exports.anInterval = exports.anImage = exports.aGetUserOfferingResponse = exports.aGetUserOfferingRequest = exports.aGetUserCouponsTypeEligibilityResponse = exports.aGetUserCouponsTypeEligibilityRequest = exports.aGetTaxSettingsResponse = exports.aGetTaxSettingsRequest = exports.aGetSaleResponse = exports.aGetSaleRequest = exports.aGetProductInfoResponse = exports.aGetProductInfoRequest = exports.aGetProductDisplayAttributesResponse = exports.aGetProductDisplayAttributesRequest = exports.aGetPackagePickerPricingResponse = void 0;
exports.aV1PendingChanges = exports.aV1FreeTrialData = exports.anUserCoupon = exports.anUpgradeSubscription = exports.anUnknownFieldSet = exports.aTransferData = exports.aTaxTypeConfigurationTaxType = exports.aTaxSettingsTaxType = exports.aTaxSettings = exports.aTaxAmount = exports.aTax = exports.aSwitchContract = exports.aSupportedPaymentTypesFilter = exports.aSubscriptionUpgradeType = exports.aSubmitResponse = exports.aSubmitRequest = exports.aStreetAddress = exports.aStoreMailboxProductPricesDto = exports.aStoreMailboxProductPriceDto = exports.aServicedataPendingChanges = exports.aServicedataFreeTrialData = exports.aServiceStatus = exports.aServiceRecurringType = exports.aServiceData = exports.aServiceCouponData = exports.aSalePricing = exports.aSaleDetails = exports.aSaleCoupon = exports.aSale = exports.aRequestedProduct = exports.aRequestedApplication = exports.aRecurringPayment = exports.aQuotaFeature = exports.aPurchaseScenario = exports.aPurchaseRule = exports.aPurchaseReturnUrls = exports.aPurchaseLineItem = exports.aPurchaseDisplayProperties = exports.aPurchaseDisclaimer = exports.aPurchaseDetails = exports.aProvisionProductsResponse = exports.aProvisionProductsRequest = exports.aProductPricingResult = exports.aProductPrices = exports.aProductInfo = exports.aProductDisplayAttributes = exports.aProductData = exports.aProductCyclePrice = exports.aProductCoupon = exports.aProductChange = void 0;
exports.aVendorProductPrices = exports.aValidateNoPreviousPurchaseType = exports.aValidateNoPreviousPurchaseResponse = exports.aValidateNoPreviousPurchaseRequest = void 0;
/* tslint:disable */
var types_1 = require("./types");
var UnassignedValue = Symbol('empty builder value');
var someBoolean = function () { return Math.random() > 0.5; };
var someDateObject = function () { return new Date(Math.floor(Math.random() * Date.now())); };
var someDateString = function () { return new Date(Math.floor(Math.random() * Date.now())).toISOString(); };
var emptyObject = function () { return ({}); };
var someGuid = function () { return 'xxxxxxxx-xxxx-4xxx-xxxx-xxxxxxxxxxxx'.replace(/x/g, function (c) { return '0123456789abcdef'[Math.floor(Math.random() * 16)]; }); };
var someInt = function () { return Math.floor(Math.random() * 1000000); };
var jsonMapOf = function (valueGenerator) {
    return new Array(exports.builderConfig.minArraySize + Math.round(Math.random() * (exports.builderConfig.maxArraySize - exports.builderConfig.minArraySize)))
        .fill(null)
        .map(function () { return [someString(), valueGenerator()]; })
        .reduce(function (jsonMap, _d) {
        var _e;
        var key = _d[0], val = _d[1];
        return (__assign(__assign({}, jsonMap), (_e = {}, _e[key] = val, _e)));
    }, {});
};
var manyOf = function (valueGenerator) {
    return new Array(exports.builderConfig.minArraySize + Math.round(Math.random() * (exports.builderConfig.maxArraySize - exports.builderConfig.minArraySize))).fill(null).map(function () { return valueGenerator(); });
};
var maybe = function (value) {
    var disableOptionals = readConfig('disabledOptionals');
    if (disableOptionals) {
        return value;
    }
    return Math.random() > 0.5 ? value : null;
};
var createNull = function () { return null; };
var someNumber = function () { return Math.random() * 1000000; };
var oneOf = function (valuesArray) { return valuesArray[Math.floor(Math.random() * valuesArray.length)]; };
var readConfig = function (value) {
    var _a, _b, _c;
    var packageJsonPath = process.cwd() + '/package.json';
    try {
        var packageJson = require(packageJsonPath);
        return (_c = (_b = (_a = packageJson) === null || _a === void 0 ? void 0 : _a.ambassador) === null || _b === void 0 ? void 0 : _b.builderConfig) === null || _c === void 0
            ? void 0
            : _c[value];
    }
    catch (e) {
        console.warn('Failed to find ' + packageJsonPath + ", that means you can't use " + value + ' property.');
    }
};
var someString = function () {
    return new Array(Math.round(Math.random() * 32))
        .fill(null)
        .map(function () { return 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_'[Math.floor(Math.random() * 64)]; })
        .join('');
};
var tupleOf = function () {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return items;
};
var someUrl = function () {
    var createString = function (len) {
        return new Array(len)
            .fill(null)
            .map(function () { return 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)]; })
            .join('');
    };
    return "http" + (Math.random() > 0.5 ? 's' : '') + "://" + createString(2 + Math.round(Math.random() * 8)) + "." + createString(2 + Math.round(Math.random() * 2));
};
var boundedString = function (minLength, maxLength) {
    return new Array(minLength + Math.round(Math.random() * (maxLength - minLength)))
        .fill(null)
        .map(function () { return 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_'[Math.floor(Math.random() * 64)]; })
        .join('');
};
var boundedAToZString = function (minLength, maxLength) {
    return new Array(minLength + Math.round(Math.random() * (maxLength - minLength)))
        .fill(null)
        .map(function () { return 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 62)]; })
        .join('');
};
var emailString = function () { return boundedString(3, 18) + '@' + hostNameString(); };
var hostNameString = function () { return (boundedAToZString(1, 63) + '.' + boundedAToZString(1, 63) + '.' + boundedAToZString(1, 63)).toLowerCase(); };
var iPv4String = function () { return randomInt(120, 255).toString() + '.' + randomInt(0, 255).toString() + '.' + randomInt(0, 255).toString() + '.' + randomInt(0, 255).toString(); };
var iPv6String = function () {
    return randomInt(4096, 65536).toString(16) + ':' + randomInt(4096, 65536).toString(16) + ':' + randomInt(4096, 65536).toString(16) + ':' + randomInt(4096, 65536).toString(16);
};
var phoneNumberString = function () { return randomInt(10, 99) + '-' + randomInt(1000, 9999) + '-' + randomInt(1000, 9999); };
var creditCardString = function () {
    var cardsOptions = [
        '4024007144802344',
        '4024007137343835',
        '4024007182408316904',
        '5319296635899189',
        '5313659704319460',
        '5239821231883506',
        '344185148936416',
        '376838602387168',
        '342988587028815',
        '6011063572203257',
        '6011897568342235',
        '6011688334523054321',
        '3532544447293430',
        '3541328171991545',
        '3543520126410292049',
        '5428157918095416',
        '5585210966718113',
        '5421059548115043',
        '30478533536597',
        '30520785757304',
        '30593479645481',
        '36041989673001',
        '36271989122390',
        '36385649757047',
        '6762419374462387',
        '6763799905488186',
        '5018087262076918',
        '4913766714630021',
        '4175006834432617',
        '4913034771805246',
        '6376711457713472',
        '6372692747824846',
        '6397824752439852',
    ];
    return cardsOptions[Math.floor(Math.random() * 32)];
};
var countryString = function () {
    var countryCodes = [
        'AF',
        'AX',
        'AL',
        'DZ',
        'AS',
        'AD',
        'AO',
        'AI',
        'AQ',
        'AG',
        'AR',
        'AM',
        'AW',
        'AU',
        'AT',
        'AZ',
        'BS',
        'BH',
        'BD',
        'BB',
        'BY',
        'BE',
        'BZ',
        'BJ',
        'BM',
        'BT',
        'BO',
        'BQ',
        'BA',
        'BW',
        'BV',
        'BR',
        'IO',
        'BN',
        'BG',
        'BF',
        'BI',
        'KH',
        'CM',
        'CA',
        'CV',
        'KY',
        'CF',
        'TD',
        'CL',
        'CN',
        'CX',
        'CC',
        'CO',
        'KM',
        'CG',
        'CD',
        'CK',
        'CR',
        'CI',
        'HR',
        'CU',
        'CW',
        'CY',
        'CZ',
        'DK',
        'DJ',
        'DM',
        'DO',
        'EC',
        'EG',
        'SV',
        'GQ',
        'ER',
        'EE',
        'ET',
        'FK',
        'FO',
        'FJ',
        'FI',
        'FR',
        'GF',
        'PF',
        'TF',
        'GA',
        'GM',
        'GE',
        'DE',
        'GH',
        'GI',
        'GR',
        'GL',
        'GD',
        'GP',
        'GU',
        'GT',
        'GG',
        'GN',
        'GW',
        'GY',
        'HT',
        'HM',
        'VA',
        'HN',
        'HK',
        'HU',
        'IS',
        'IN',
        'ID',
        'IR',
        'IQ',
        'IE',
        'IM',
        'IL',
        'IT',
        'JM',
        'JP',
        'JE',
        'JO',
        'KZ',
        'KE',
        'KI',
        'KP',
        'KR',
        'KW',
        'KG',
        'LA',
        'LV',
        'LB',
        'LS',
        'LR',
        'LY',
        'LI',
        'LT',
        'LU',
        'MO',
        'MK',
        'MG',
        'MW',
        'MY',
        'MV',
        'ML',
        'MT',
        'MH',
        'MQ',
        'MR',
        'MU',
        'YT',
        'MX',
        'FM',
        'MD',
        'MC',
        'MN',
        'ME',
        'MS',
        'MA',
        'MZ',
        'MM',
        'NA',
        'NR',
        'NP',
        'NL',
        'NC',
        'NZ',
        'NI',
        'NE',
        'NG',
        'NU',
        'NF',
        'MP',
        'NO',
        'OM',
        'PK',
        'PW',
        'PS',
        'PA',
        'PG',
        'PY',
        'PE',
        'PH',
        'PN',
        'PL',
        'PT',
        'PR',
        'QA',
        'RE',
        'RO',
        'RU',
        'RW',
        'BL',
        'SH',
        'KN',
        'LC',
        'MF',
        'PM',
        'VC',
        'WS',
        'SM',
        'ST',
        'SA',
        'SN',
        'RS',
        'SC',
        'SL',
        'SG',
        'SX',
        'SK',
        'SI',
        'SB',
        'SO',
        'ZA',
        'GS',
        'SS',
        'ES',
        'LK',
        'SD',
        'SR',
        'SJ',
        'SZ',
        'SE',
        'CH',
        'SY',
        'TW',
        'TJ',
        'TZ',
        'TH',
        'TL',
        'TG',
        'TK',
        'TO',
        'TT',
        'TN',
        'TR',
        'TM',
        'TC',
        'TV',
        'UG',
        'UA',
        'AE',
        'GB',
        'US',
        'UM',
        'UY',
        'UZ',
        'VU',
        'VE',
        'VN',
        'VG',
        'VI',
        'WF',
        'EH',
        'YE',
        'ZM',
        'ZW',
    ];
    return countryCodes[Math.floor(Math.random() * countryCodes.length)];
};
var languageString = function () {
    var languageCodes = [
        'aa',
        'ab',
        'ae',
        'af',
        'ak',
        'am',
        'an',
        'ar',
        'as',
        'av',
        'ay',
        'az',
        'ba',
        'be',
        'bg',
        'bh',
        'bm',
        'bi',
        'bn',
        'bo',
        'br',
        'bs',
        'ca',
        'ce',
        'ch',
        'co',
        'cr',
        'cs',
        'cu',
        'cv',
        'cy',
        'da',
        'de',
        'dv',
        'dz',
        'ee',
        'el',
        'en',
        'eo',
        'es',
        'et',
        'eu',
        'fa',
        'ff',
        'fi',
        'fj',
        'fo',
        'fr',
        'fy',
        'ga',
        'gd',
        'gl',
        'gn',
        'gu',
        'gv',
        'ha',
        'he',
        'hi',
        'ho',
        'hr',
        'ht',
        'hu',
        'hy',
        'hz',
        'ia',
        'id',
        'ie',
        'ig',
        'ii',
        'ik',
        'io',
        'is',
        'it',
        'iu',
        'ja',
        'jv',
        'ka',
        'kg',
        'ki',
        'kj',
        'kk',
        'kl',
        'km',
        'kn',
        'ko',
        'kr',
        'ks',
        'ku',
        'kv',
        'kw',
        'ky',
        'la',
        'lb',
        'lg',
        'li',
        'ln',
        'lo',
        'lt',
        'lu',
        'lv',
        'mg',
        'mh',
        'mi',
        'mk',
        'ml',
        'mn',
        'mr',
        'ms',
        'mt',
        'my',
        'na',
        'nb',
        'nd',
        'ne',
        'ng',
        'nl',
        'nn',
        'no',
        'nr',
        'nv',
        'ny',
        'oc',
        'oj',
        'om',
        'or',
        'os',
        'pa',
        'pi',
        'pl',
        'ps',
        'pt',
        'qu',
        'rm',
        'rn',
        'ro',
        'ru',
        'rw',
        'sa',
        'sc',
        'sd',
        'se',
        'sg',
        'si',
        'sk',
        'sl',
        'sm',
        'sn',
        'so',
        'sq',
        'sr',
        'ss',
        'st',
        'su',
        'sv',
        'sw',
        'ta',
        'te',
        'tg',
        'th',
        'ti',
        'tk',
        'tl',
        'tn',
        'to',
        'tr',
        'ts',
        'tt',
        'tw',
        'ty',
        'ug',
        'uk',
        'ur',
        'uz',
        've',
        'vi',
        'vo',
        'wa',
        'wo',
        'xh',
        'yi',
        'yo',
        'za',
        'zh',
        'zu',
    ];
    return languageCodes[Math.floor(Math.random() * languageCodes.length)];
};
var uriString = function () { return someUrl(); };
var webUrlString = function () { return someUrl(); };
var currencyString = function () {
    var currenciesArray = [
        'AFN',
        'EUR',
        'ALL',
        'DZD',
        'USD',
        'EUR',
        'AOA',
        'XCD',
        'XCD',
        'ARS',
        'AMD',
        'AWG',
        'AUD',
        'EUR',
        'AZN',
        'BSD',
        'BHD',
        'BDT',
        'BBD',
        'BYN',
        'EUR',
        'BZD',
        'XOF',
        'BMD',
        'INR',
        'BTN',
        'BOB',
        'BOV',
        'USD',
        'BAM',
        'BWP',
        'NOK',
        'BRL',
        'USD',
        'BND',
        'BGN',
        'XOF',
        'BIF',
        'CVE',
        'KHR',
        'XAF',
        'CAD',
        'KYD',
        'XAF',
        'XAF',
        'CLP',
        'CLF',
        'CNY',
        'AUD',
        'AUD',
        'COP',
        'COU',
        'KMF',
        'CDF',
        'XAF',
        'NZD',
        'CRC',
        'XOF',
        'HRK',
        'CUP',
        'CUC',
        'ANG',
        'EUR',
        'CZK',
        'DKK',
        'DJF',
        'XCD',
        'DOP',
        'USD',
        'EGP',
        'SVC',
        'USD',
        'XAF',
        'ERN',
        'EUR',
        'ETB',
        'EUR',
        'FKP',
        'DKK',
        'FJD',
        'EUR',
        'EUR',
        'EUR',
        'XPF',
        'EUR',
        'XAF',
        'GMD',
        'GEL',
        'EUR',
        'GHS',
        'GIP',
        'EUR',
        'DKK',
        'XCD',
        'EUR',
        'USD',
        'GTQ',
        'GBP',
        'GNF',
        'XOF',
        'GYD',
        'HTG',
        'USD',
        'AUD',
        'EUR',
        'HNL',
        'HKD',
        'HUF',
        'ISK',
        'INR',
        'IDR',
        'XDR',
    ];
    return currenciesArray[Math.floor(Math.random() * currenciesArray.length)];
};
var decimalValueString = function () { return randomNumber(0, 100000); };
var colorHexString = function () { return '#' + randomHexString(6).toUpperCase(); };
var randomHexString = function (length) {
    return new Array(length)
        .fill(null)
        .map(function () { return 'abcdef0123456789'[Math.floor(Math.random() * 16)]; })
        .join('');
};
var randomInt = function (min, max) { return Math.floor(Math.random() * (max - min)) + min; };
var randomNumber = function (min, max) { return Math.random() * (max - min) + min; };
var boundedManyOf = function (min, max, valueGenerator) { return new Array(randomInt(min, max)).fill(null).map(function () { return valueGenerator(); }); };
var boundedDecimalString = function (min, gt, max, lt, scale) {
    var rand = randomNumber(min, max).toFixed(scale);
    if (gt || lt) {
        if (rand === min.toFixed(scale) || rand === max.toFixed(scale))
            return randomNumber(min, max).toFixed(scale);
    }
    return rand;
};
exports.defaultMaxArraySize = 3;
exports.defaultMinArraySize = 0;
exports.builderConfig = {
    maxArraySize: exports.defaultMaxArraySize,
    minArraySize: exports.defaultMinArraySize,
};
function resetBuilderConfig() {
    exports.builderConfig.maxArraySize = readConfig('maxArraySize') || exports.defaultMaxArraySize;
    exports.builderConfig.minArraySize = readConfig('minArraySize') || exports.defaultMinArraySize;
}
exports.resetBuilderConfig = resetBuilderConfig;
resetBuilderConfig();
var createDefaultBuildInput = function () { return ({ buildersVisited: {} }); };
var increaseVisit = function (_a) {
    var caseClassName = _a.caseClassName, buildersVisited = _a.buildersVisited;
    // When we recursive building entities, we don't mind that more builders of that kind will be built in our layer (for ex: if some want's an array of that entity).
    // Therefore I change the reference of visitedMap (clone), and only layers beneath this builder will stop if we stuck in a circle.
    // We allow 2 vists in the same node. any deeper building will need manual handling.
    buildersVisited = Object.assign({}, buildersVisited);
    if (!buildersVisited[caseClassName]) {
        buildersVisited[caseClassName] = 1;
    }
    else {
        buildersVisited[caseClassName]++;
    }
    if (buildersVisited[caseClassName] > 2) {
        buildersVisited._isDone = true;
    }
    return buildersVisited;
};
var AllCurrenciesFormattingRequestDTOBuilder = /** @class */ (function () {
    function AllCurrenciesFormattingRequestDTOBuilder() {
        this._countryCode = UnassignedValue;
        this._languageCode = UnassignedValue;
    }
    AllCurrenciesFormattingRequestDTOBuilder.prototype.withCountryCode = function (_countryCode) {
        this._countryCode = _countryCode;
        return this;
    };
    AllCurrenciesFormattingRequestDTOBuilder.prototype.withLanguageCode = function (_languageCode) {
        this._languageCode = _languageCode;
        return this;
    };
    AllCurrenciesFormattingRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'AllCurrenciesFormattingRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            countryCode: this._countryCode !== UnassignedValue ? this._countryCode : someString(),
            languageCode: this._languageCode !== UnassignedValue ? this._languageCode : someString(),
        };
    };
    return AllCurrenciesFormattingRequestDTOBuilder;
}());
exports.AllCurrenciesFormattingRequestDTOBuilder = AllCurrenciesFormattingRequestDTOBuilder;
var AllCurrenciesFormattingResponseDTOBuilder = /** @class */ (function () {
    function AllCurrenciesFormattingResponseDTOBuilder() {
        this._currencyFormattingBulkResult = UnassignedValue;
    }
    AllCurrenciesFormattingResponseDTOBuilder.prototype.withCurrencyFormattingBulkResult = function (_currencyFormattingBulkResult) {
        this._currencyFormattingBulkResult = _currencyFormattingBulkResult;
        return this;
    };
    AllCurrenciesFormattingResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'AllCurrenciesFormattingResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currencyFormattingBulkResult: this._currencyFormattingBulkResult !== UnassignedValue ? this._currencyFormattingBulkResult : manyOf(function () { return exports.aCurrencyFormattingKeyValue().build({ buildersVisited: buildersVisited }); }),
        };
    };
    return AllCurrenciesFormattingResponseDTOBuilder;
}());
exports.AllCurrenciesFormattingResponseDTOBuilder = AllCurrenciesFormattingResponseDTOBuilder;
var AllowedActionsDTOBuilder = /** @class */ (function () {
    function AllowedActionsDTOBuilder() {
        this._changeCycle = UnassignedValue;
    }
    AllowedActionsDTOBuilder.prototype.withChangeCycle = function (_changeCycle) {
        this._changeCycle = _changeCycle;
        return this;
    };
    AllowedActionsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'AllowedActions', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            changeCycle: this._changeCycle !== UnassignedValue ? this._changeCycle : maybe(someBoolean()),
        };
    };
    return AllowedActionsDTOBuilder;
}());
exports.AllowedActionsDTOBuilder = AllowedActionsDTOBuilder;
var AmountsDTOBuilder = /** @class */ (function () {
    function AmountsDTOBuilder() {
        this._beforeTaxAmount = UnassignedValue;
        this._creditAmount = UnassignedValue;
        this._discountAmount = UnassignedValue;
        this._maxPossibleTotalAmount = UnassignedValue;
        this._subTotalAmount = UnassignedValue;
        this._taxAmounts = UnassignedValue;
        this._totalAmount = UnassignedValue;
        this._totalAmountWithoutDiscount = UnassignedValue;
        this._totalTaxAmount = UnassignedValue;
    }
    AmountsDTOBuilder.prototype.withSubTotalAmount = function (_subTotalAmount) {
        this._subTotalAmount = _subTotalAmount;
        return this;
    };
    AmountsDTOBuilder.prototype.withCreditAmount = function (_creditAmount) {
        this._creditAmount = _creditAmount;
        return this;
    };
    AmountsDTOBuilder.prototype.withDiscountAmount = function (_discountAmount) {
        this._discountAmount = _discountAmount;
        return this;
    };
    AmountsDTOBuilder.prototype.withBeforeTaxAmount = function (_beforeTaxAmount) {
        this._beforeTaxAmount = _beforeTaxAmount;
        return this;
    };
    AmountsDTOBuilder.prototype.withTaxAmounts = function (_taxAmounts) {
        this._taxAmounts = _taxAmounts;
        return this;
    };
    AmountsDTOBuilder.prototype.withTotalAmount = function (_totalAmount) {
        this._totalAmount = _totalAmount;
        return this;
    };
    AmountsDTOBuilder.prototype.withTotalTaxAmount = function (_totalTaxAmount) {
        this._totalTaxAmount = _totalTaxAmount;
        return this;
    };
    AmountsDTOBuilder.prototype.withTotalAmountWithoutDiscount = function (_totalAmountWithoutDiscount) {
        this._totalAmountWithoutDiscount = _totalAmountWithoutDiscount;
        return this;
    };
    AmountsDTOBuilder.prototype.withMaxPossibleTotalAmount = function (_maxPossibleTotalAmount) {
        this._maxPossibleTotalAmount = _maxPossibleTotalAmount;
        return this;
    };
    AmountsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Amounts', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            beforeTaxAmount: this._beforeTaxAmount !== UnassignedValue ? this._beforeTaxAmount : maybe(someInt()),
            creditAmount: this._creditAmount !== UnassignedValue ? this._creditAmount : maybe(someInt()),
            discountAmount: this._discountAmount !== UnassignedValue ? this._discountAmount : maybe(someInt()),
            maxPossibleTotalAmount: this._maxPossibleTotalAmount !== UnassignedValue ? this._maxPossibleTotalAmount : maybe(someInt()),
            subTotalAmount: this._subTotalAmount !== UnassignedValue ? this._subTotalAmount : maybe(someInt()),
            taxAmounts: this._taxAmounts !== UnassignedValue ? this._taxAmounts : maybe(manyOf(function () { return exports.aTaxAmount().build({ buildersVisited: buildersVisited }); })),
            totalAmount: this._totalAmount !== UnassignedValue ? this._totalAmount : maybe(someInt()),
            totalAmountWithoutDiscount: this._totalAmountWithoutDiscount !== UnassignedValue ? this._totalAmountWithoutDiscount : maybe(someInt()),
            totalTaxAmount: this._totalTaxAmount !== UnassignedValue ? this._totalTaxAmount : maybe(someInt()),
        };
    };
    return AmountsDTOBuilder;
}());
exports.AmountsDTOBuilder = AmountsDTOBuilder;
var ApiV1CycleDTOBuilder = /** @class */ (function () {
    function ApiV1CycleDTOBuilder() {
        this._interval = UnassignedValue;
        this._oneTime = UnassignedValue;
    }
    ApiV1CycleDTOBuilder.prototype.withInterval = function (_interval) {
        this._interval = _interval;
        this._oneTime = UnassignedValue;
        return this;
    };
    ApiV1CycleDTOBuilder.prototype.withOneTime = function (_oneTime) {
        this._oneTime = _oneTime;
        this._interval = UnassignedValue;
        return this;
    };
    ApiV1CycleDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ApiV1Cycle', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._interval === UnassignedValue && this._oneTime === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['interval', 'oneTime'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 2), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                interval: assignRandomOneOf('interval', maybe(exports.anInterval().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                oneTime: assignRandomOneOf('oneTime', maybe(exports.anOneTime().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            interval: this._interval === UnassignedValue ? undefined : this._interval,
            oneTime: this._oneTime === UnassignedValue ? undefined : this._oneTime,
        };
    };
    return ApiV1CycleDTOBuilder;
}());
exports.ApiV1CycleDTOBuilder = ApiV1CycleDTOBuilder;
var ApplicationPricesDTOBuilder = /** @class */ (function () {
    function ApplicationPricesDTOBuilder() {
        this._appDefinitionId = UnassignedValue;
        this._vendorProductPrices = UnassignedValue;
    }
    ApplicationPricesDTOBuilder.prototype.withAppDefinitionId = function (_appDefinitionId) {
        this._appDefinitionId = _appDefinitionId;
        return this;
    };
    ApplicationPricesDTOBuilder.prototype.withVendorProductPrices = function (_vendorProductPrices) {
        this._vendorProductPrices = _vendorProductPrices;
        return this;
    };
    ApplicationPricesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ApplicationPrices', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            appDefinitionId: this._appDefinitionId !== UnassignedValue ? this._appDefinitionId : maybe(someString()),
            vendorProductPrices: this._vendorProductPrices !== UnassignedValue ? this._vendorProductPrices : maybe(manyOf(function () { return exports.aVendorProductPrices().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ApplicationPricesDTOBuilder;
}());
exports.ApplicationPricesDTOBuilder = ApplicationPricesDTOBuilder;
var BillingAddressDTOBuilder = /** @class */ (function () {
    function BillingAddressDTOBuilder() {
        this._city = UnassignedValue;
        this._country = UnassignedValue;
        this._postalCode = UnassignedValue;
        this._streetAddress = UnassignedValue;
        this._subdivision = UnassignedValue;
    }
    BillingAddressDTOBuilder.prototype.withCountry = function (_country) {
        this._country = _country;
        return this;
    };
    BillingAddressDTOBuilder.prototype.withSubdivision = function (_subdivision) {
        this._subdivision = _subdivision;
        return this;
    };
    BillingAddressDTOBuilder.prototype.withCity = function (_city) {
        this._city = _city;
        return this;
    };
    BillingAddressDTOBuilder.prototype.withPostalCode = function (_postalCode) {
        this._postalCode = _postalCode;
        return this;
    };
    BillingAddressDTOBuilder.prototype.withStreetAddress = function (_streetAddress) {
        this._streetAddress = _streetAddress;
        return this;
    };
    BillingAddressDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BillingAddress', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            city: this._city !== UnassignedValue ? this._city : maybe(someString()),
            country: this._country !== UnassignedValue ? this._country : maybe(countryString()),
            postalCode: this._postalCode !== UnassignedValue ? this._postalCode : maybe(someString()),
            streetAddress: this._streetAddress !== UnassignedValue ? this._streetAddress : maybe(exports.aStreetAddress().build({ buildersVisited: buildersVisited })),
            subdivision: this._subdivision !== UnassignedValue ? this._subdivision : maybe(someString()),
        };
    };
    return BillingAddressDTOBuilder;
}());
exports.BillingAddressDTOBuilder = BillingAddressDTOBuilder;
var BillingCycleDTOBuilder = /** @class */ (function () {
    function BillingCycleDTOBuilder() {
    }
    BillingCycleDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.BillingCycle.ONE_TIME,
            types_1.BillingCycle.DAILY,
            types_1.BillingCycle.WEEKLY,
            types_1.BillingCycle.MONTHLY,
            types_1.BillingCycle.QUARTERLY,
            types_1.BillingCycle.SEMI_ANNUALLY,
            types_1.BillingCycle.YEARLY,
            types_1.BillingCycle.TWO_YEARS,
            types_1.BillingCycle.THREE_YEARS,
            types_1.BillingCycle.FOUR_YEARS,
            types_1.BillingCycle.FIVE_YEARS,
            types_1.BillingCycle.SIX_YEARS,
            types_1.BillingCycle.SEVEN_YEARS,
            types_1.BillingCycle.EIGHT_YEARS,
            types_1.BillingCycle.NINE_YEARS,
            types_1.BillingCycle.TEN_YEARS,
        ]);
    };
    return BillingCycleDTOBuilder;
}());
exports.BillingCycleDTOBuilder = BillingCycleDTOBuilder;
var BillingReferenceDTOBuilder = /** @class */ (function () {
    function BillingReferenceDTOBuilder() {
        this._previousProviderReferenceIds = UnassignedValue;
        this._providerName = UnassignedValue;
        this._providerReferenceId = UnassignedValue;
        this._unknownFields = UnassignedValue;
    }
    BillingReferenceDTOBuilder.prototype.withUnknownFields = function (_unknownFields) {
        this._unknownFields = _unknownFields;
        return this;
    };
    BillingReferenceDTOBuilder.prototype.withPreviousProviderReferenceIds = function (_previousProviderReferenceIds) {
        this._previousProviderReferenceIds = _previousProviderReferenceIds;
        return this;
    };
    BillingReferenceDTOBuilder.prototype.withProviderReferenceId = function (_providerReferenceId) {
        this._providerReferenceId = _providerReferenceId;
        return this;
    };
    BillingReferenceDTOBuilder.prototype.withProviderName = function (_providerName) {
        this._providerName = _providerName;
        return this;
    };
    BillingReferenceDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BillingReference', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            previousProviderReferenceIds: this._previousProviderReferenceIds !== UnassignedValue ? this._previousProviderReferenceIds : manyOf(function () { return someString(); }),
            providerName: this._providerName !== UnassignedValue ? this._providerName : createNull(),
            providerReferenceId: this._providerReferenceId !== UnassignedValue ? this._providerReferenceId : maybe(someString()),
            unknownFields: this._unknownFields !== UnassignedValue ? this._unknownFields : exports.anUnknownFieldSet().build({ buildersVisited: buildersVisited }),
        };
    };
    return BillingReferenceDTOBuilder;
}());
exports.BillingReferenceDTOBuilder = BillingReferenceDTOBuilder;
var BoSbsCatalogProductDTOBuilder = /** @class */ (function () {
    function BoSbsCatalogProductDTOBuilder() {
        this._cyclePrices = UnassignedValue;
        this._id = UnassignedValue;
    }
    BoSbsCatalogProductDTOBuilder.prototype.withCyclePrices = function (_cyclePrices) {
        this._cyclePrices = _cyclePrices;
        return this;
    };
    BoSbsCatalogProductDTOBuilder.prototype.withId = function (_id) {
        this._id = _id;
        return this;
    };
    BoSbsCatalogProductDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BoSbsCatalogProduct', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            cyclePrices: this._cyclePrices !== UnassignedValue ? this._cyclePrices : jsonMapOf(function () { return someNumber(); }),
            id: this._id !== UnassignedValue ? this._id : someGuid(),
        };
    };
    return BoSbsCatalogProductDTOBuilder;
}());
exports.BoSbsCatalogProductDTOBuilder = BoSbsCatalogProductDTOBuilder;
var BooleanFeatureDTOBuilder = /** @class */ (function () {
    function BooleanFeatureDTOBuilder() {
    }
    BooleanFeatureDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'BooleanFeature', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return BooleanFeatureDTOBuilder;
}());
exports.BooleanFeatureDTOBuilder = BooleanFeatureDTOBuilder;
var CancelRequestDTOBuilder = /** @class */ (function () {
    function CancelRequestDTOBuilder() {
        this._subscriptionId = UnassignedValue;
    }
    CancelRequestDTOBuilder.prototype.withSubscriptionId = function (_subscriptionId) {
        this._subscriptionId = _subscriptionId;
        return this;
    };
    CancelRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CancelRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            subscriptionId: this._subscriptionId !== UnassignedValue ? this._subscriptionId : maybe(someGuid()),
        };
    };
    return CancelRequestDTOBuilder;
}());
exports.CancelRequestDTOBuilder = CancelRequestDTOBuilder;
var CancelResponseDTOBuilder = /** @class */ (function () {
    function CancelResponseDTOBuilder() {
    }
    CancelResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CancelResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return CancelResponseDTOBuilder;
}());
exports.CancelResponseDTOBuilder = CancelResponseDTOBuilder;
var CandidateSubscriptionDTOBuilder = /** @class */ (function () {
    function CandidateSubscriptionDTOBuilder() {
        this._active = UnassignedValue;
        this._billingReference = UnassignedValue;
        this._cycle = UnassignedValue;
        this._metaSiteId = UnassignedValue;
        this._subscriptionId = UnassignedValue;
        this._userId = UnassignedValue;
    }
    CandidateSubscriptionDTOBuilder.prototype.withBillingReference = function (_billingReference) {
        this._billingReference = _billingReference;
        return this;
    };
    CandidateSubscriptionDTOBuilder.prototype.withSubscriptionId = function (_subscriptionId) {
        this._subscriptionId = _subscriptionId;
        return this;
    };
    CandidateSubscriptionDTOBuilder.prototype.withCycle = function (_cycle) {
        this._cycle = _cycle;
        return this;
    };
    CandidateSubscriptionDTOBuilder.prototype.withUserId = function (_userId) {
        this._userId = _userId;
        return this;
    };
    CandidateSubscriptionDTOBuilder.prototype.withActive = function (_active) {
        this._active = _active;
        return this;
    };
    CandidateSubscriptionDTOBuilder.prototype.withMetaSiteId = function (_metaSiteId) {
        this._metaSiteId = _metaSiteId;
        return this;
    };
    CandidateSubscriptionDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CandidateSubscription', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            active: this._active !== UnassignedValue ? this._active : someBoolean(),
            billingReference: this._billingReference !== UnassignedValue ? this._billingReference : maybe(exports.aBillingReference().build({ buildersVisited: buildersVisited })),
            cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            metaSiteId: this._metaSiteId !== UnassignedValue ? this._metaSiteId : maybe(someString()),
            subscriptionId: this._subscriptionId !== UnassignedValue ? this._subscriptionId : someString(),
            userId: this._userId !== UnassignedValue ? this._userId : someString(),
        };
    };
    return CandidateSubscriptionDTOBuilder;
}());
exports.CandidateSubscriptionDTOBuilder = CandidateSubscriptionDTOBuilder;
var CatalogReferenceDTOBuilder = /** @class */ (function () {
    function CatalogReferenceDTOBuilder() {
        this._catalogId = UnassignedValue;
        this._catalogItemId = UnassignedValue;
        this._metadata = UnassignedValue;
    }
    CatalogReferenceDTOBuilder.prototype.withCatalogItemId = function (_catalogItemId) {
        this._catalogItemId = _catalogItemId;
        return this;
    };
    CatalogReferenceDTOBuilder.prototype.withCatalogId = function (_catalogId) {
        this._catalogId = _catalogId;
        return this;
    };
    CatalogReferenceDTOBuilder.prototype.withMetadata = function (_metadata) {
        this._metadata = _metadata;
        return this;
    };
    CatalogReferenceDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CatalogReference', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            catalogId: this._catalogId !== UnassignedValue ? this._catalogId : maybe(boundedString(1, 32)),
            catalogItemId: this._catalogItemId !== UnassignedValue ? this._catalogItemId : maybe(boundedString(1, 32)),
            metadata: this._metadata !== UnassignedValue ? this._metadata : maybe(jsonMapOf(function () { return createNull(); })),
        };
    };
    return CatalogReferenceDTOBuilder;
}());
exports.CatalogReferenceDTOBuilder = CatalogReferenceDTOBuilder;
var CommonV1CycleDTOBuilder = /** @class */ (function () {
    function CommonV1CycleDTOBuilder() {
        this._cycleDuration = UnassignedValue;
        this._cycleType = UnassignedValue;
    }
    CommonV1CycleDTOBuilder.prototype.withCycleType = function (_cycleType) {
        this._cycleType = _cycleType;
        return this;
    };
    CommonV1CycleDTOBuilder.prototype.withCycleDuration = function (_cycleDuration) {
        this._cycleDuration = _cycleDuration;
        return this;
    };
    CommonV1CycleDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CommonV1Cycle', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            cycleDuration: this._cycleDuration !== UnassignedValue ? this._cycleDuration : maybe(exports.aDuration().build({ buildersVisited: buildersVisited })),
            cycleType: this._cycleType !== UnassignedValue ? this._cycleType : maybe(exports.aCycleType().build({ buildersVisited: buildersVisited })),
        };
    };
    return CommonV1CycleDTOBuilder;
}());
exports.CommonV1CycleDTOBuilder = CommonV1CycleDTOBuilder;
var ContractSwitchTypeDTOBuilder = /** @class */ (function () {
    function ContractSwitchTypeDTOBuilder() {
    }
    ContractSwitchTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.ContractSwitchType.UNKNOWN,
            types_1.ContractSwitchType.CREDIT_UNUSED_PERIOD,
            types_1.ContractSwitchType.EXTEND,
            types_1.ContractSwitchType.FULL_AMOUNT_PERIOD,
            types_1.ContractSwitchType.DOWNGRADE_RENEWAL,
        ]);
    };
    return ContractSwitchTypeDTOBuilder;
}());
exports.ContractSwitchTypeDTOBuilder = ContractSwitchTypeDTOBuilder;
var CouponDTOBuilder = /** @class */ (function () {
    function CouponDTOBuilder() {
        this._couponDisplayName = UnassignedValue;
        this._couponId = UnassignedValue;
    }
    CouponDTOBuilder.prototype.withCouponId = function (_couponId) {
        this._couponId = _couponId;
        return this;
    };
    CouponDTOBuilder.prototype.withCouponDisplayName = function (_couponDisplayName) {
        this._couponDisplayName = _couponDisplayName;
        return this;
    };
    CouponDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Coupon', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            couponDisplayName: this._couponDisplayName !== UnassignedValue ? this._couponDisplayName : maybe(someString()),
            couponId: this._couponId !== UnassignedValue ? this._couponId : maybe(someGuid()),
        };
    };
    return CouponDTOBuilder;
}());
exports.CouponDTOBuilder = CouponDTOBuilder;
var CouponInfoDTOBuilder = /** @class */ (function () {
    function CouponInfoDTOBuilder() {
        this._id = UnassignedValue;
    }
    CouponInfoDTOBuilder.prototype.withId = function (_id) {
        this._id = _id;
        return this;
    };
    CouponInfoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CouponInfo', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            id: this._id !== UnassignedValue ? this._id : maybe(someString()),
        };
    };
    return CouponInfoDTOBuilder;
}());
exports.CouponInfoDTOBuilder = CouponInfoDTOBuilder;
var CouponPricingDTOBuilder = /** @class */ (function () {
    function CouponPricingDTOBuilder() {
        this._couponInfo = UnassignedValue;
        this._discountPrices = UnassignedValue;
    }
    CouponPricingDTOBuilder.prototype.withCouponInfo = function (_couponInfo) {
        this._couponInfo = _couponInfo;
        return this;
    };
    CouponPricingDTOBuilder.prototype.withDiscountPrices = function (_discountPrices) {
        this._discountPrices = _discountPrices;
        return this;
    };
    CouponPricingDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CouponPricing', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            couponInfo: this._couponInfo !== UnassignedValue ? this._couponInfo : maybe(exports.aCouponInfo().build({ buildersVisited: buildersVisited })),
            discountPrices: this._discountPrices !== UnassignedValue ? this._discountPrices : maybe(manyOf(function () { return exports.aCyclePricing().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return CouponPricingDTOBuilder;
}());
exports.CouponPricingDTOBuilder = CouponPricingDTOBuilder;
var CouponsTypeEligibilityDTOBuilder = /** @class */ (function () {
    function CouponsTypeEligibilityDTOBuilder() {
        this._couponsNames = UnassignedValue;
    }
    CouponsTypeEligibilityDTOBuilder.prototype.withCouponsNames = function (_couponsNames) {
        this._couponsNames = _couponsNames;
        return this;
    };
    CouponsTypeEligibilityDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CouponsTypeEligibility', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            couponsNames: this._couponsNames !== UnassignedValue ? this._couponsNames : maybe(manyOf(function () { return someString(); })),
        };
    };
    return CouponsTypeEligibilityDTOBuilder;
}());
exports.CouponsTypeEligibilityDTOBuilder = CouponsTypeEligibilityDTOBuilder;
var CreateOrderPageRequestDTOBuilder = /** @class */ (function () {
    function CreateOrderPageRequestDTOBuilder() {
        this._cartItems = UnassignedValue;
        this._eventAggregator = UnassignedValue;
        this._purchaseFlowId = UnassignedValue;
    }
    CreateOrderPageRequestDTOBuilder.prototype.withCartItems = function (_cartItems) {
        this._cartItems = _cartItems;
        return this;
    };
    CreateOrderPageRequestDTOBuilder.prototype.withPurchaseFlowId = function (_purchaseFlowId) {
        this._purchaseFlowId = _purchaseFlowId;
        return this;
    };
    CreateOrderPageRequestDTOBuilder.prototype.withEventAggregator = function (_eventAggregator) {
        this._eventAggregator = _eventAggregator;
        return this;
    };
    CreateOrderPageRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CreateOrderPageRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            cartItems: this._cartItems !== UnassignedValue ? this._cartItems : maybe(manyOf(function () { return exports.aLineItem().build({ buildersVisited: buildersVisited }); })),
            eventAggregator: this._eventAggregator !== UnassignedValue ? this._eventAggregator : maybe(someString()),
            purchaseFlowId: this._purchaseFlowId !== UnassignedValue ? this._purchaseFlowId : maybe(someGuid()),
        };
    };
    return CreateOrderPageRequestDTOBuilder;
}());
exports.CreateOrderPageRequestDTOBuilder = CreateOrderPageRequestDTOBuilder;
var CreateOrderPageResponseDTOBuilder = /** @class */ (function () {
    function CreateOrderPageResponseDTOBuilder() {
        this._eventAggregator = UnassignedValue;
        this._orderSessionId = UnassignedValue;
        this._riskIframeUrl = UnassignedValue;
    }
    CreateOrderPageResponseDTOBuilder.prototype.withOrderSessionId = function (_orderSessionId) {
        this._orderSessionId = _orderSessionId;
        return this;
    };
    CreateOrderPageResponseDTOBuilder.prototype.withRiskIframeUrl = function (_riskIframeUrl) {
        this._riskIframeUrl = _riskIframeUrl;
        return this;
    };
    CreateOrderPageResponseDTOBuilder.prototype.withEventAggregator = function (_eventAggregator) {
        this._eventAggregator = _eventAggregator;
        return this;
    };
    CreateOrderPageResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CreateOrderPageResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            eventAggregator: this._eventAggregator !== UnassignedValue ? this._eventAggregator : maybe(someString()),
            orderSessionId: this._orderSessionId !== UnassignedValue ? this._orderSessionId : maybe(someString()),
            riskIframeUrl: this._riskIframeUrl !== UnassignedValue ? this._riskIframeUrl : maybe(someString()),
        };
    };
    return CreateOrderPageResponseDTOBuilder;
}());
exports.CreateOrderPageResponseDTOBuilder = CreateOrderPageResponseDTOBuilder;
var CreateWixCheckoutRequestDTOBuilder = /** @class */ (function () {
    function CreateWixCheckoutRequestDTOBuilder() {
        this._displayProperties = UnassignedValue;
        this._metaSiteId = UnassignedValue;
        this._purchaseDetails = UnassignedValue;
        this._supportedPaymentTypes = UnassignedValue;
        this._useSiteLevelCoupons = UnassignedValue;
    }
    CreateWixCheckoutRequestDTOBuilder.prototype.withMetaSiteId = function (_metaSiteId) {
        this._metaSiteId = _metaSiteId;
        return this;
    };
    CreateWixCheckoutRequestDTOBuilder.prototype.withPurchaseDetails = function (_purchaseDetails) {
        this._purchaseDetails = _purchaseDetails;
        return this;
    };
    CreateWixCheckoutRequestDTOBuilder.prototype.withDisplayProperties = function (_displayProperties) {
        this._displayProperties = _displayProperties;
        return this;
    };
    CreateWixCheckoutRequestDTOBuilder.prototype.withUseSiteLevelCoupons = function (_useSiteLevelCoupons) {
        this._useSiteLevelCoupons = _useSiteLevelCoupons;
        return this;
    };
    CreateWixCheckoutRequestDTOBuilder.prototype.withSupportedPaymentTypes = function (_supportedPaymentTypes) {
        this._supportedPaymentTypes = _supportedPaymentTypes;
        return this;
    };
    CreateWixCheckoutRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CreateWixCheckoutRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            displayProperties: this._displayProperties !== UnassignedValue ? this._displayProperties : maybe(exports.aPurchaseDisplayProperties().build({ buildersVisited: buildersVisited })),
            metaSiteId: this._metaSiteId !== UnassignedValue ? this._metaSiteId : maybe(someGuid()),
            purchaseDetails: this._purchaseDetails !== UnassignedValue ? this._purchaseDetails : maybe(exports.aPurchaseDetails().build({ buildersVisited: buildersVisited })),
            supportedPaymentTypes: this._supportedPaymentTypes !== UnassignedValue ? this._supportedPaymentTypes : maybe(exports.aSupportedPaymentTypesFilter().build({ buildersVisited: buildersVisited })),
            useSiteLevelCoupons: this._useSiteLevelCoupons !== UnassignedValue ? this._useSiteLevelCoupons : maybe(someBoolean()),
        };
    };
    return CreateWixCheckoutRequestDTOBuilder;
}());
exports.CreateWixCheckoutRequestDTOBuilder = CreateWixCheckoutRequestDTOBuilder;
var CreateWixCheckoutResponseDTOBuilder = /** @class */ (function () {
    function CreateWixCheckoutResponseDTOBuilder() {
        this._checkoutComponentsSupported = UnassignedValue;
        this._orderPageCreationParamsToken = UnassignedValue;
        this._token = UnassignedValue;
        this._url = UnassignedValue;
    }
    CreateWixCheckoutResponseDTOBuilder.prototype.withToken = function (_token) {
        this._token = _token;
        return this;
    };
    CreateWixCheckoutResponseDTOBuilder.prototype.withUrl = function (_url) {
        this._url = _url;
        return this;
    };
    CreateWixCheckoutResponseDTOBuilder.prototype.withOrderPageCreationParamsToken = function (_orderPageCreationParamsToken) {
        this._orderPageCreationParamsToken = _orderPageCreationParamsToken;
        return this;
    };
    CreateWixCheckoutResponseDTOBuilder.prototype.withCheckoutComponentsSupported = function (_checkoutComponentsSupported) {
        this._checkoutComponentsSupported = _checkoutComponentsSupported;
        return this;
    };
    CreateWixCheckoutResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CreateWixCheckoutResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            checkoutComponentsSupported: this._checkoutComponentsSupported !== UnassignedValue ? this._checkoutComponentsSupported : maybe(someBoolean()),
            orderPageCreationParamsToken: this._orderPageCreationParamsToken !== UnassignedValue ? this._orderPageCreationParamsToken : maybe(someString()),
            token: this._token !== UnassignedValue ? this._token : maybe(someString()),
            url: this._url !== UnassignedValue ? this._url : maybe(webUrlString()),
        };
    };
    return CreateWixCheckoutResponseDTOBuilder;
}());
exports.CreateWixCheckoutResponseDTOBuilder = CreateWixCheckoutResponseDTOBuilder;
var CurrencyCodeDTOBuilder = /** @class */ (function () {
    function CurrencyCodeDTOBuilder() {
    }
    CurrencyCodeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.CurrencyCode.AED,
            types_1.CurrencyCode.AFN,
            types_1.CurrencyCode.ALL,
            types_1.CurrencyCode.AMD,
            types_1.CurrencyCode.ANG,
            types_1.CurrencyCode.ARS,
            types_1.CurrencyCode.AUD,
            types_1.CurrencyCode.AWG,
            types_1.CurrencyCode.AZN,
            types_1.CurrencyCode.BAM,
            types_1.CurrencyCode.BBD,
            types_1.CurrencyCode.BDT,
            types_1.CurrencyCode.BEF,
            types_1.CurrencyCode.BGL,
            types_1.CurrencyCode.BGN,
            types_1.CurrencyCode.BHD,
            types_1.CurrencyCode.BIF,
            types_1.CurrencyCode.BMD,
            types_1.CurrencyCode.BND,
            types_1.CurrencyCode.BOB,
            types_1.CurrencyCode.BRL,
            types_1.CurrencyCode.BSD,
            types_1.CurrencyCode.BWP,
            types_1.CurrencyCode.BYR,
            types_1.CurrencyCode.BZD,
            types_1.CurrencyCode.CAD,
            types_1.CurrencyCode.CDF,
            types_1.CurrencyCode.CHF,
            types_1.CurrencyCode.CLP,
            types_1.CurrencyCode.CNY,
            types_1.CurrencyCode.COP,
            types_1.CurrencyCode.CRC,
            types_1.CurrencyCode.CUP,
            types_1.CurrencyCode.CVE,
            types_1.CurrencyCode.CYP,
            types_1.CurrencyCode.CZK,
            types_1.CurrencyCode.DJF,
            types_1.CurrencyCode.DKK,
            types_1.CurrencyCode.DOP,
            types_1.CurrencyCode.DZD,
            types_1.CurrencyCode.EEK,
            types_1.CurrencyCode.EGP,
            types_1.CurrencyCode.ERN,
            types_1.CurrencyCode.ESP,
            types_1.CurrencyCode.ETB,
            types_1.CurrencyCode.EUR,
            types_1.CurrencyCode.FJD,
            types_1.CurrencyCode.FKP,
            types_1.CurrencyCode.FRF,
            types_1.CurrencyCode.GBP,
            types_1.CurrencyCode.GEL,
            types_1.CurrencyCode.GHC,
            types_1.CurrencyCode.GHS,
            types_1.CurrencyCode.GIP,
            types_1.CurrencyCode.GMD,
            types_1.CurrencyCode.GNF,
            types_1.CurrencyCode.GRD,
            types_1.CurrencyCode.GTQ,
            types_1.CurrencyCode.GYD,
            types_1.CurrencyCode.HKD,
            types_1.CurrencyCode.HNL,
            types_1.CurrencyCode.HRK,
            types_1.CurrencyCode.HTG,
            types_1.CurrencyCode.HUF,
            types_1.CurrencyCode.IDR,
            types_1.CurrencyCode.IEP,
            types_1.CurrencyCode.ILS,
            types_1.CurrencyCode.INR,
            types_1.CurrencyCode.IQD,
            types_1.CurrencyCode.IRR,
            types_1.CurrencyCode.ISK,
            types_1.CurrencyCode.ITL,
            types_1.CurrencyCode.JMD,
            types_1.CurrencyCode.JOD,
            types_1.CurrencyCode.JPY,
            types_1.CurrencyCode.KES,
            types_1.CurrencyCode.KGS,
            types_1.CurrencyCode.KHR,
            types_1.CurrencyCode.KMF,
            types_1.CurrencyCode.KPW,
            types_1.CurrencyCode.KRW,
            types_1.CurrencyCode.KWD,
            types_1.CurrencyCode.KYD,
            types_1.CurrencyCode.KZT,
            types_1.CurrencyCode.LAK,
            types_1.CurrencyCode.LBP,
            types_1.CurrencyCode.LKR,
            types_1.CurrencyCode.LRD,
            types_1.CurrencyCode.LSL,
            types_1.CurrencyCode.LTL,
            types_1.CurrencyCode.LUF,
            types_1.CurrencyCode.LVL,
            types_1.CurrencyCode.LYD,
            types_1.CurrencyCode.MAD,
            types_1.CurrencyCode.MDL,
            types_1.CurrencyCode.MGA,
            types_1.CurrencyCode.MKD,
            types_1.CurrencyCode.MMK,
            types_1.CurrencyCode.MNT,
            types_1.CurrencyCode.MOP,
            types_1.CurrencyCode.MRO,
            types_1.CurrencyCode.MTL,
            types_1.CurrencyCode.MUR,
            types_1.CurrencyCode.MVR,
            types_1.CurrencyCode.MWK,
            types_1.CurrencyCode.MXN,
            types_1.CurrencyCode.MYR,
            types_1.CurrencyCode.MZN,
            types_1.CurrencyCode.NAD,
            types_1.CurrencyCode.NGN,
            types_1.CurrencyCode.NIO,
            types_1.CurrencyCode.NLG,
            types_1.CurrencyCode.NOK,
            types_1.CurrencyCode.NPR,
            types_1.CurrencyCode.NZD,
            types_1.CurrencyCode.OMR,
            types_1.CurrencyCode.PAB,
            types_1.CurrencyCode.PEN,
            types_1.CurrencyCode.PGK,
            types_1.CurrencyCode.PHP,
            types_1.CurrencyCode.PKR,
            types_1.CurrencyCode.PLN,
            types_1.CurrencyCode.PYG,
            types_1.CurrencyCode.QAR,
            types_1.CurrencyCode.RON,
            types_1.CurrencyCode.RSD,
            types_1.CurrencyCode.RUB,
            types_1.CurrencyCode.RWF,
            types_1.CurrencyCode.SAR,
            types_1.CurrencyCode.SBD,
            types_1.CurrencyCode.SCR,
            types_1.CurrencyCode.SDG,
            types_1.CurrencyCode.SEK,
            types_1.CurrencyCode.SGD,
            types_1.CurrencyCode.SHP,
            types_1.CurrencyCode.SKK,
            types_1.CurrencyCode.SLL,
            types_1.CurrencyCode.SOS,
            types_1.CurrencyCode.SRD,
            types_1.CurrencyCode.STD,
            types_1.CurrencyCode.SVC,
            types_1.CurrencyCode.SYP,
            types_1.CurrencyCode.SZL,
            types_1.CurrencyCode.THB,
            types_1.CurrencyCode.TJS,
            types_1.CurrencyCode.TMT,
            types_1.CurrencyCode.TND,
            types_1.CurrencyCode.TOP,
            types_1.CurrencyCode.TRL,
            types_1.CurrencyCode.TRY,
            types_1.CurrencyCode.TTD,
            types_1.CurrencyCode.TWD,
            types_1.CurrencyCode.TZS,
            types_1.CurrencyCode.UAH,
            types_1.CurrencyCode.UGX,
            types_1.CurrencyCode.USD,
            types_1.CurrencyCode.UYU,
            types_1.CurrencyCode.UZS,
            types_1.CurrencyCode.VEB,
            types_1.CurrencyCode.VEF,
            types_1.CurrencyCode.VND,
            types_1.CurrencyCode.VUV,
            types_1.CurrencyCode.WST,
            types_1.CurrencyCode.XAF,
            types_1.CurrencyCode.XAG,
            types_1.CurrencyCode.XAU,
            types_1.CurrencyCode.XCD,
            types_1.CurrencyCode.XEU,
            types_1.CurrencyCode.XOF,
            types_1.CurrencyCode.XPD,
            types_1.CurrencyCode.XPF,
            types_1.CurrencyCode.XPT,
            types_1.CurrencyCode.YER,
            types_1.CurrencyCode.ZAR,
            types_1.CurrencyCode.ZMK,
            types_1.CurrencyCode.ZMW,
            types_1.CurrencyCode.ZWD,
            types_1.CurrencyCode.ZWL,
            types_1.CurrencyCode.BYN,
            types_1.CurrencyCode.AOA,
            types_1.CurrencyCode.MZM,
            types_1.CurrencyCode.TMM,
            types_1.CurrencyCode.ROL,
            types_1.CurrencyCode.BTN,
            types_1.CurrencyCode.MRU,
            types_1.CurrencyCode.VES,
            types_1.CurrencyCode.STN,
            types_1.CurrencyCode.RUR,
        ]);
    };
    return CurrencyCodeDTOBuilder;
}());
exports.CurrencyCodeDTOBuilder = CurrencyCodeDTOBuilder;
var CurrencyFormattingKeyDTOBuilder = /** @class */ (function () {
    function CurrencyFormattingKeyDTOBuilder() {
        this._countryCode = UnassignedValue;
        this._currencyCode = UnassignedValue;
        this._languageCode = UnassignedValue;
    }
    CurrencyFormattingKeyDTOBuilder.prototype.withCurrencyCode = function (_currencyCode) {
        this._currencyCode = _currencyCode;
        return this;
    };
    CurrencyFormattingKeyDTOBuilder.prototype.withLanguageCode = function (_languageCode) {
        this._languageCode = _languageCode;
        return this;
    };
    CurrencyFormattingKeyDTOBuilder.prototype.withCountryCode = function (_countryCode) {
        this._countryCode = _countryCode;
        return this;
    };
    CurrencyFormattingKeyDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CurrencyFormattingKey', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            countryCode: this._countryCode !== UnassignedValue ? this._countryCode : someString(),
            currencyCode: this._currencyCode !== UnassignedValue ? this._currencyCode : someString(),
            languageCode: this._languageCode !== UnassignedValue ? this._languageCode : someString(),
        };
    };
    return CurrencyFormattingKeyDTOBuilder;
}());
exports.CurrencyFormattingKeyDTOBuilder = CurrencyFormattingKeyDTOBuilder;
var CurrencyFormattingKeyValueDTOBuilder = /** @class */ (function () {
    function CurrencyFormattingKeyValueDTOBuilder() {
        this._key = UnassignedValue;
        this._value = UnassignedValue;
    }
    CurrencyFormattingKeyValueDTOBuilder.prototype.withValue = function (_value) {
        this._value = _value;
        return this;
    };
    CurrencyFormattingKeyValueDTOBuilder.prototype.withKey = function (_key) {
        this._key = _key;
        return this;
    };
    CurrencyFormattingKeyValueDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CurrencyFormattingKeyValue', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            key: this._key !== UnassignedValue ? this._key : exports.aCurrencyFormattingKey().build({ buildersVisited: buildersVisited }),
            value: this._value !== UnassignedValue ? this._value : exports.aPremiumCurrencySettings().build({ buildersVisited: buildersVisited }),
        };
    };
    return CurrencyFormattingKeyValueDTOBuilder;
}());
exports.CurrencyFormattingKeyValueDTOBuilder = CurrencyFormattingKeyValueDTOBuilder;
var CurrencySettingsDTOBuilder = /** @class */ (function () {
    function CurrencySettingsDTOBuilder() {
        this._code = UnassignedValue;
        this._decimalSeparator = UnassignedValue;
        this._groupSeparator = UnassignedValue;
        this._minorUnits = UnassignedValue;
        this._negativePrefix = UnassignedValue;
        this._negativeSuffix = UnassignedValue;
        this._positivePrefix = UnassignedValue;
        this._positiveSuffix = UnassignedValue;
        this._symbol = UnassignedValue;
    }
    CurrencySettingsDTOBuilder.prototype.withCode = function (_code) {
        this._code = _code;
        return this;
    };
    CurrencySettingsDTOBuilder.prototype.withSymbol = function (_symbol) {
        this._symbol = _symbol;
        return this;
    };
    CurrencySettingsDTOBuilder.prototype.withMinorUnits = function (_minorUnits) {
        this._minorUnits = _minorUnits;
        return this;
    };
    CurrencySettingsDTOBuilder.prototype.withDecimalSeparator = function (_decimalSeparator) {
        this._decimalSeparator = _decimalSeparator;
        return this;
    };
    CurrencySettingsDTOBuilder.prototype.withGroupSeparator = function (_groupSeparator) {
        this._groupSeparator = _groupSeparator;
        return this;
    };
    CurrencySettingsDTOBuilder.prototype.withPositivePrefix = function (_positivePrefix) {
        this._positivePrefix = _positivePrefix;
        return this;
    };
    CurrencySettingsDTOBuilder.prototype.withPositiveSuffix = function (_positiveSuffix) {
        this._positiveSuffix = _positiveSuffix;
        return this;
    };
    CurrencySettingsDTOBuilder.prototype.withNegativePrefix = function (_negativePrefix) {
        this._negativePrefix = _negativePrefix;
        return this;
    };
    CurrencySettingsDTOBuilder.prototype.withNegativeSuffix = function (_negativeSuffix) {
        this._negativeSuffix = _negativeSuffix;
        return this;
    };
    CurrencySettingsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CurrencySettings', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            code: this._code !== UnassignedValue ? this._code : maybe(someString()),
            decimalSeparator: this._decimalSeparator !== UnassignedValue ? this._decimalSeparator : maybe(someString()),
            groupSeparator: this._groupSeparator !== UnassignedValue ? this._groupSeparator : maybe(someString()),
            minorUnits: this._minorUnits !== UnassignedValue ? this._minorUnits : maybe(someInt()),
            negativePrefix: this._negativePrefix !== UnassignedValue ? this._negativePrefix : maybe(someString()),
            negativeSuffix: this._negativeSuffix !== UnassignedValue ? this._negativeSuffix : maybe(someString()),
            positivePrefix: this._positivePrefix !== UnassignedValue ? this._positivePrefix : maybe(someString()),
            positiveSuffix: this._positiveSuffix !== UnassignedValue ? this._positiveSuffix : maybe(someString()),
            symbol: this._symbol !== UnassignedValue ? this._symbol : maybe(someString()),
        };
    };
    return CurrencySettingsDTOBuilder;
}());
exports.CurrencySettingsDTOBuilder = CurrencySettingsDTOBuilder;
var CurrentSubscriptionInfoDTOBuilder = /** @class */ (function () {
    function CurrentSubscriptionInfoDTOBuilder() {
        this._availableCredit = UnassignedValue;
        this._cycle = UnassignedValue;
        this._freeTrialData = UnassignedValue;
        this._isBundled = UnassignedValue;
        this._monthlyPrice = UnassignedValue;
        this._periodEndDate = UnassignedValue;
        this._premiumCycle = UnassignedValue;
        this._productId = UnassignedValue;
        this._productName = UnassignedValue;
        this._subscriptionId = UnassignedValue;
    }
    CurrentSubscriptionInfoDTOBuilder.prototype.withSubscriptionId = function (_subscriptionId) {
        this._subscriptionId = _subscriptionId;
        return this;
    };
    CurrentSubscriptionInfoDTOBuilder.prototype.withCycle = function (_cycle) {
        this._cycle = _cycle;
        return this;
    };
    CurrentSubscriptionInfoDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    CurrentSubscriptionInfoDTOBuilder.prototype.withProductName = function (_productName) {
        this._productName = _productName;
        return this;
    };
    CurrentSubscriptionInfoDTOBuilder.prototype.withPeriodEndDate = function (_periodEndDate) {
        this._periodEndDate = _periodEndDate;
        return this;
    };
    CurrentSubscriptionInfoDTOBuilder.prototype.withMonthlyPrice = function (_monthlyPrice) {
        this._monthlyPrice = _monthlyPrice;
        return this;
    };
    CurrentSubscriptionInfoDTOBuilder.prototype.withIsBundled = function (_isBundled) {
        this._isBundled = _isBundled;
        return this;
    };
    CurrentSubscriptionInfoDTOBuilder.prototype.withAvailableCredit = function (_availableCredit) {
        this._availableCredit = _availableCredit;
        return this;
    };
    CurrentSubscriptionInfoDTOBuilder.prototype.withFreeTrialData = function (_freeTrialData) {
        this._freeTrialData = _freeTrialData;
        return this;
    };
    CurrentSubscriptionInfoDTOBuilder.prototype.withPremiumCycle = function (_premiumCycle) {
        this._premiumCycle = _premiumCycle;
        return this;
    };
    CurrentSubscriptionInfoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CurrentSubscriptionInfo', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            availableCredit: this._availableCredit !== UnassignedValue ? this._availableCredit : maybe(someInt()),
            cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            freeTrialData: this._freeTrialData !== UnassignedValue ? this._freeTrialData : maybe(exports.aV1FreeTrialData().build({ buildersVisited: buildersVisited })),
            isBundled: this._isBundled !== UnassignedValue ? this._isBundled : maybe(someBoolean()),
            monthlyPrice: this._monthlyPrice !== UnassignedValue ? this._monthlyPrice : maybe(someInt()),
            periodEndDate: this._periodEndDate !== UnassignedValue ? this._periodEndDate : maybe(someDateString()),
            premiumCycle: this._premiumCycle !== UnassignedValue ? this._premiumCycle : maybe(exports.aCommonV1Cycle().build({ buildersVisited: buildersVisited })),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
            productName: this._productName !== UnassignedValue ? this._productName : maybe(someString()),
            subscriptionId: this._subscriptionId !== UnassignedValue ? this._subscriptionId : maybe(someGuid()),
        };
    };
    return CurrentSubscriptionInfoDTOBuilder;
}());
exports.CurrentSubscriptionInfoDTOBuilder = CurrentSubscriptionInfoDTOBuilder;
var CycleChangeDTOBuilder = /** @class */ (function () {
    function CycleChangeDTOBuilder() {
        this._cycle = UnassignedValue;
    }
    CycleChangeDTOBuilder.prototype.withCycle = function (_cycle) {
        this._cycle = _cycle;
        return this;
    };
    CycleChangeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CycleChange', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
        };
    };
    return CycleChangeDTOBuilder;
}());
exports.CycleChangeDTOBuilder = CycleChangeDTOBuilder;
var CycleDisplayPropertiesDTOBuilder = /** @class */ (function () {
    function CycleDisplayPropertiesDTOBuilder() {
        this._cycle = UnassignedValue;
        this._displayProperties = UnassignedValue;
        this._premiumCycle = UnassignedValue;
    }
    CycleDisplayPropertiesDTOBuilder.prototype.withCycle = function (_cycle) {
        this._cycle = _cycle;
        return this;
    };
    CycleDisplayPropertiesDTOBuilder.prototype.withDisplayProperties = function (_displayProperties) {
        this._displayProperties = _displayProperties;
        return this;
    };
    CycleDisplayPropertiesDTOBuilder.prototype.withPremiumCycle = function (_premiumCycle) {
        this._premiumCycle = _premiumCycle;
        return this;
    };
    CycleDisplayPropertiesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CycleDisplayProperties', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            displayProperties: this._displayProperties !== UnassignedValue ? this._displayProperties : maybe(jsonMapOf(function () { return someString(); })),
            premiumCycle: this._premiumCycle !== UnassignedValue ? this._premiumCycle : maybe(exports.aCommonV1Cycle().build({ buildersVisited: buildersVisited })),
        };
    };
    return CycleDisplayPropertiesDTOBuilder;
}());
exports.CycleDisplayPropertiesDTOBuilder = CycleDisplayPropertiesDTOBuilder;
var CyclePriceDTOBuilder = /** @class */ (function () {
    function CyclePriceDTOBuilder() {
        this._paymentCycle = UnassignedValue;
        this._priceValue = UnassignedValue;
        this._priceWithTax = UnassignedValue;
    }
    CyclePriceDTOBuilder.prototype.withPaymentCycle = function (_paymentCycle) {
        this._paymentCycle = _paymentCycle;
        return this;
    };
    CyclePriceDTOBuilder.prototype.withPriceValue = function (_priceValue) {
        this._priceValue = _priceValue;
        return this;
    };
    CyclePriceDTOBuilder.prototype.withPriceWithTax = function (_priceWithTax) {
        this._priceWithTax = _priceWithTax;
        return this;
    };
    CyclePriceDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CyclePrice', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            paymentCycle: this._paymentCycle !== UnassignedValue ? this._paymentCycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            priceValue: this._priceValue !== UnassignedValue ? this._priceValue : maybe(decimalValueString()),
            priceWithTax: this._priceWithTax !== UnassignedValue ? this._priceWithTax : maybe(decimalValueString()),
        };
    };
    return CyclePriceDTOBuilder;
}());
exports.CyclePriceDTOBuilder = CyclePriceDTOBuilder;
var CyclePricingDTOBuilder = /** @class */ (function () {
    function CyclePricingDTOBuilder() {
        this._cycle = UnassignedValue;
        this._fixedAmount = UnassignedValue;
        this._fixedAmountDecimal = UnassignedValue;
        this._monthlyPrice = UnassignedValue;
        this._monthlyPriceDecimal = UnassignedValue;
        this._monthlyPriceWithTax = UnassignedValue;
        this._monthlyPriceWithTaxDecimal = UnassignedValue;
        this._monthsPerCycle = UnassignedValue;
        this._percentage = UnassignedValue;
        this._percentageDecimal = UnassignedValue;
        this._premiumCycle = UnassignedValue;
        this._price = UnassignedValue;
        this._priceDecimal = UnassignedValue;
        this._priceWithTax = UnassignedValue;
        this._priceWithTaxDecimal = UnassignedValue;
    }
    CyclePricingDTOBuilder.prototype.withCycle = function (_cycle) {
        this._cycle = _cycle;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withPrice = function (_price) {
        this._price = _price;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withPriceWithTax = function (_priceWithTax) {
        this._priceWithTax = _priceWithTax;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withMonthsPerCycle = function (_monthsPerCycle) {
        this._monthsPerCycle = _monthsPerCycle;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withMonthlyPrice = function (_monthlyPrice) {
        this._monthlyPrice = _monthlyPrice;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withMonthlyPriceWithTax = function (_monthlyPriceWithTax) {
        this._monthlyPriceWithTax = _monthlyPriceWithTax;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withPriceDecimal = function (_priceDecimal) {
        this._priceDecimal = _priceDecimal;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withPriceWithTaxDecimal = function (_priceWithTaxDecimal) {
        this._priceWithTaxDecimal = _priceWithTaxDecimal;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withMonthlyPriceDecimal = function (_monthlyPriceDecimal) {
        this._monthlyPriceDecimal = _monthlyPriceDecimal;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withMonthlyPriceWithTaxDecimal = function (_monthlyPriceWithTaxDecimal) {
        this._monthlyPriceWithTaxDecimal = _monthlyPriceWithTaxDecimal;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withPremiumCycle = function (_premiumCycle) {
        this._premiumCycle = _premiumCycle;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withPercentage = function (_percentage) {
        this._percentage = _percentage;
        this._fixedAmount = UnassignedValue;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withFixedAmount = function (_fixedAmount) {
        this._fixedAmount = _fixedAmount;
        this._percentage = UnassignedValue;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withPercentageDecimal = function (_percentageDecimal) {
        this._percentageDecimal = _percentageDecimal;
        this._fixedAmountDecimal = UnassignedValue;
        return this;
    };
    CyclePricingDTOBuilder.prototype.withFixedAmountDecimal = function (_fixedAmountDecimal) {
        this._fixedAmountDecimal = _fixedAmountDecimal;
        this._percentageDecimal = UnassignedValue;
        return this;
    };
    CyclePricingDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CyclePricing', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._percentage === UnassignedValue && this._fixedAmount === UnassignedValue && this._percentageDecimal === UnassignedValue && this._fixedAmountDecimal === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['percentage', 'fixedAmount', 'percentageDecimal', 'fixedAmountDecimal'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 4), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
                fixedAmount: assignRandomOneOf('fixedAmount', maybe(someInt()), oneOfFieldsToUnAssign),
                fixedAmountDecimal: assignRandomOneOf('fixedAmountDecimal', maybe(decimalValueString()), oneOfFieldsToUnAssign),
                monthlyPrice: this._monthlyPrice !== UnassignedValue ? this._monthlyPrice : maybe(someInt()),
                monthlyPriceDecimal: this._monthlyPriceDecimal !== UnassignedValue ? this._monthlyPriceDecimal : maybe(decimalValueString()),
                monthlyPriceWithTax: this._monthlyPriceWithTax !== UnassignedValue ? this._monthlyPriceWithTax : maybe(someInt()),
                monthlyPriceWithTaxDecimal: this._monthlyPriceWithTaxDecimal !== UnassignedValue ? this._monthlyPriceWithTaxDecimal : maybe(decimalValueString()),
                monthsPerCycle: this._monthsPerCycle !== UnassignedValue ? this._monthsPerCycle : maybe(someInt()),
                percentage: assignRandomOneOf('percentage', maybe(randomInt(0, 100)), oneOfFieldsToUnAssign),
                percentageDecimal: assignRandomOneOf('percentageDecimal', maybe(randomInt(0, 100)), oneOfFieldsToUnAssign),
                premiumCycle: this._premiumCycle !== UnassignedValue ? this._premiumCycle : maybe(exports.aCommonV1Cycle().build({ buildersVisited: buildersVisited })),
                price: this._price !== UnassignedValue ? this._price : maybe(someInt()),
                priceDecimal: this._priceDecimal !== UnassignedValue ? this._priceDecimal : maybe(decimalValueString()),
                priceWithTax: this._priceWithTax !== UnassignedValue ? this._priceWithTax : maybe(someInt()),
                priceWithTaxDecimal: this._priceWithTaxDecimal !== UnassignedValue ? this._priceWithTaxDecimal : maybe(decimalValueString()),
            };
        }
        return {
            cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            fixedAmount: this._fixedAmount === UnassignedValue ? undefined : this._fixedAmount,
            fixedAmountDecimal: this._fixedAmountDecimal === UnassignedValue ? undefined : this._fixedAmountDecimal,
            monthlyPrice: this._monthlyPrice !== UnassignedValue ? this._monthlyPrice : maybe(someInt()),
            monthlyPriceDecimal: this._monthlyPriceDecimal !== UnassignedValue ? this._monthlyPriceDecimal : maybe(decimalValueString()),
            monthlyPriceWithTax: this._monthlyPriceWithTax !== UnassignedValue ? this._monthlyPriceWithTax : maybe(someInt()),
            monthlyPriceWithTaxDecimal: this._monthlyPriceWithTaxDecimal !== UnassignedValue ? this._monthlyPriceWithTaxDecimal : maybe(decimalValueString()),
            monthsPerCycle: this._monthsPerCycle !== UnassignedValue ? this._monthsPerCycle : maybe(someInt()),
            percentage: this._percentage === UnassignedValue ? undefined : this._percentage,
            percentageDecimal: this._percentageDecimal === UnassignedValue ? undefined : this._percentageDecimal,
            premiumCycle: this._premiumCycle !== UnassignedValue ? this._premiumCycle : maybe(exports.aCommonV1Cycle().build({ buildersVisited: buildersVisited })),
            price: this._price !== UnassignedValue ? this._price : maybe(someInt()),
            priceDecimal: this._priceDecimal !== UnassignedValue ? this._priceDecimal : maybe(decimalValueString()),
            priceWithTax: this._priceWithTax !== UnassignedValue ? this._priceWithTax : maybe(someInt()),
            priceWithTaxDecimal: this._priceWithTaxDecimal !== UnassignedValue ? this._priceWithTaxDecimal : maybe(decimalValueString()),
        };
    };
    return CyclePricingDTOBuilder;
}());
exports.CyclePricingDTOBuilder = CyclePricingDTOBuilder;
var CyclePricingOldDTOBuilder = /** @class */ (function () {
    function CyclePricingOldDTOBuilder() {
        this._catalogPrice = UnassignedValue;
        this._catalogPriceAfterDiscount = UnassignedValue;
        this._catalogPriceAfterDiscountWithTax = UnassignedValue;
        this._catalogPriceWithTax = UnassignedValue;
        this._cycle = UnassignedValue;
        this._monthsPerCycle = UnassignedValue;
    }
    CyclePricingOldDTOBuilder.prototype.withCycle = function (_cycle) {
        this._cycle = _cycle;
        return this;
    };
    CyclePricingOldDTOBuilder.prototype.withCatalogPrice = function (_catalogPrice) {
        this._catalogPrice = _catalogPrice;
        return this;
    };
    CyclePricingOldDTOBuilder.prototype.withCatalogPriceWithTax = function (_catalogPriceWithTax) {
        this._catalogPriceWithTax = _catalogPriceWithTax;
        return this;
    };
    CyclePricingOldDTOBuilder.prototype.withCatalogPriceAfterDiscount = function (_catalogPriceAfterDiscount) {
        this._catalogPriceAfterDiscount = _catalogPriceAfterDiscount;
        return this;
    };
    CyclePricingOldDTOBuilder.prototype.withCatalogPriceAfterDiscountWithTax = function (_catalogPriceAfterDiscountWithTax) {
        this._catalogPriceAfterDiscountWithTax = _catalogPriceAfterDiscountWithTax;
        return this;
    };
    CyclePricingOldDTOBuilder.prototype.withMonthsPerCycle = function (_monthsPerCycle) {
        this._monthsPerCycle = _monthsPerCycle;
        return this;
    };
    CyclePricingOldDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'CyclePricingOld', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            catalogPrice: this._catalogPrice !== UnassignedValue ? this._catalogPrice : maybe(someInt()),
            catalogPriceAfterDiscount: this._catalogPriceAfterDiscount !== UnassignedValue ? this._catalogPriceAfterDiscount : maybe(someInt()),
            catalogPriceAfterDiscountWithTax: this._catalogPriceAfterDiscountWithTax !== UnassignedValue ? this._catalogPriceAfterDiscountWithTax : maybe(someInt()),
            catalogPriceWithTax: this._catalogPriceWithTax !== UnassignedValue ? this._catalogPriceWithTax : maybe(someInt()),
            cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            monthsPerCycle: this._monthsPerCycle !== UnassignedValue ? this._monthsPerCycle : maybe(someInt()),
        };
    };
    return CyclePricingOldDTOBuilder;
}());
exports.CyclePricingOldDTOBuilder = CyclePricingOldDTOBuilder;
var CycleTypeDTOBuilder = /** @class */ (function () {
    function CycleTypeDTOBuilder() {
    }
    CycleTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.CycleType.UNKNOWN_TYPE, types_1.CycleType.ONE_TIME, types_1.CycleType.RECURRING]);
    };
    return CycleTypeDTOBuilder;
}());
exports.CycleTypeDTOBuilder = CycleTypeDTOBuilder;
var CycleUnitTypeDTOBuilder = /** @class */ (function () {
    function CycleUnitTypeDTOBuilder() {
    }
    CycleUnitTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.CycleUnitType.ONE_TIME,
            types_1.CycleUnitType.DAILY,
            types_1.CycleUnitType.WEEKLY,
            types_1.CycleUnitType.MONTHLY,
            types_1.CycleUnitType.QUARTERLY,
            types_1.CycleUnitType.SEMI_ANNUALLY,
            types_1.CycleUnitType.YEARLY,
            types_1.CycleUnitType.TWO_YEARS,
            types_1.CycleUnitType.THREE_YEARS,
            types_1.CycleUnitType.FOUR_YEARS,
            types_1.CycleUnitType.FIVE_YEARS,
            types_1.CycleUnitType.SIX_YEARS,
            types_1.CycleUnitType.SEVEN_YEARS,
            types_1.CycleUnitType.EIGHT_YEARS,
            types_1.CycleUnitType.NINE_YEARS,
            types_1.CycleUnitType.TEN_YEARS,
        ]);
    };
    return CycleUnitTypeDTOBuilder;
}());
exports.CycleUnitTypeDTOBuilder = CycleUnitTypeDTOBuilder;
var DigitalGoodsPriceDTOBuilder = /** @class */ (function () {
    function DigitalGoodsPriceDTOBuilder() {
        this._priceValue = UnassignedValue;
        this._priceWithTax = UnassignedValue;
        this._skuId = UnassignedValue;
    }
    DigitalGoodsPriceDTOBuilder.prototype.withSkuId = function (_skuId) {
        this._skuId = _skuId;
        return this;
    };
    DigitalGoodsPriceDTOBuilder.prototype.withPriceValue = function (_priceValue) {
        this._priceValue = _priceValue;
        return this;
    };
    DigitalGoodsPriceDTOBuilder.prototype.withPriceWithTax = function (_priceWithTax) {
        this._priceWithTax = _priceWithTax;
        return this;
    };
    DigitalGoodsPriceDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DigitalGoodsPrice', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            priceValue: this._priceValue !== UnassignedValue ? this._priceValue : maybe(decimalValueString()),
            priceWithTax: this._priceWithTax !== UnassignedValue ? this._priceWithTax : maybe(decimalValueString()),
            skuId: this._skuId !== UnassignedValue ? this._skuId : maybe(someGuid()),
        };
    };
    return DigitalGoodsPriceDTOBuilder;
}());
exports.DigitalGoodsPriceDTOBuilder = DigitalGoodsPriceDTOBuilder;
var DisclaimerInfoDTOBuilder = /** @class */ (function () {
    function DisclaimerInfoDTOBuilder() {
        this._disclaimerText = UnassignedValue;
    }
    DisclaimerInfoDTOBuilder.prototype.withDisclaimerText = function (_disclaimerText) {
        this._disclaimerText = _disclaimerText;
        return this;
    };
    DisclaimerInfoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DisclaimerInfo', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            disclaimerText: this._disclaimerText !== UnassignedValue ? this._disclaimerText : maybe(someString()),
        };
    };
    return DisclaimerInfoDTOBuilder;
}());
exports.DisclaimerInfoDTOBuilder = DisclaimerInfoDTOBuilder;
var DiscountInfoDTOBuilder = /** @class */ (function () {
    function DiscountInfoDTOBuilder() {
        this._metadata = UnassignedValue;
    }
    DiscountInfoDTOBuilder.prototype.withMetadata = function (_metadata) {
        this._metadata = _metadata;
        return this;
    };
    DiscountInfoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DiscountInfo', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            metadata: this._metadata !== UnassignedValue ? this._metadata : maybe(jsonMapOf(function () { return someString(); })),
        };
    };
    return DiscountInfoDTOBuilder;
}());
exports.DiscountInfoDTOBuilder = DiscountInfoDTOBuilder;
var DiscountedPricingDTOBuilder = /** @class */ (function () {
    function DiscountedPricingDTOBuilder() {
        this._discountedPrices = UnassignedValue;
        this._fixedAmount = UnassignedValue;
        this._percentage = UnassignedValue;
    }
    DiscountedPricingDTOBuilder.prototype.withDiscountedPrices = function (_discountedPrices) {
        this._discountedPrices = _discountedPrices;
        return this;
    };
    DiscountedPricingDTOBuilder.prototype.withPercentage = function (_percentage) {
        this._percentage = _percentage;
        this._fixedAmount = UnassignedValue;
        return this;
    };
    DiscountedPricingDTOBuilder.prototype.withFixedAmount = function (_fixedAmount) {
        this._fixedAmount = _fixedAmount;
        this._percentage = UnassignedValue;
        return this;
    };
    DiscountedPricingDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DiscountedPricing', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._percentage === UnassignedValue && this._fixedAmount === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['percentage', 'fixedAmount'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 2), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                discountedPrices: this._discountedPrices !== UnassignedValue ? this._discountedPrices : maybe(exports.aProductCyclePrice().build({ buildersVisited: buildersVisited })),
                fixedAmount: assignRandomOneOf('fixedAmount', maybe(decimalValueString()), oneOfFieldsToUnAssign),
                percentage: assignRandomOneOf('percentage', maybe(randomInt(0, 100)), oneOfFieldsToUnAssign),
            };
        }
        return {
            discountedPrices: this._discountedPrices !== UnassignedValue ? this._discountedPrices : maybe(exports.aProductCyclePrice().build({ buildersVisited: buildersVisited })),
            fixedAmount: this._fixedAmount === UnassignedValue ? undefined : this._fixedAmount,
            percentage: this._percentage === UnassignedValue ? undefined : this._percentage,
        };
    };
    return DiscountedPricingDTOBuilder;
}());
exports.DiscountedPricingDTOBuilder = DiscountedPricingDTOBuilder;
var DisplayPreviewDTOBuilder = /** @class */ (function () {
    function DisplayPreviewDTOBuilder() {
        this._descriptionLines = UnassignedValue;
        this._previewUrl = UnassignedValue;
        this._translationParams = UnassignedValue;
    }
    DisplayPreviewDTOBuilder.prototype.withPreviewUrl = function (_previewUrl) {
        this._previewUrl = _previewUrl;
        return this;
    };
    DisplayPreviewDTOBuilder.prototype.withDescriptionLines = function (_descriptionLines) {
        this._descriptionLines = _descriptionLines;
        return this;
    };
    DisplayPreviewDTOBuilder.prototype.withTranslationParams = function (_translationParams) {
        this._translationParams = _translationParams;
        return this;
    };
    DisplayPreviewDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'DisplayPreview', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            descriptionLines: this._descriptionLines !== UnassignedValue ? this._descriptionLines : maybe(manyOf(function () { return someString(); })),
            previewUrl: this._previewUrl !== UnassignedValue ? this._previewUrl : maybe(webUrlString()),
            translationParams: this._translationParams !== UnassignedValue ? this._translationParams : maybe(jsonMapOf(function () { return someString(); })),
        };
    };
    return DisplayPreviewDTOBuilder;
}());
exports.DisplayPreviewDTOBuilder = DisplayPreviewDTOBuilder;
var DurationDTOBuilder = /** @class */ (function () {
    function DurationDTOBuilder() {
        this._count = UnassignedValue;
        this._unit = UnassignedValue;
    }
    DurationDTOBuilder.prototype.withUnit = function (_unit) {
        this._unit = _unit;
        return this;
    };
    DurationDTOBuilder.prototype.withCount = function (_count) {
        this._count = _count;
        return this;
    };
    DurationDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Duration', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            count: this._count !== UnassignedValue ? this._count : maybe(randomInt(1, 1000000)),
            unit: this._unit !== UnassignedValue ? this._unit : maybe(exports.aDurationUnit().build({ buildersVisited: buildersVisited })),
        };
    };
    return DurationDTOBuilder;
}());
exports.DurationDTOBuilder = DurationDTOBuilder;
var DurationUnitDTOBuilder = /** @class */ (function () {
    function DurationUnitDTOBuilder() {
    }
    DurationUnitDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.DurationUnit.UNKNOWN_UNIT, types_1.DurationUnit.DAY, types_1.DurationUnit.WEEK, types_1.DurationUnit.MONTH, types_1.DurationUnit.YEAR]);
    };
    return DurationUnitDTOBuilder;
}());
exports.DurationUnitDTOBuilder = DurationUnitDTOBuilder;
var EligibleDTOBuilder = /** @class */ (function () {
    function EligibleDTOBuilder() {
    }
    EligibleDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Eligible', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return EligibleDTOBuilder;
}());
exports.EligibleDTOBuilder = EligibleDTOBuilder;
var EmailSkuDtoDTOBuilder = /** @class */ (function () {
    function EmailSkuDtoDTOBuilder() {
        this._emailSkuId = UnassignedValue;
        this._paymentCycle = UnassignedValue;
        this._sbsProductId = UnassignedValue;
    }
    EmailSkuDtoDTOBuilder.prototype.withEmailSkuId = function (_emailSkuId) {
        this._emailSkuId = _emailSkuId;
        return this;
    };
    EmailSkuDtoDTOBuilder.prototype.withPaymentCycle = function (_paymentCycle) {
        this._paymentCycle = _paymentCycle;
        return this;
    };
    EmailSkuDtoDTOBuilder.prototype.withSbsProductId = function (_sbsProductId) {
        this._sbsProductId = _sbsProductId;
        return this;
    };
    EmailSkuDtoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'EmailSkuDto', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            emailSkuId: this._emailSkuId !== UnassignedValue ? this._emailSkuId : maybe(someInt()),
            paymentCycle: this._paymentCycle !== UnassignedValue ? this._paymentCycle : maybe(someInt()),
            sbsProductId: this._sbsProductId !== UnassignedValue ? this._sbsProductId : maybe(someGuid()),
        };
    };
    return EmailSkuDtoDTOBuilder;
}());
exports.EmailSkuDtoDTOBuilder = EmailSkuDtoDTOBuilder;
var FeatureDTOBuilder = /** @class */ (function () {
    function FeatureDTOBuilder() {
        this._booleanFeature = UnassignedValue;
        this._displayProperties = UnassignedValue;
        this._excludedCycles = UnassignedValue;
        this._excludedPremiumCycle = UnassignedValue;
        this._name = UnassignedValue;
        this._quotaFeature = UnassignedValue;
    }
    FeatureDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    FeatureDTOBuilder.prototype.withExcludedCycles = function (_excludedCycles) {
        this._excludedCycles = _excludedCycles;
        return this;
    };
    FeatureDTOBuilder.prototype.withDisplayProperties = function (_displayProperties) {
        this._displayProperties = _displayProperties;
        return this;
    };
    FeatureDTOBuilder.prototype.withExcludedPremiumCycle = function (_excludedPremiumCycle) {
        this._excludedPremiumCycle = _excludedPremiumCycle;
        return this;
    };
    FeatureDTOBuilder.prototype.withBooleanFeature = function (_booleanFeature) {
        this._booleanFeature = _booleanFeature;
        this._quotaFeature = UnassignedValue;
        return this;
    };
    FeatureDTOBuilder.prototype.withQuotaFeature = function (_quotaFeature) {
        this._quotaFeature = _quotaFeature;
        this._booleanFeature = UnassignedValue;
        return this;
    };
    FeatureDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Feature', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._booleanFeature === UnassignedValue && this._quotaFeature === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['booleanFeature', 'quotaFeature'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 2), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                booleanFeature: assignRandomOneOf('booleanFeature', maybe(exports.aBooleanFeature().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                displayProperties: this._displayProperties !== UnassignedValue ? this._displayProperties : maybe(jsonMapOf(function () { return someString(); })),
                excludedCycles: this._excludedCycles !== UnassignedValue ? this._excludedCycles : maybe(manyOf(function () { return exports.anApiV1Cycle().build({ buildersVisited: buildersVisited }); })),
                excludedPremiumCycle: this._excludedPremiumCycle !== UnassignedValue ? this._excludedPremiumCycle : maybe(boundedManyOf(0, 3, function () { return exports.aCommonV1Cycle().build({ buildersVisited: buildersVisited }); })),
                name: this._name !== UnassignedValue ? this._name : maybe(someString()),
                quotaFeature: assignRandomOneOf('quotaFeature', maybe(exports.aQuotaFeature().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            booleanFeature: this._booleanFeature === UnassignedValue ? undefined : this._booleanFeature,
            displayProperties: this._displayProperties !== UnassignedValue ? this._displayProperties : maybe(jsonMapOf(function () { return someString(); })),
            excludedCycles: this._excludedCycles !== UnassignedValue ? this._excludedCycles : maybe(manyOf(function () { return exports.anApiV1Cycle().build({ buildersVisited: buildersVisited }); })),
            excludedPremiumCycle: this._excludedPremiumCycle !== UnassignedValue ? this._excludedPremiumCycle : maybe(boundedManyOf(0, 3, function () { return exports.aCommonV1Cycle().build({ buildersVisited: buildersVisited }); })),
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            quotaFeature: this._quotaFeature === UnassignedValue ? undefined : this._quotaFeature,
        };
    };
    return FeatureDTOBuilder;
}());
exports.FeatureDTOBuilder = FeatureDTOBuilder;
var FeatureDisplayAttributesDTOBuilder = /** @class */ (function () {
    function FeatureDisplayAttributesDTOBuilder() {
        this._description = UnassignedValue;
        this._featureId = UnassignedValue;
        this._hidden = UnassignedValue;
        this._metaData = UnassignedValue;
        this._name = UnassignedValue;
        this._priority = UnassignedValue;
        this._translationKey = UnassignedValue;
    }
    FeatureDisplayAttributesDTOBuilder.prototype.withFeatureId = function (_featureId) {
        this._featureId = _featureId;
        return this;
    };
    FeatureDisplayAttributesDTOBuilder.prototype.withTranslationKey = function (_translationKey) {
        this._translationKey = _translationKey;
        return this;
    };
    FeatureDisplayAttributesDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    FeatureDisplayAttributesDTOBuilder.prototype.withDescription = function (_description) {
        this._description = _description;
        return this;
    };
    FeatureDisplayAttributesDTOBuilder.prototype.withMetaData = function (_metaData) {
        this._metaData = _metaData;
        return this;
    };
    FeatureDisplayAttributesDTOBuilder.prototype.withPriority = function (_priority) {
        this._priority = _priority;
        return this;
    };
    FeatureDisplayAttributesDTOBuilder.prototype.withHidden = function (_hidden) {
        this._hidden = _hidden;
        return this;
    };
    FeatureDisplayAttributesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FeatureDisplayAttributes', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            description: this._description !== UnassignedValue ? this._description : maybe(someString()),
            featureId: this._featureId !== UnassignedValue ? this._featureId : maybe(someGuid()),
            hidden: this._hidden !== UnassignedValue ? this._hidden : maybe(someBoolean()),
            metaData: this._metaData !== UnassignedValue ? this._metaData : maybe(jsonMapOf(function () { return someString(); })),
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            priority: this._priority !== UnassignedValue ? this._priority : maybe(someNumber()),
            translationKey: this._translationKey !== UnassignedValue ? this._translationKey : maybe(someString()),
        };
    };
    return FeatureDisplayAttributesDTOBuilder;
}());
exports.FeatureDisplayAttributesDTOBuilder = FeatureDisplayAttributesDTOBuilder;
var FeaturePeriodDTOBuilder = /** @class */ (function () {
    function FeaturePeriodDTOBuilder() {
    }
    FeaturePeriodDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.FeaturePeriod.NO_PERIOD,
            types_1.FeaturePeriod.MILLISECOND,
            types_1.FeaturePeriod.SECOND,
            types_1.FeaturePeriod.MINUTE,
            types_1.FeaturePeriod.HOUR,
            types_1.FeaturePeriod.DAY,
            types_1.FeaturePeriod.WEEK,
            types_1.FeaturePeriod.MONTH,
            types_1.FeaturePeriod.YEAR,
        ]);
    };
    return FeaturePeriodDTOBuilder;
}());
exports.FeaturePeriodDTOBuilder = FeaturePeriodDTOBuilder;
var FieldDTOBuilder = /** @class */ (function () {
    function FieldDTOBuilder() {
        this._fixed32 = UnassignedValue;
        this._fixed64 = UnassignedValue;
        this._lengthDelimited = UnassignedValue;
        this._varint = UnassignedValue;
    }
    FieldDTOBuilder.prototype.withLengthDelimited = function (_lengthDelimited) {
        this._lengthDelimited = _lengthDelimited;
        return this;
    };
    FieldDTOBuilder.prototype.withFixed32 = function (_fixed32) {
        this._fixed32 = _fixed32;
        return this;
    };
    FieldDTOBuilder.prototype.withFixed64 = function (_fixed64) {
        this._fixed64 = _fixed64;
        return this;
    };
    FieldDTOBuilder.prototype.withVarint = function (_varint) {
        this._varint = _varint;
        return this;
    };
    FieldDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Field', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            fixed32: this._fixed32 !== UnassignedValue ? this._fixed32 : manyOf(function () { return someInt(); }),
            fixed64: this._fixed64 !== UnassignedValue ? this._fixed64 : manyOf(function () { return someInt(); }),
            lengthDelimited: this._lengthDelimited !== UnassignedValue ? this._lengthDelimited : manyOf(function () { return createNull(); }),
            varint: this._varint !== UnassignedValue ? this._varint : manyOf(function () { return someInt(); }),
        };
    };
    return FieldDTOBuilder;
}());
exports.FieldDTOBuilder = FieldDTOBuilder;
var FreeTrialDTOBuilder = /** @class */ (function () {
    function FreeTrialDTOBuilder() {
        this._duration = UnassignedValue;
        this._premiumDuration = UnassignedValue;
    }
    FreeTrialDTOBuilder.prototype.withDuration = function (_duration) {
        this._duration = _duration;
        return this;
    };
    FreeTrialDTOBuilder.prototype.withPremiumDuration = function (_premiumDuration) {
        this._premiumDuration = _premiumDuration;
        return this;
    };
    FreeTrialDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FreeTrial', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            duration: this._duration !== UnassignedValue ? this._duration : maybe(exports.anInterval().build({ buildersVisited: buildersVisited })),
            premiumDuration: this._premiumDuration !== UnassignedValue ? this._premiumDuration : maybe(exports.aDuration().build({ buildersVisited: buildersVisited })),
        };
    };
    return FreeTrialDTOBuilder;
}());
exports.FreeTrialDTOBuilder = FreeTrialDTOBuilder;
var FreeTrialEligibilityDTOBuilder = /** @class */ (function () {
    function FreeTrialEligibilityDTOBuilder() {
        this._eligible = UnassignedValue;
        this._ineligibleReason = UnassignedValue;
    }
    FreeTrialEligibilityDTOBuilder.prototype.withEligible = function (_eligible) {
        this._eligible = _eligible;
        this._ineligibleReason = UnassignedValue;
        return this;
    };
    FreeTrialEligibilityDTOBuilder.prototype.withIneligibleReason = function (_ineligibleReason) {
        this._ineligibleReason = _ineligibleReason;
        this._eligible = UnassignedValue;
        return this;
    };
    FreeTrialEligibilityDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'FreeTrialEligibility', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._eligible === UnassignedValue && this._ineligibleReason === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['eligible', 'ineligibleReason'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 2), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                eligible: assignRandomOneOf('eligible', maybe(exports.anEligible().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                ineligibleReason: assignRandomOneOf('ineligibleReason', maybe(exports.aFreeTrialIneligibilityReasonEnum().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            eligible: this._eligible === UnassignedValue ? undefined : this._eligible,
            ineligibleReason: this._ineligibleReason === UnassignedValue ? undefined : this._ineligibleReason,
        };
    };
    return FreeTrialEligibilityDTOBuilder;
}());
exports.FreeTrialEligibilityDTOBuilder = FreeTrialEligibilityDTOBuilder;
var FreeTrialIneligibilityReasonEnumDTOBuilder = /** @class */ (function () {
    function FreeTrialIneligibilityReasonEnumDTOBuilder() {
    }
    FreeTrialIneligibilityReasonEnumDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.FreeTrialIneligibilityReasonEnum.UNKNOWN,
            types_1.FreeTrialIneligibilityReasonEnum.ACCOUNT_NOT_ELIGIBLE,
            types_1.FreeTrialIneligibilityReasonEnum.NOT_INITIAL_PURCHASE,
            types_1.FreeTrialIneligibilityReasonEnum.NO_FREE_TRIAL_PRODUCT,
        ]);
    };
    return FreeTrialIneligibilityReasonEnumDTOBuilder;
}());
exports.FreeTrialIneligibilityReasonEnumDTOBuilder = FreeTrialIneligibilityReasonEnumDTOBuilder;
var GetAllowedActionsV2RequestDTOBuilder = /** @class */ (function () {
    function GetAllowedActionsV2RequestDTOBuilder() {
        this._productData = UnassignedValue;
        this._sbsService = UnassignedValue;
        this._sbsServiceId = UnassignedValue;
    }
    GetAllowedActionsV2RequestDTOBuilder.prototype.withProductData = function (_productData) {
        this._productData = _productData;
        return this;
    };
    GetAllowedActionsV2RequestDTOBuilder.prototype.withSbsService = function (_sbsService) {
        this._sbsService = _sbsService;
        return this;
    };
    GetAllowedActionsV2RequestDTOBuilder.prototype.withSbsServiceId = function (_sbsServiceId) {
        this._sbsServiceId = _sbsServiceId;
        return this;
    };
    GetAllowedActionsV2RequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetAllowedActionsV2Request', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            productData: this._productData !== UnassignedValue ? this._productData : maybe(exports.aProductData().build({ buildersVisited: buildersVisited })),
            sbsService: this._sbsService !== UnassignedValue ? this._sbsService : maybe(exports.aServiceData().build({ buildersVisited: buildersVisited })),
            sbsServiceId: this._sbsServiceId !== UnassignedValue ? this._sbsServiceId : someGuid(),
        };
    };
    return GetAllowedActionsV2RequestDTOBuilder;
}());
exports.GetAllowedActionsV2RequestDTOBuilder = GetAllowedActionsV2RequestDTOBuilder;
var GetB2BUserOfferingRequestDTOBuilder = /** @class */ (function () {
    function GetB2BUserOfferingRequestDTOBuilder() {
        this._eventAggregator = UnassignedValue;
        this._msid = UnassignedValue;
        this._productTypeId = UnassignedValue;
    }
    GetB2BUserOfferingRequestDTOBuilder.prototype.withProductTypeId = function (_productTypeId) {
        this._productTypeId = _productTypeId;
        return this;
    };
    GetB2BUserOfferingRequestDTOBuilder.prototype.withMsid = function (_msid) {
        this._msid = _msid;
        return this;
    };
    GetB2BUserOfferingRequestDTOBuilder.prototype.withEventAggregator = function (_eventAggregator) {
        this._eventAggregator = _eventAggregator;
        return this;
    };
    GetB2BUserOfferingRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetB2BUserOfferingRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            eventAggregator: this._eventAggregator !== UnassignedValue ? this._eventAggregator : maybe(someString()),
            msid: this._msid !== UnassignedValue ? this._msid : maybe(someString()),
            productTypeId: this._productTypeId !== UnassignedValue ? this._productTypeId : maybe(someGuid()),
        };
    };
    return GetB2BUserOfferingRequestDTOBuilder;
}());
exports.GetB2BUserOfferingRequestDTOBuilder = GetB2BUserOfferingRequestDTOBuilder;
var GetB2BUserOfferingResponseDTOBuilder = /** @class */ (function () {
    function GetB2BUserOfferingResponseDTOBuilder() {
        this._displayProperties = UnassignedValue;
        this._eligibleCountries = UnassignedValue;
        this._eventAggregator = UnassignedValue;
        this._products = UnassignedValue;
    }
    GetB2BUserOfferingResponseDTOBuilder.prototype.withProducts = function (_products) {
        this._products = _products;
        return this;
    };
    GetB2BUserOfferingResponseDTOBuilder.prototype.withEligibleCountries = function (_eligibleCountries) {
        this._eligibleCountries = _eligibleCountries;
        return this;
    };
    GetB2BUserOfferingResponseDTOBuilder.prototype.withDisplayProperties = function (_displayProperties) {
        this._displayProperties = _displayProperties;
        return this;
    };
    GetB2BUserOfferingResponseDTOBuilder.prototype.withEventAggregator = function (_eventAggregator) {
        this._eventAggregator = _eventAggregator;
        return this;
    };
    GetB2BUserOfferingResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetB2BUserOfferingResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            displayProperties: this._displayProperties !== UnassignedValue ? this._displayProperties : maybe(jsonMapOf(function () { return someString(); })),
            eligibleCountries: this._eligibleCountries !== UnassignedValue ? this._eligibleCountries : maybe(manyOf(function () { return someString(); })),
            eventAggregator: this._eventAggregator !== UnassignedValue ? this._eventAggregator : maybe(someString()),
            products: this._products !== UnassignedValue ? this._products : maybe(manyOf(function () { return exports.aProductInfo().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return GetB2BUserOfferingResponseDTOBuilder;
}());
exports.GetB2BUserOfferingResponseDTOBuilder = GetB2BUserOfferingResponseDTOBuilder;
var GetCurrencySettingsRequestDTOBuilder = /** @class */ (function () {
    function GetCurrencySettingsRequestDTOBuilder() {
        this._overrideCountryCode = UnassignedValue;
        this._overrideCurrencyCode = UnassignedValue;
        this._overrideLanguageCode = UnassignedValue;
    }
    GetCurrencySettingsRequestDTOBuilder.prototype.withOverrideCountryCode = function (_overrideCountryCode) {
        this._overrideCountryCode = _overrideCountryCode;
        return this;
    };
    GetCurrencySettingsRequestDTOBuilder.prototype.withOverrideLanguageCode = function (_overrideLanguageCode) {
        this._overrideLanguageCode = _overrideLanguageCode;
        return this;
    };
    GetCurrencySettingsRequestDTOBuilder.prototype.withOverrideCurrencyCode = function (_overrideCurrencyCode) {
        this._overrideCurrencyCode = _overrideCurrencyCode;
        return this;
    };
    GetCurrencySettingsRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetCurrencySettingsRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            overrideCountryCode: this._overrideCountryCode !== UnassignedValue ? this._overrideCountryCode : maybe(someString()),
            overrideCurrencyCode: this._overrideCurrencyCode !== UnassignedValue ? this._overrideCurrencyCode : maybe(someString()),
            overrideLanguageCode: this._overrideLanguageCode !== UnassignedValue ? this._overrideLanguageCode : maybe(someString()),
        };
    };
    return GetCurrencySettingsRequestDTOBuilder;
}());
exports.GetCurrencySettingsRequestDTOBuilder = GetCurrencySettingsRequestDTOBuilder;
var GetCurrencySettingsResponseDTOBuilder = /** @class */ (function () {
    function GetCurrencySettingsResponseDTOBuilder() {
        this._currencySettings = UnassignedValue;
    }
    GetCurrencySettingsResponseDTOBuilder.prototype.withCurrencySettings = function (_currencySettings) {
        this._currencySettings = _currencySettings;
        return this;
    };
    GetCurrencySettingsResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetCurrencySettingsResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currencySettings: this._currencySettings !== UnassignedValue ? this._currencySettings : maybe(exports.aCurrencySettings().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetCurrencySettingsResponseDTOBuilder;
}());
exports.GetCurrencySettingsResponseDTOBuilder = GetCurrencySettingsResponseDTOBuilder;
var GetFreeTrialEligibilityRequestDTOBuilder = /** @class */ (function () {
    function GetFreeTrialEligibilityRequestDTOBuilder() {
        this._productFamilyId = UnassignedValue;
        this._productTypeId = UnassignedValue;
    }
    GetFreeTrialEligibilityRequestDTOBuilder.prototype.withProductTypeId = function (_productTypeId) {
        this._productTypeId = _productTypeId;
        return this;
    };
    GetFreeTrialEligibilityRequestDTOBuilder.prototype.withProductFamilyId = function (_productFamilyId) {
        this._productFamilyId = _productFamilyId;
        return this;
    };
    GetFreeTrialEligibilityRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetFreeTrialEligibilityRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            productFamilyId: this._productFamilyId !== UnassignedValue ? this._productFamilyId : maybe(someGuid()),
            productTypeId: this._productTypeId !== UnassignedValue ? this._productTypeId : maybe(someGuid()),
        };
    };
    return GetFreeTrialEligibilityRequestDTOBuilder;
}());
exports.GetFreeTrialEligibilityRequestDTOBuilder = GetFreeTrialEligibilityRequestDTOBuilder;
var GetFreeTrialEligibilityResponseDTOBuilder = /** @class */ (function () {
    function GetFreeTrialEligibilityResponseDTOBuilder() {
        this._freeTrialEligibility = UnassignedValue;
    }
    GetFreeTrialEligibilityResponseDTOBuilder.prototype.withFreeTrialEligibility = function (_freeTrialEligibility) {
        this._freeTrialEligibility = _freeTrialEligibility;
        return this;
    };
    GetFreeTrialEligibilityResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetFreeTrialEligibilityResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            freeTrialEligibility: this._freeTrialEligibility !== UnassignedValue ? this._freeTrialEligibility : maybe(exports.aFreeTrialEligibility().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetFreeTrialEligibilityResponseDTOBuilder;
}());
exports.GetFreeTrialEligibilityResponseDTOBuilder = GetFreeTrialEligibilityResponseDTOBuilder;
var GetInfoRequestDTOBuilder = /** @class */ (function () {
    function GetInfoRequestDTOBuilder() {
        this._subscriptionId = UnassignedValue;
    }
    GetInfoRequestDTOBuilder.prototype.withSubscriptionId = function (_subscriptionId) {
        this._subscriptionId = _subscriptionId;
        return this;
    };
    GetInfoRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetInfoRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            subscriptionId: this._subscriptionId !== UnassignedValue ? this._subscriptionId : maybe(someGuid()),
        };
    };
    return GetInfoRequestDTOBuilder;
}());
exports.GetInfoRequestDTOBuilder = GetInfoRequestDTOBuilder;
var GetInfoResponseDTOBuilder = /** @class */ (function () {
    function GetInfoResponseDTOBuilder() {
        this._availableCycles = UnassignedValue;
        this._billingProductId = UnassignedValue;
        this._currencySettings = UnassignedValue;
        this._offerValidUntil = UnassignedValue;
        this._offeringType = UnassignedValue;
        this._productId = UnassignedValue;
        this._productName = UnassignedValue;
        this._productPricing = UnassignedValue;
        this._subscriptionCurrentCycle = UnassignedValue;
        this._subscriptionPendingChanges = UnassignedValue;
        this._taxSettings = UnassignedValue;
    }
    GetInfoResponseDTOBuilder.prototype.withProductName = function (_productName) {
        this._productName = _productName;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.withSubscriptionCurrentCycle = function (_subscriptionCurrentCycle) {
        this._subscriptionCurrentCycle = _subscriptionCurrentCycle;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.withProductPricing = function (_productPricing) {
        this._productPricing = _productPricing;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.withTaxSettings = function (_taxSettings) {
        this._taxSettings = _taxSettings;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.withAvailableCycles = function (_availableCycles) {
        this._availableCycles = _availableCycles;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.withCurrencySettings = function (_currencySettings) {
        this._currencySettings = _currencySettings;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.withBillingProductId = function (_billingProductId) {
        this._billingProductId = _billingProductId;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.withOfferValidUntil = function (_offerValidUntil) {
        this._offerValidUntil = _offerValidUntil;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.withSubscriptionPendingChanges = function (_subscriptionPendingChanges) {
        this._subscriptionPendingChanges = _subscriptionPendingChanges;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.withOfferingType = function (_offeringType) {
        this._offeringType = _offeringType;
        return this;
    };
    GetInfoResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetInfoResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            availableCycles: this._availableCycles !== UnassignedValue ? this._availableCycles : maybe(manyOf(function () { return exports.anApiV1Cycle().build({ buildersVisited: buildersVisited }); })),
            billingProductId: this._billingProductId !== UnassignedValue ? this._billingProductId : maybe(someString()),
            currencySettings: this._currencySettings !== UnassignedValue ? this._currencySettings : maybe(exports.aCurrencySettings().build({ buildersVisited: buildersVisited })),
            offerValidUntil: this._offerValidUntil !== UnassignedValue ? this._offerValidUntil : maybe(someDateString()),
            offeringType: this._offeringType !== UnassignedValue ? this._offeringType : maybe(someString()),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someString()),
            productName: this._productName !== UnassignedValue ? this._productName : maybe(someString()),
            productPricing: this._productPricing !== UnassignedValue ? this._productPricing : maybe(exports.aPricingInfo().build({ buildersVisited: buildersVisited })),
            subscriptionCurrentCycle: this._subscriptionCurrentCycle !== UnassignedValue ? this._subscriptionCurrentCycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            subscriptionPendingChanges: this._subscriptionPendingChanges !== UnassignedValue ? this._subscriptionPendingChanges : maybe(exports.aV1PendingChanges().build({ buildersVisited: buildersVisited })),
            taxSettings: this._taxSettings !== UnassignedValue ? this._taxSettings : maybe(exports.aTaxSettings().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetInfoResponseDTOBuilder;
}());
exports.GetInfoResponseDTOBuilder = GetInfoResponseDTOBuilder;
var GetItemsRequestDTOBuilder = /** @class */ (function () {
    function GetItemsRequestDTOBuilder() {
        this._catalogReferences = UnassignedValue;
        this._currency = UnassignedValue;
        this._taxIncludedInPrices = UnassignedValue;
    }
    GetItemsRequestDTOBuilder.prototype.withCatalogReferences = function (_catalogReferences) {
        this._catalogReferences = _catalogReferences;
        return this;
    };
    GetItemsRequestDTOBuilder.prototype.withTaxIncludedInPrices = function (_taxIncludedInPrices) {
        this._taxIncludedInPrices = _taxIncludedInPrices;
        return this;
    };
    GetItemsRequestDTOBuilder.prototype.withCurrency = function (_currency) {
        this._currency = _currency;
        return this;
    };
    GetItemsRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetItemsRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            catalogReferences: this._catalogReferences !== UnassignedValue ? this._catalogReferences : maybe(boundedManyOf(1, 3, function () { return exports.aCatalogReference().build({ buildersVisited: buildersVisited }); })),
            currency: this._currency !== UnassignedValue ? this._currency : maybe(currencyString()),
            taxIncludedInPrices: this._taxIncludedInPrices !== UnassignedValue ? this._taxIncludedInPrices : maybe(someBoolean()),
        };
    };
    return GetItemsRequestDTOBuilder;
}());
exports.GetItemsRequestDTOBuilder = GetItemsRequestDTOBuilder;
var GetItemsResponseDTOBuilder = /** @class */ (function () {
    function GetItemsResponseDTOBuilder() {
        this._items = UnassignedValue;
    }
    GetItemsResponseDTOBuilder.prototype.withItems = function (_items) {
        this._items = _items;
        return this;
    };
    GetItemsResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetItemsResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            items: this._items !== UnassignedValue ? this._items : maybe(boundedManyOf(1, 3, function () { return exports.anItem().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return GetItemsResponseDTOBuilder;
}());
exports.GetItemsResponseDTOBuilder = GetItemsResponseDTOBuilder;
var GetMailboxSaleTypeForDomainRequestDTOBuilder = /** @class */ (function () {
    function GetMailboxSaleTypeForDomainRequestDTOBuilder() {
        this._domainName = UnassignedValue;
        this._userId = UnassignedValue;
    }
    GetMailboxSaleTypeForDomainRequestDTOBuilder.prototype.withDomainName = function (_domainName) {
        this._domainName = _domainName;
        return this;
    };
    GetMailboxSaleTypeForDomainRequestDTOBuilder.prototype.withUserId = function (_userId) {
        this._userId = _userId;
        return this;
    };
    GetMailboxSaleTypeForDomainRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetMailboxSaleTypeForDomainRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            domainName: this._domainName !== UnassignedValue ? this._domainName : maybe(boundedString(0, 256)),
            userId: this._userId !== UnassignedValue ? this._userId : maybe(someGuid()),
        };
    };
    return GetMailboxSaleTypeForDomainRequestDTOBuilder;
}());
exports.GetMailboxSaleTypeForDomainRequestDTOBuilder = GetMailboxSaleTypeForDomainRequestDTOBuilder;
var GetMailboxSaleTypeForSiteRequestDTOBuilder = /** @class */ (function () {
    function GetMailboxSaleTypeForSiteRequestDTOBuilder() {
        this._siteId = UnassignedValue;
    }
    GetMailboxSaleTypeForSiteRequestDTOBuilder.prototype.withSiteId = function (_siteId) {
        this._siteId = _siteId;
        return this;
    };
    GetMailboxSaleTypeForSiteRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetMailboxSaleTypeForSiteRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            siteId: this._siteId !== UnassignedValue ? this._siteId : maybe(someGuid()),
        };
    };
    return GetMailboxSaleTypeForSiteRequestDTOBuilder;
}());
exports.GetMailboxSaleTypeForSiteRequestDTOBuilder = GetMailboxSaleTypeForSiteRequestDTOBuilder;
var GetMailboxSaleTypeForUserRequestDTOBuilder = /** @class */ (function () {
    function GetMailboxSaleTypeForUserRequestDTOBuilder() {
        this._userId = UnassignedValue;
    }
    GetMailboxSaleTypeForUserRequestDTOBuilder.prototype.withUserId = function (_userId) {
        this._userId = _userId;
        return this;
    };
    GetMailboxSaleTypeForUserRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetMailboxSaleTypeForUserRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            userId: this._userId !== UnassignedValue ? this._userId : maybe(someGuid()),
        };
    };
    return GetMailboxSaleTypeForUserRequestDTOBuilder;
}());
exports.GetMailboxSaleTypeForUserRequestDTOBuilder = GetMailboxSaleTypeForUserRequestDTOBuilder;
var GetMailboxSaleTypeResponseDTOBuilder = /** @class */ (function () {
    function GetMailboxSaleTypeResponseDTOBuilder() {
        this._mailboxSaleType = UnassignedValue;
    }
    GetMailboxSaleTypeResponseDTOBuilder.prototype.withMailboxSaleType = function (_mailboxSaleType) {
        this._mailboxSaleType = _mailboxSaleType;
        return this;
    };
    GetMailboxSaleTypeResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetMailboxSaleTypeResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            mailboxSaleType: this._mailboxSaleType !== UnassignedValue ? this._mailboxSaleType : maybe(exports.aMailboxSaleType().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetMailboxSaleTypeResponseDTOBuilder;
}());
exports.GetMailboxSaleTypeResponseDTOBuilder = GetMailboxSaleTypeResponseDTOBuilder;
var GetOrderPreviewRequestDTOBuilder = /** @class */ (function () {
    function GetOrderPreviewRequestDTOBuilder() {
        this._billingProductId = UnassignedValue;
        this._paymentSourceId = UnassignedValue;
        this._selectedCycle = UnassignedValue;
        this._subscriptionId = UnassignedValue;
    }
    GetOrderPreviewRequestDTOBuilder.prototype.withSubscriptionId = function (_subscriptionId) {
        this._subscriptionId = _subscriptionId;
        return this;
    };
    GetOrderPreviewRequestDTOBuilder.prototype.withSelectedCycle = function (_selectedCycle) {
        this._selectedCycle = _selectedCycle;
        return this;
    };
    GetOrderPreviewRequestDTOBuilder.prototype.withBillingProductId = function (_billingProductId) {
        this._billingProductId = _billingProductId;
        return this;
    };
    GetOrderPreviewRequestDTOBuilder.prototype.withPaymentSourceId = function (_paymentSourceId) {
        this._paymentSourceId = _paymentSourceId;
        return this;
    };
    GetOrderPreviewRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetOrderPreviewRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            billingProductId: this._billingProductId !== UnassignedValue ? this._billingProductId : maybe(someGuid()),
            paymentSourceId: this._paymentSourceId !== UnassignedValue ? this._paymentSourceId : maybe(someGuid()),
            selectedCycle: this._selectedCycle !== UnassignedValue ? this._selectedCycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            subscriptionId: this._subscriptionId !== UnassignedValue ? this._subscriptionId : maybe(someGuid()),
        };
    };
    return GetOrderPreviewRequestDTOBuilder;
}());
exports.GetOrderPreviewRequestDTOBuilder = GetOrderPreviewRequestDTOBuilder;
var GetOrderPreviewResponseDTOBuilder = /** @class */ (function () {
    function GetOrderPreviewResponseDTOBuilder() {
        this._orderPreview = UnassignedValue;
    }
    GetOrderPreviewResponseDTOBuilder.prototype.withOrderPreview = function (_orderPreview) {
        this._orderPreview = _orderPreview;
        return this;
    };
    GetOrderPreviewResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetOrderPreviewResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            orderPreview: this._orderPreview !== UnassignedValue ? this._orderPreview : maybe(exports.anOrderPreview().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetOrderPreviewResponseDTOBuilder;
}());
exports.GetOrderPreviewResponseDTOBuilder = GetOrderPreviewResponseDTOBuilder;
var GetPackagePickerPricingRequestDTOBuilder = /** @class */ (function () {
    function GetPackagePickerPricingRequestDTOBuilder() {
    }
    GetPackagePickerPricingRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetPackagePickerPricingRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return GetPackagePickerPricingRequestDTOBuilder;
}());
exports.GetPackagePickerPricingRequestDTOBuilder = GetPackagePickerPricingRequestDTOBuilder;
var GetPackagePickerPricingResponseDTOBuilder = /** @class */ (function () {
    function GetPackagePickerPricingResponseDTOBuilder() {
        this._currencyCode = UnassignedValue;
        this._emailSkus = UnassignedValue;
        this._productsPrice = UnassignedValue;
    }
    GetPackagePickerPricingResponseDTOBuilder.prototype.withProductsPrice = function (_productsPrice) {
        this._productsPrice = _productsPrice;
        return this;
    };
    GetPackagePickerPricingResponseDTOBuilder.prototype.withEmailSkus = function (_emailSkus) {
        this._emailSkus = _emailSkus;
        return this;
    };
    GetPackagePickerPricingResponseDTOBuilder.prototype.withCurrencyCode = function (_currencyCode) {
        this._currencyCode = _currencyCode;
        return this;
    };
    GetPackagePickerPricingResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetPackagePickerPricingResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currencyCode: this._currencyCode !== UnassignedValue ? this._currencyCode : maybe(someString()),
            emailSkus: this._emailSkus !== UnassignedValue ? this._emailSkus : maybe(manyOf(function () { return exports.anEmailSkuDto().build({ buildersVisited: buildersVisited }); })),
            productsPrice: this._productsPrice !== UnassignedValue ? this._productsPrice : maybe(jsonMapOf(function () { return exports.aStoreMailboxProductPricesDto().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return GetPackagePickerPricingResponseDTOBuilder;
}());
exports.GetPackagePickerPricingResponseDTOBuilder = GetPackagePickerPricingResponseDTOBuilder;
var GetProductDisplayAttributesRequestDTOBuilder = /** @class */ (function () {
    function GetProductDisplayAttributesRequestDTOBuilder() {
        this._languageCode = UnassignedValue;
        this._offeringId = UnassignedValue;
        this._productId = UnassignedValue;
    }
    GetProductDisplayAttributesRequestDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    GetProductDisplayAttributesRequestDTOBuilder.prototype.withOfferingId = function (_offeringId) {
        this._offeringId = _offeringId;
        return this;
    };
    GetProductDisplayAttributesRequestDTOBuilder.prototype.withLanguageCode = function (_languageCode) {
        this._languageCode = _languageCode;
        return this;
    };
    GetProductDisplayAttributesRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetProductDisplayAttributesRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            languageCode: this._languageCode !== UnassignedValue ? this._languageCode : maybe(someString()),
            offeringId: this._offeringId !== UnassignedValue ? this._offeringId : maybe(someGuid()),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
        };
    };
    return GetProductDisplayAttributesRequestDTOBuilder;
}());
exports.GetProductDisplayAttributesRequestDTOBuilder = GetProductDisplayAttributesRequestDTOBuilder;
var GetProductDisplayAttributesResponseDTOBuilder = /** @class */ (function () {
    function GetProductDisplayAttributesResponseDTOBuilder() {
        this._productDisplayAttributes = UnassignedValue;
    }
    GetProductDisplayAttributesResponseDTOBuilder.prototype.withProductDisplayAttributes = function (_productDisplayAttributes) {
        this._productDisplayAttributes = _productDisplayAttributes;
        return this;
    };
    GetProductDisplayAttributesResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetProductDisplayAttributesResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            productDisplayAttributes: this._productDisplayAttributes !== UnassignedValue ? this._productDisplayAttributes : maybe(exports.aProductDisplayAttributes().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetProductDisplayAttributesResponseDTOBuilder;
}());
exports.GetProductDisplayAttributesResponseDTOBuilder = GetProductDisplayAttributesResponseDTOBuilder;
var GetProductInfoRequestDTOBuilder = /** @class */ (function () {
    function GetProductInfoRequestDTOBuilder() {
        this._cycle = UnassignedValue;
        this._offeringId = UnassignedValue;
        this._productId = UnassignedValue;
    }
    GetProductInfoRequestDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    GetProductInfoRequestDTOBuilder.prototype.withCycle = function (_cycle) {
        this._cycle = _cycle;
        return this;
    };
    GetProductInfoRequestDTOBuilder.prototype.withOfferingId = function (_offeringId) {
        this._offeringId = _offeringId;
        return this;
    };
    GetProductInfoRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetProductInfoRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            offeringId: this._offeringId !== UnassignedValue ? this._offeringId : maybe(someGuid()),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
        };
    };
    return GetProductInfoRequestDTOBuilder;
}());
exports.GetProductInfoRequestDTOBuilder = GetProductInfoRequestDTOBuilder;
var GetProductInfoResponseDTOBuilder = /** @class */ (function () {
    function GetProductInfoResponseDTOBuilder() {
        this._productInfo = UnassignedValue;
    }
    GetProductInfoResponseDTOBuilder.prototype.withProductInfo = function (_productInfo) {
        this._productInfo = _productInfo;
        return this;
    };
    GetProductInfoResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetProductInfoResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            productInfo: this._productInfo !== UnassignedValue ? this._productInfo : maybe(exports.aProductInfo().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetProductInfoResponseDTOBuilder;
}());
exports.GetProductInfoResponseDTOBuilder = GetProductInfoResponseDTOBuilder;
var GetSaleRequestDTOBuilder = /** @class */ (function () {
    function GetSaleRequestDTOBuilder() {
        this._productTypeId = UnassignedValue;
    }
    GetSaleRequestDTOBuilder.prototype.withProductTypeId = function (_productTypeId) {
        this._productTypeId = _productTypeId;
        return this;
    };
    GetSaleRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetSaleRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            productTypeId: this._productTypeId !== UnassignedValue ? this._productTypeId : maybe(someGuid()),
        };
    };
    return GetSaleRequestDTOBuilder;
}());
exports.GetSaleRequestDTOBuilder = GetSaleRequestDTOBuilder;
var GetSaleResponseDTOBuilder = /** @class */ (function () {
    function GetSaleResponseDTOBuilder() {
        this._saleDetails = UnassignedValue;
    }
    GetSaleResponseDTOBuilder.prototype.withSaleDetails = function (_saleDetails) {
        this._saleDetails = _saleDetails;
        return this;
    };
    GetSaleResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetSaleResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            saleDetails: this._saleDetails !== UnassignedValue ? this._saleDetails : maybe(exports.aSaleDetails().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetSaleResponseDTOBuilder;
}());
exports.GetSaleResponseDTOBuilder = GetSaleResponseDTOBuilder;
var GetTaxSettingsRequestDTOBuilder = /** @class */ (function () {
    function GetTaxSettingsRequestDTOBuilder() {
    }
    GetTaxSettingsRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetTaxSettingsRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return GetTaxSettingsRequestDTOBuilder;
}());
exports.GetTaxSettingsRequestDTOBuilder = GetTaxSettingsRequestDTOBuilder;
var GetTaxSettingsResponseDTOBuilder = /** @class */ (function () {
    function GetTaxSettingsResponseDTOBuilder() {
        this._taxSettings = UnassignedValue;
    }
    GetTaxSettingsResponseDTOBuilder.prototype.withTaxSettings = function (_taxSettings) {
        this._taxSettings = _taxSettings;
        return this;
    };
    GetTaxSettingsResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetTaxSettingsResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            taxSettings: this._taxSettings !== UnassignedValue ? this._taxSettings : maybe(exports.aTaxSettings().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetTaxSettingsResponseDTOBuilder;
}());
exports.GetTaxSettingsResponseDTOBuilder = GetTaxSettingsResponseDTOBuilder;
var GetUserCouponsTypeEligibilityRequestDTOBuilder = /** @class */ (function () {
    function GetUserCouponsTypeEligibilityRequestDTOBuilder() {
        this._existingSubscriptionId = UnassignedValue;
    }
    GetUserCouponsTypeEligibilityRequestDTOBuilder.prototype.withExistingSubscriptionId = function (_existingSubscriptionId) {
        this._existingSubscriptionId = _existingSubscriptionId;
        return this;
    };
    GetUserCouponsTypeEligibilityRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetUserCouponsTypeEligibilityRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            existingSubscriptionId: this._existingSubscriptionId !== UnassignedValue ? this._existingSubscriptionId : maybe(someGuid()),
        };
    };
    return GetUserCouponsTypeEligibilityRequestDTOBuilder;
}());
exports.GetUserCouponsTypeEligibilityRequestDTOBuilder = GetUserCouponsTypeEligibilityRequestDTOBuilder;
var GetUserCouponsTypeEligibilityResponseDTOBuilder = /** @class */ (function () {
    function GetUserCouponsTypeEligibilityResponseDTOBuilder() {
        this._couponsTypeEligibility = UnassignedValue;
    }
    GetUserCouponsTypeEligibilityResponseDTOBuilder.prototype.withCouponsTypeEligibility = function (_couponsTypeEligibility) {
        this._couponsTypeEligibility = _couponsTypeEligibility;
        return this;
    };
    GetUserCouponsTypeEligibilityResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetUserCouponsTypeEligibilityResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            couponsTypeEligibility: this._couponsTypeEligibility !== UnassignedValue ? this._couponsTypeEligibility : maybe(exports.aCouponsTypeEligibility().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetUserCouponsTypeEligibilityResponseDTOBuilder;
}());
exports.GetUserCouponsTypeEligibilityResponseDTOBuilder = GetUserCouponsTypeEligibilityResponseDTOBuilder;
var GetUserOfferingRequestDTOBuilder = /** @class */ (function () {
    function GetUserOfferingRequestDTOBuilder() {
        this._biReference = UnassignedValue;
        this._billingAddress = UnassignedValue;
        this._country = UnassignedValue;
        this._currency = UnassignedValue;
        this._customOfferingFilters = UnassignedValue;
        this._eventAggregator = UnassignedValue;
        this._existingSubscriptionId = UnassignedValue;
        this._msid = UnassignedValue;
        this._productFamilyId = UnassignedValue;
        this._productTypeId = UnassignedValue;
        this._useSavedMerchantAddress = UnassignedValue;
    }
    GetUserOfferingRequestDTOBuilder.prototype.withProductTypeId = function (_productTypeId) {
        this._productTypeId = _productTypeId;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.withMsid = function (_msid) {
        this._msid = _msid;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.withBiReference = function (_biReference) {
        this._biReference = _biReference;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.withCustomOfferingFilters = function (_customOfferingFilters) {
        this._customOfferingFilters = _customOfferingFilters;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.withEventAggregator = function (_eventAggregator) {
        this._eventAggregator = _eventAggregator;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.withCurrency = function (_currency) {
        this._currency = _currency;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.withCountry = function (_country) {
        this._country = _country;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.withExistingSubscriptionId = function (_existingSubscriptionId) {
        this._existingSubscriptionId = _existingSubscriptionId;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.withProductFamilyId = function (_productFamilyId) {
        this._productFamilyId = _productFamilyId;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.withBillingAddress = function (_billingAddress) {
        this._billingAddress = _billingAddress;
        this._useSavedMerchantAddress = UnassignedValue;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.withUseSavedMerchantAddress = function (_useSavedMerchantAddress) {
        this._useSavedMerchantAddress = _useSavedMerchantAddress;
        this._billingAddress = UnassignedValue;
        return this;
    };
    GetUserOfferingRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetUserOfferingRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._billingAddress === UnassignedValue && this._useSavedMerchantAddress === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['billingAddress', 'useSavedMerchantAddress'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 2), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                biReference: this._biReference !== UnassignedValue ? this._biReference : maybe(someString()),
                billingAddress: assignRandomOneOf('billingAddress', maybe(exports.aBillingAddress().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                country: this._country !== UnassignedValue ? this._country : maybe(countryString()),
                currency: this._currency !== UnassignedValue ? this._currency : maybe(someString()),
                customOfferingFilters: this._customOfferingFilters !== UnassignedValue ? this._customOfferingFilters : maybe(jsonMapOf(function () { return someString(); })),
                eventAggregator: this._eventAggregator !== UnassignedValue ? this._eventAggregator : maybe(someString()),
                existingSubscriptionId: this._existingSubscriptionId !== UnassignedValue ? this._existingSubscriptionId : maybe(someGuid()),
                msid: this._msid !== UnassignedValue ? this._msid : maybe(someString()),
                productFamilyId: this._productFamilyId !== UnassignedValue ? this._productFamilyId : maybe(someGuid()),
                productTypeId: this._productTypeId !== UnassignedValue ? this._productTypeId : maybe(someGuid()),
                useSavedMerchantAddress: assignRandomOneOf('useSavedMerchantAddress', maybe(someBoolean()), oneOfFieldsToUnAssign),
            };
        }
        return {
            biReference: this._biReference !== UnassignedValue ? this._biReference : maybe(someString()),
            billingAddress: this._billingAddress === UnassignedValue ? undefined : this._billingAddress,
            country: this._country !== UnassignedValue ? this._country : maybe(countryString()),
            currency: this._currency !== UnassignedValue ? this._currency : maybe(someString()),
            customOfferingFilters: this._customOfferingFilters !== UnassignedValue ? this._customOfferingFilters : maybe(jsonMapOf(function () { return someString(); })),
            eventAggregator: this._eventAggregator !== UnassignedValue ? this._eventAggregator : maybe(someString()),
            existingSubscriptionId: this._existingSubscriptionId !== UnassignedValue ? this._existingSubscriptionId : maybe(someGuid()),
            msid: this._msid !== UnassignedValue ? this._msid : maybe(someString()),
            productFamilyId: this._productFamilyId !== UnassignedValue ? this._productFamilyId : maybe(someGuid()),
            productTypeId: this._productTypeId !== UnassignedValue ? this._productTypeId : maybe(someGuid()),
            useSavedMerchantAddress: this._useSavedMerchantAddress === UnassignedValue ? undefined : this._useSavedMerchantAddress,
        };
    };
    return GetUserOfferingRequestDTOBuilder;
}());
exports.GetUserOfferingRequestDTOBuilder = GetUserOfferingRequestDTOBuilder;
var GetUserOfferingResponseDTOBuilder = /** @class */ (function () {
    function GetUserOfferingResponseDTOBuilder() {
        this._currencySettings = UnassignedValue;
        this._currentSubscriptionInfo = UnassignedValue;
        this._displayProperties = UnassignedValue;
        this._eventAggregator = UnassignedValue;
        this._freeTrialEligibility = UnassignedValue;
        this._offerValidUntil = UnassignedValue;
        this._products = UnassignedValue;
        this._purchaseScenario = UnassignedValue;
        this._saleType = UnassignedValue;
        this._taxSettings = UnassignedValue;
    }
    GetUserOfferingResponseDTOBuilder.prototype.withProducts = function (_products) {
        this._products = _products;
        return this;
    };
    GetUserOfferingResponseDTOBuilder.prototype.withCurrencySettings = function (_currencySettings) {
        this._currencySettings = _currencySettings;
        return this;
    };
    GetUserOfferingResponseDTOBuilder.prototype.withDisplayProperties = function (_displayProperties) {
        this._displayProperties = _displayProperties;
        return this;
    };
    GetUserOfferingResponseDTOBuilder.prototype.withCurrentSubscriptionInfo = function (_currentSubscriptionInfo) {
        this._currentSubscriptionInfo = _currentSubscriptionInfo;
        return this;
    };
    GetUserOfferingResponseDTOBuilder.prototype.withPurchaseScenario = function (_purchaseScenario) {
        this._purchaseScenario = _purchaseScenario;
        return this;
    };
    GetUserOfferingResponseDTOBuilder.prototype.withEventAggregator = function (_eventAggregator) {
        this._eventAggregator = _eventAggregator;
        return this;
    };
    GetUserOfferingResponseDTOBuilder.prototype.withOfferValidUntil = function (_offerValidUntil) {
        this._offerValidUntil = _offerValidUntil;
        return this;
    };
    GetUserOfferingResponseDTOBuilder.prototype.withTaxSettings = function (_taxSettings) {
        this._taxSettings = _taxSettings;
        return this;
    };
    GetUserOfferingResponseDTOBuilder.prototype.withFreeTrialEligibility = function (_freeTrialEligibility) {
        this._freeTrialEligibility = _freeTrialEligibility;
        return this;
    };
    GetUserOfferingResponseDTOBuilder.prototype.withSaleType = function (_saleType) {
        this._saleType = _saleType;
        return this;
    };
    GetUserOfferingResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'GetUserOfferingResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currencySettings: this._currencySettings !== UnassignedValue ? this._currencySettings : maybe(exports.aCurrencySettings().build({ buildersVisited: buildersVisited })),
            currentSubscriptionInfo: this._currentSubscriptionInfo !== UnassignedValue ? this._currentSubscriptionInfo : maybe(exports.aCurrentSubscriptionInfo().build({ buildersVisited: buildersVisited })),
            displayProperties: this._displayProperties !== UnassignedValue ? this._displayProperties : maybe(jsonMapOf(function () { return someString(); })),
            eventAggregator: this._eventAggregator !== UnassignedValue ? this._eventAggregator : maybe(someString()),
            freeTrialEligibility: this._freeTrialEligibility !== UnassignedValue ? this._freeTrialEligibility : maybe(exports.aFreeTrialEligibility().build({ buildersVisited: buildersVisited })),
            offerValidUntil: this._offerValidUntil !== UnassignedValue ? this._offerValidUntil : maybe(someDateString()),
            products: this._products !== UnassignedValue ? this._products : maybe(manyOf(function () { return exports.aProductInfo().build({ buildersVisited: buildersVisited }); })),
            purchaseScenario: this._purchaseScenario !== UnassignedValue ? this._purchaseScenario : maybe(exports.aPurchaseScenario().build({ buildersVisited: buildersVisited })),
            saleType: this._saleType !== UnassignedValue ? this._saleType : maybe(someString()),
            taxSettings: this._taxSettings !== UnassignedValue ? this._taxSettings : maybe(exports.aTaxSettings().build({ buildersVisited: buildersVisited })),
        };
    };
    return GetUserOfferingResponseDTOBuilder;
}());
exports.GetUserOfferingResponseDTOBuilder = GetUserOfferingResponseDTOBuilder;
var ImageDTOBuilder = /** @class */ (function () {
    function ImageDTOBuilder() {
        this._filename = UnassignedValue;
        this._height = UnassignedValue;
        this._id = UnassignedValue;
        this._url = UnassignedValue;
        this._width = UnassignedValue;
    }
    ImageDTOBuilder.prototype.withId = function (_id) {
        this._id = _id;
        return this;
    };
    ImageDTOBuilder.prototype.withUrl = function (_url) {
        this._url = _url;
        return this;
    };
    ImageDTOBuilder.prototype.withHeight = function (_height) {
        this._height = _height;
        return this;
    };
    ImageDTOBuilder.prototype.withWidth = function (_width) {
        this._width = _width;
        return this;
    };
    ImageDTOBuilder.prototype.withFilename = function (_filename) {
        this._filename = _filename;
        return this;
    };
    ImageDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Image', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            filename: this._filename !== UnassignedValue ? this._filename : maybe(someString()),
            height: this._height !== UnassignedValue ? this._height : maybe(someInt()),
            id: this._id !== UnassignedValue ? this._id : maybe(someString()),
            url: this._url !== UnassignedValue ? this._url : maybe(someString()),
            width: this._width !== UnassignedValue ? this._width : maybe(someInt()),
        };
    };
    return ImageDTOBuilder;
}());
exports.ImageDTOBuilder = ImageDTOBuilder;
var IntervalDTOBuilder = /** @class */ (function () {
    function IntervalDTOBuilder() {
        this._count = UnassignedValue;
        this._unit = UnassignedValue;
    }
    IntervalDTOBuilder.prototype.withUnit = function (_unit) {
        this._unit = _unit;
        return this;
    };
    IntervalDTOBuilder.prototype.withCount = function (_count) {
        this._count = _count;
        return this;
    };
    IntervalDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Interval', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            count: this._count !== UnassignedValue ? this._count : maybe(someInt()),
            unit: this._unit !== UnassignedValue ? this._unit : maybe(exports.anIntervalUnit().build({ buildersVisited: buildersVisited })),
        };
    };
    return IntervalDTOBuilder;
}());
exports.IntervalDTOBuilder = IntervalDTOBuilder;
var IntervalUnitDTOBuilder = /** @class */ (function () {
    function IntervalUnitDTOBuilder() {
    }
    IntervalUnitDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.IntervalUnit.UNKNOWN, types_1.IntervalUnit.DAY, types_1.IntervalUnit.WEEK, types_1.IntervalUnit.MONTH, types_1.IntervalUnit.YEAR]);
    };
    return IntervalUnitDTOBuilder;
}());
exports.IntervalUnitDTOBuilder = IntervalUnitDTOBuilder;
var ItemDTOBuilder = /** @class */ (function () {
    function ItemDTOBuilder() {
        this._catalogReference = UnassignedValue;
        this._data = UnassignedValue;
    }
    ItemDTOBuilder.prototype.withCatalogReference = function (_catalogReference) {
        this._catalogReference = _catalogReference;
        return this;
    };
    ItemDTOBuilder.prototype.withData = function (_data) {
        this._data = _data;
        return this;
    };
    ItemDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Item', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            catalogReference: this._catalogReference !== UnassignedValue ? this._catalogReference : maybe(exports.aCatalogReference().build({ buildersVisited: buildersVisited })),
            data: this._data !== UnassignedValue ? this._data : maybe(exports.anItemData().build({ buildersVisited: buildersVisited })),
        };
    };
    return ItemDTOBuilder;
}());
exports.ItemDTOBuilder = ItemDTOBuilder;
var ItemDataDTOBuilder = /** @class */ (function () {
    function ItemDataDTOBuilder() {
        this._description = UnassignedValue;
        this._image = UnassignedValue;
        this._price = UnassignedValue;
        this._productName = UnassignedValue;
        this._quantityAvailable = UnassignedValue;
    }
    ItemDataDTOBuilder.prototype.withPrice = function (_price) {
        this._price = _price;
        return this;
    };
    ItemDataDTOBuilder.prototype.withImage = function (_image) {
        this._image = _image;
        return this;
    };
    ItemDataDTOBuilder.prototype.withProductName = function (_productName) {
        this._productName = _productName;
        return this;
    };
    ItemDataDTOBuilder.prototype.withDescription = function (_description) {
        this._description = _description;
        return this;
    };
    ItemDataDTOBuilder.prototype.withQuantityAvailable = function (_quantityAvailable) {
        this._quantityAvailable = _quantityAvailable;
        return this;
    };
    ItemDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ItemData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            description: this._description !== UnassignedValue ? this._description : maybe(exports.aMultiLingualText().build({ buildersVisited: buildersVisited })),
            image: this._image !== UnassignedValue ? this._image : maybe(exports.anImage().build({ buildersVisited: buildersVisited })),
            price: this._price !== UnassignedValue ? this._price : maybe(decimalValueString()),
            productName: this._productName !== UnassignedValue ? this._productName : maybe(exports.aMultiLingualText().build({ buildersVisited: buildersVisited })),
            quantityAvailable: this._quantityAvailable !== UnassignedValue ? this._quantityAvailable : maybe(someInt()),
        };
    };
    return ItemDataDTOBuilder;
}());
exports.ItemDataDTOBuilder = ItemDataDTOBuilder;
var LineItemDTOBuilder = /** @class */ (function () {
    function LineItemDTOBuilder() {
        this._additionalData = UnassignedValue;
        this._customOfferingFilters = UnassignedValue;
        this._cycle = UnassignedValue;
        this._freeTrial = UnassignedValue;
        this._newSubscription = UnassignedValue;
        this._nonCouponUsage = UnassignedValue;
        this._overridePrice = UnassignedValue;
        this._productCoupon = UnassignedValue;
        this._productId = UnassignedValue;
        this._quantity = UnassignedValue;
        this._saleCoupon = UnassignedValue;
        this._switchContract = UnassignedValue;
        this._upgradeSubscription = UnassignedValue;
        this._userCoupon = UnassignedValue;
    }
    LineItemDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    LineItemDTOBuilder.prototype.withCycle = function (_cycle) {
        this._cycle = _cycle;
        return this;
    };
    LineItemDTOBuilder.prototype.withQuantity = function (_quantity) {
        this._quantity = _quantity;
        return this;
    };
    LineItemDTOBuilder.prototype.withAdditionalData = function (_additionalData) {
        this._additionalData = _additionalData;
        return this;
    };
    LineItemDTOBuilder.prototype.withOverridePrice = function (_overridePrice) {
        this._overridePrice = _overridePrice;
        return this;
    };
    LineItemDTOBuilder.prototype.withFreeTrial = function (_freeTrial) {
        this._freeTrial = _freeTrial;
        return this;
    };
    LineItemDTOBuilder.prototype.withCustomOfferingFilters = function (_customOfferingFilters) {
        this._customOfferingFilters = _customOfferingFilters;
        return this;
    };
    LineItemDTOBuilder.prototype.withNewSubscription = function (_newSubscription) {
        this._newSubscription = _newSubscription;
        this._upgradeSubscription = UnassignedValue;
        this._switchContract = UnassignedValue;
        return this;
    };
    LineItemDTOBuilder.prototype.withUpgradeSubscription = function (_upgradeSubscription) {
        this._upgradeSubscription = _upgradeSubscription;
        this._newSubscription = UnassignedValue;
        this._switchContract = UnassignedValue;
        return this;
    };
    LineItemDTOBuilder.prototype.withSwitchContract = function (_switchContract) {
        this._switchContract = _switchContract;
        this._newSubscription = UnassignedValue;
        this._upgradeSubscription = UnassignedValue;
        return this;
    };
    LineItemDTOBuilder.prototype.withSaleCoupon = function (_saleCoupon) {
        this._saleCoupon = _saleCoupon;
        this._userCoupon = UnassignedValue;
        this._productCoupon = UnassignedValue;
        this._nonCouponUsage = UnassignedValue;
        return this;
    };
    LineItemDTOBuilder.prototype.withUserCoupon = function (_userCoupon) {
        this._userCoupon = _userCoupon;
        this._saleCoupon = UnassignedValue;
        this._productCoupon = UnassignedValue;
        this._nonCouponUsage = UnassignedValue;
        return this;
    };
    LineItemDTOBuilder.prototype.withProductCoupon = function (_productCoupon) {
        this._productCoupon = _productCoupon;
        this._saleCoupon = UnassignedValue;
        this._userCoupon = UnassignedValue;
        this._nonCouponUsage = UnassignedValue;
        return this;
    };
    LineItemDTOBuilder.prototype.withNonCouponUsage = function (_nonCouponUsage) {
        this._nonCouponUsage = _nonCouponUsage;
        this._saleCoupon = UnassignedValue;
        this._userCoupon = UnassignedValue;
        this._productCoupon = UnassignedValue;
        return this;
    };
    LineItemDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'LineItem', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._newSubscription === UnassignedValue &&
            this._upgradeSubscription === UnassignedValue &&
            this._switchContract === UnassignedValue &&
            this._saleCoupon === UnassignedValue &&
            this._userCoupon === UnassignedValue &&
            this._productCoupon === UnassignedValue &&
            this._nonCouponUsage === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['newSubscription', 'upgradeSubscription', 'switchContract', 'saleCoupon', 'userCoupon', 'productCoupon', 'nonCouponUsage'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 7), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                additionalData: this._additionalData !== UnassignedValue ? this._additionalData : maybe(jsonMapOf(function () { return someString(); })),
                customOfferingFilters: this._customOfferingFilters !== UnassignedValue ? this._customOfferingFilters : maybe(jsonMapOf(function () { return someString(); })),
                cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
                freeTrial: this._freeTrial !== UnassignedValue ? this._freeTrial : maybe(someBoolean()),
                newSubscription: assignRandomOneOf('newSubscription', maybe(exports.aNewSubscription().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                nonCouponUsage: assignRandomOneOf('nonCouponUsage', maybe(exports.aNonCouponUsage().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                overridePrice: this._overridePrice !== UnassignedValue ? this._overridePrice : maybe(decimalValueString()),
                productCoupon: assignRandomOneOf('productCoupon', maybe(exports.aProductCoupon().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
                quantity: this._quantity !== UnassignedValue ? this._quantity : maybe(randomInt(1, 1000000)),
                saleCoupon: assignRandomOneOf('saleCoupon', maybe(exports.aSaleCoupon().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                switchContract: assignRandomOneOf('switchContract', maybe(exports.aSwitchContract().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                upgradeSubscription: assignRandomOneOf('upgradeSubscription', maybe(exports.anUpgradeSubscription().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                userCoupon: assignRandomOneOf('userCoupon', maybe(exports.anUserCoupon().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            additionalData: this._additionalData !== UnassignedValue ? this._additionalData : maybe(jsonMapOf(function () { return someString(); })),
            customOfferingFilters: this._customOfferingFilters !== UnassignedValue ? this._customOfferingFilters : maybe(jsonMapOf(function () { return someString(); })),
            cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            freeTrial: this._freeTrial !== UnassignedValue ? this._freeTrial : maybe(someBoolean()),
            newSubscription: this._newSubscription === UnassignedValue ? undefined : this._newSubscription,
            nonCouponUsage: this._nonCouponUsage === UnassignedValue ? undefined : this._nonCouponUsage,
            overridePrice: this._overridePrice !== UnassignedValue ? this._overridePrice : maybe(decimalValueString()),
            productCoupon: this._productCoupon === UnassignedValue ? undefined : this._productCoupon,
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
            quantity: this._quantity !== UnassignedValue ? this._quantity : maybe(randomInt(1, 1000000)),
            saleCoupon: this._saleCoupon === UnassignedValue ? undefined : this._saleCoupon,
            switchContract: this._switchContract === UnassignedValue ? undefined : this._switchContract,
            upgradeSubscription: this._upgradeSubscription === UnassignedValue ? undefined : this._upgradeSubscription,
            userCoupon: this._userCoupon === UnassignedValue ? undefined : this._userCoupon,
        };
    };
    return LineItemDTOBuilder;
}());
exports.LineItemDTOBuilder = LineItemDTOBuilder;
var LineItemEntryDTOBuilder = /** @class */ (function () {
    function LineItemEntryDTOBuilder() {
        this._id = UnassignedValue;
        this._lineItem = UnassignedValue;
    }
    LineItemEntryDTOBuilder.prototype.withId = function (_id) {
        this._id = _id;
        return this;
    };
    LineItemEntryDTOBuilder.prototype.withLineItem = function (_lineItem) {
        this._lineItem = _lineItem;
        return this;
    };
    LineItemEntryDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'LineItemEntry', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            id: this._id !== UnassignedValue ? this._id : maybe(someGuid()),
            lineItem: this._lineItem !== UnassignedValue ? this._lineItem : maybe(exports.aLineItem().build({ buildersVisited: buildersVisited })),
        };
    };
    return LineItemEntryDTOBuilder;
}());
exports.LineItemEntryDTOBuilder = LineItemEntryDTOBuilder;
var LineItemPricesDTOBuilder = /** @class */ (function () {
    function LineItemPricesDTOBuilder() {
        this._amounts = UnassignedValue;
        this._lineItemId = UnassignedValue;
        this._personalCoupon = UnassignedValue;
        this._purchaseRule = UnassignedValue;
        this._sale = UnassignedValue;
    }
    LineItemPricesDTOBuilder.prototype.withLineItemId = function (_lineItemId) {
        this._lineItemId = _lineItemId;
        return this;
    };
    LineItemPricesDTOBuilder.prototype.withAmounts = function (_amounts) {
        this._amounts = _amounts;
        return this;
    };
    LineItemPricesDTOBuilder.prototype.withSale = function (_sale) {
        this._sale = _sale;
        this._personalCoupon = UnassignedValue;
        this._purchaseRule = UnassignedValue;
        return this;
    };
    LineItemPricesDTOBuilder.prototype.withPersonalCoupon = function (_personalCoupon) {
        this._personalCoupon = _personalCoupon;
        this._sale = UnassignedValue;
        this._purchaseRule = UnassignedValue;
        return this;
    };
    LineItemPricesDTOBuilder.prototype.withPurchaseRule = function (_purchaseRule) {
        this._purchaseRule = _purchaseRule;
        this._sale = UnassignedValue;
        this._personalCoupon = UnassignedValue;
        return this;
    };
    LineItemPricesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'LineItemPrices', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        var noOneOfFieldIsAssigned = this._sale === UnassignedValue && this._personalCoupon === UnassignedValue && this._purchaseRule === UnassignedValue;
        if (noOneOfFieldIsAssigned) {
            var oneOfFieldsToUnAssign = ['sale', 'personalCoupon', 'purchaseRule'];
            oneOfFieldsToUnAssign.splice(Math.floor(Math.random() * 3), 1);
            var assignRandomOneOf = function (fieldName, builder, oneOfFieldsToUnAssign) {
                var shouldSkipThisField = oneOfFieldsToUnAssign.includes(fieldName);
                var shouldReturnBuilder = process.env.TEST_ALWAYS_RETURN_BUILDER;
                if (shouldSkipThisField && !shouldReturnBuilder) {
                    return undefined;
                }
                return builder;
            };
            return {
                amounts: this._amounts !== UnassignedValue ? this._amounts : maybe(exports.aPriceAmounts().build({ buildersVisited: buildersVisited })),
                lineItemId: this._lineItemId !== UnassignedValue ? this._lineItemId : maybe(someGuid()),
                personalCoupon: assignRandomOneOf('personalCoupon', maybe(exports.aPersonalCoupon().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                purchaseRule: assignRandomOneOf('purchaseRule', maybe(exports.aPurchaseRule().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
                sale: assignRandomOneOf('sale', maybe(exports.aSale().build({ buildersVisited: buildersVisited })), oneOfFieldsToUnAssign),
            };
        }
        return {
            amounts: this._amounts !== UnassignedValue ? this._amounts : maybe(exports.aPriceAmounts().build({ buildersVisited: buildersVisited })),
            lineItemId: this._lineItemId !== UnassignedValue ? this._lineItemId : maybe(someGuid()),
            personalCoupon: this._personalCoupon === UnassignedValue ? undefined : this._personalCoupon,
            purchaseRule: this._purchaseRule === UnassignedValue ? undefined : this._purchaseRule,
            sale: this._sale === UnassignedValue ? undefined : this._sale,
        };
    };
    return LineItemPricesDTOBuilder;
}());
exports.LineItemPricesDTOBuilder = LineItemPricesDTOBuilder;
var ListDigitalGoodsPricesRequestDTOBuilder = /** @class */ (function () {
    function ListDigitalGoodsPricesRequestDTOBuilder() {
        this._skuIds = UnassignedValue;
    }
    ListDigitalGoodsPricesRequestDTOBuilder.prototype.withSkuIds = function (_skuIds) {
        this._skuIds = _skuIds;
        return this;
    };
    ListDigitalGoodsPricesRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListDigitalGoodsPricesRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            skuIds: this._skuIds !== UnassignedValue ? this._skuIds : maybe(boundedManyOf(1, 3, function () { return someGuid(); })),
        };
    };
    return ListDigitalGoodsPricesRequestDTOBuilder;
}());
exports.ListDigitalGoodsPricesRequestDTOBuilder = ListDigitalGoodsPricesRequestDTOBuilder;
var ListDigitalGoodsPricesResponseDTOBuilder = /** @class */ (function () {
    function ListDigitalGoodsPricesResponseDTOBuilder() {
        this._currencySettings = UnassignedValue;
        this._digitalGoodsPrices = UnassignedValue;
        this._taxSettings = UnassignedValue;
    }
    ListDigitalGoodsPricesResponseDTOBuilder.prototype.withDigitalGoodsPrices = function (_digitalGoodsPrices) {
        this._digitalGoodsPrices = _digitalGoodsPrices;
        return this;
    };
    ListDigitalGoodsPricesResponseDTOBuilder.prototype.withCurrencySettings = function (_currencySettings) {
        this._currencySettings = _currencySettings;
        return this;
    };
    ListDigitalGoodsPricesResponseDTOBuilder.prototype.withTaxSettings = function (_taxSettings) {
        this._taxSettings = _taxSettings;
        return this;
    };
    ListDigitalGoodsPricesResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListDigitalGoodsPricesResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currencySettings: this._currencySettings !== UnassignedValue ? this._currencySettings : maybe(exports.aCurrencySettings().build({ buildersVisited: buildersVisited })),
            digitalGoodsPrices: this._digitalGoodsPrices !== UnassignedValue ? this._digitalGoodsPrices : maybe(manyOf(function () { return exports.aDigitalGoodsPrice().build({ buildersVisited: buildersVisited }); })),
            taxSettings: this._taxSettings !== UnassignedValue ? this._taxSettings : maybe(exports.aTaxSettings().build({ buildersVisited: buildersVisited })),
        };
    };
    return ListDigitalGoodsPricesResponseDTOBuilder;
}());
exports.ListDigitalGoodsPricesResponseDTOBuilder = ListDigitalGoodsPricesResponseDTOBuilder;
var ListLineItemsPricesRequestDTOBuilder = /** @class */ (function () {
    function ListLineItemsPricesRequestDTOBuilder() {
        this._currency = UnassignedValue;
        this._lineItems = UnassignedValue;
    }
    ListLineItemsPricesRequestDTOBuilder.prototype.withLineItems = function (_lineItems) {
        this._lineItems = _lineItems;
        return this;
    };
    ListLineItemsPricesRequestDTOBuilder.prototype.withCurrency = function (_currency) {
        this._currency = _currency;
        return this;
    };
    ListLineItemsPricesRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListLineItemsPricesRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currency: this._currency !== UnassignedValue ? this._currency : maybe(currencyString()),
            lineItems: this._lineItems !== UnassignedValue ? this._lineItems : maybe(boundedManyOf(1, 3, function () { return exports.aLineItemEntry().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ListLineItemsPricesRequestDTOBuilder;
}());
exports.ListLineItemsPricesRequestDTOBuilder = ListLineItemsPricesRequestDTOBuilder;
var ListLineItemsPricesResponseDTOBuilder = /** @class */ (function () {
    function ListLineItemsPricesResponseDTOBuilder() {
        this._productsPrices = UnassignedValue;
        this._totalAmounts = UnassignedValue;
    }
    ListLineItemsPricesResponseDTOBuilder.prototype.withProductsPrices = function (_productsPrices) {
        this._productsPrices = _productsPrices;
        return this;
    };
    ListLineItemsPricesResponseDTOBuilder.prototype.withTotalAmounts = function (_totalAmounts) {
        this._totalAmounts = _totalAmounts;
        return this;
    };
    ListLineItemsPricesResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListLineItemsPricesResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            productsPrices: this._productsPrices !== UnassignedValue ? this._productsPrices : maybe(boundedManyOf(1, 3, function () { return exports.aLineItemPrices().build({ buildersVisited: buildersVisited }); })),
            totalAmounts: this._totalAmounts !== UnassignedValue ? this._totalAmounts : maybe(exports.aPriceAmounts().build({ buildersVisited: buildersVisited })),
        };
    };
    return ListLineItemsPricesResponseDTOBuilder;
}());
exports.ListLineItemsPricesResponseDTOBuilder = ListLineItemsPricesResponseDTOBuilder;
var ListPremiumProductCatalogPricesRequestDTOBuilder = /** @class */ (function () {
    function ListPremiumProductCatalogPricesRequestDTOBuilder() {
        this._ignoreDiscountPrices = UnassignedValue;
        this._products = UnassignedValue;
        this._useSaleCoupons = UnassignedValue;
        this._useSiteLevelCoupons = UnassignedValue;
    }
    ListPremiumProductCatalogPricesRequestDTOBuilder.prototype.withProducts = function (_products) {
        this._products = _products;
        return this;
    };
    ListPremiumProductCatalogPricesRequestDTOBuilder.prototype.withIgnoreDiscountPrices = function (_ignoreDiscountPrices) {
        this._ignoreDiscountPrices = _ignoreDiscountPrices;
        return this;
    };
    ListPremiumProductCatalogPricesRequestDTOBuilder.prototype.withUseSiteLevelCoupons = function (_useSiteLevelCoupons) {
        this._useSiteLevelCoupons = _useSiteLevelCoupons;
        return this;
    };
    ListPremiumProductCatalogPricesRequestDTOBuilder.prototype.withUseSaleCoupons = function (_useSaleCoupons) {
        this._useSaleCoupons = _useSaleCoupons;
        return this;
    };
    ListPremiumProductCatalogPricesRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListPremiumProductCatalogPricesRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            ignoreDiscountPrices: this._ignoreDiscountPrices !== UnassignedValue ? this._ignoreDiscountPrices : maybe(someBoolean()),
            products: this._products !== UnassignedValue ? this._products : maybe(boundedManyOf(1, 3, function () { return exports.aProduct().build({ buildersVisited: buildersVisited }); })),
            useSaleCoupons: this._useSaleCoupons !== UnassignedValue ? this._useSaleCoupons : maybe(someBoolean()),
            useSiteLevelCoupons: this._useSiteLevelCoupons !== UnassignedValue ? this._useSiteLevelCoupons : maybe(someBoolean()),
        };
    };
    return ListPremiumProductCatalogPricesRequestDTOBuilder;
}());
exports.ListPremiumProductCatalogPricesRequestDTOBuilder = ListPremiumProductCatalogPricesRequestDTOBuilder;
var ListPremiumProductCatalogPricesResponseDTOBuilder = /** @class */ (function () {
    function ListPremiumProductCatalogPricesResponseDTOBuilder() {
        this._currencySettings = UnassignedValue;
        this._productPrices = UnassignedValue;
        this._taxSettings = UnassignedValue;
    }
    ListPremiumProductCatalogPricesResponseDTOBuilder.prototype.withProductPrices = function (_productPrices) {
        this._productPrices = _productPrices;
        return this;
    };
    ListPremiumProductCatalogPricesResponseDTOBuilder.prototype.withCurrencySettings = function (_currencySettings) {
        this._currencySettings = _currencySettings;
        return this;
    };
    ListPremiumProductCatalogPricesResponseDTOBuilder.prototype.withTaxSettings = function (_taxSettings) {
        this._taxSettings = _taxSettings;
        return this;
    };
    ListPremiumProductCatalogPricesResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListPremiumProductCatalogPricesResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currencySettings: this._currencySettings !== UnassignedValue ? this._currencySettings : maybe(exports.aCurrencySettings().build({ buildersVisited: buildersVisited })),
            productPrices: this._productPrices !== UnassignedValue ? this._productPrices : maybe(manyOf(function () { return exports.aPremiumProductCatalogProductPrices().build({ buildersVisited: buildersVisited }); })),
            taxSettings: this._taxSettings !== UnassignedValue ? this._taxSettings : maybe(exports.aTaxSettings().build({ buildersVisited: buildersVisited })),
        };
    };
    return ListPremiumProductCatalogPricesResponseDTOBuilder;
}());
exports.ListPremiumProductCatalogPricesResponseDTOBuilder = ListPremiumProductCatalogPricesResponseDTOBuilder;
var ListProductPricesRequestDTOBuilder = /** @class */ (function () {
    function ListProductPricesRequestDTOBuilder() {
        this._ignoreDiscountPrices = UnassignedValue;
        this._requestedProducts = UnassignedValue;
        this._useSaleCoupons = UnassignedValue;
        this._useSiteLevelCoupons = UnassignedValue;
    }
    ListProductPricesRequestDTOBuilder.prototype.withRequestedProducts = function (_requestedProducts) {
        this._requestedProducts = _requestedProducts;
        return this;
    };
    ListProductPricesRequestDTOBuilder.prototype.withIgnoreDiscountPrices = function (_ignoreDiscountPrices) {
        this._ignoreDiscountPrices = _ignoreDiscountPrices;
        return this;
    };
    ListProductPricesRequestDTOBuilder.prototype.withUseSiteLevelCoupons = function (_useSiteLevelCoupons) {
        this._useSiteLevelCoupons = _useSiteLevelCoupons;
        return this;
    };
    ListProductPricesRequestDTOBuilder.prototype.withUseSaleCoupons = function (_useSaleCoupons) {
        this._useSaleCoupons = _useSaleCoupons;
        return this;
    };
    ListProductPricesRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListProductPricesRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            ignoreDiscountPrices: this._ignoreDiscountPrices !== UnassignedValue ? this._ignoreDiscountPrices : maybe(someBoolean()),
            requestedProducts: this._requestedProducts !== UnassignedValue ? this._requestedProducts : maybe(boundedManyOf(1, 3, function () { return exports.aRequestedProduct().build({ buildersVisited: buildersVisited }); })),
            useSaleCoupons: this._useSaleCoupons !== UnassignedValue ? this._useSaleCoupons : maybe(someBoolean()),
            useSiteLevelCoupons: this._useSiteLevelCoupons !== UnassignedValue ? this._useSiteLevelCoupons : maybe(someBoolean()),
        };
    };
    return ListProductPricesRequestDTOBuilder;
}());
exports.ListProductPricesRequestDTOBuilder = ListProductPricesRequestDTOBuilder;
var ListProductPricesResponseDTOBuilder = /** @class */ (function () {
    function ListProductPricesResponseDTOBuilder() {
        this._currencySettings = UnassignedValue;
        this._productPrices = UnassignedValue;
        this._taxSettings = UnassignedValue;
    }
    ListProductPricesResponseDTOBuilder.prototype.withProductPrices = function (_productPrices) {
        this._productPrices = _productPrices;
        return this;
    };
    ListProductPricesResponseDTOBuilder.prototype.withCurrencySettings = function (_currencySettings) {
        this._currencySettings = _currencySettings;
        return this;
    };
    ListProductPricesResponseDTOBuilder.prototype.withTaxSettings = function (_taxSettings) {
        this._taxSettings = _taxSettings;
        return this;
    };
    ListProductPricesResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListProductPricesResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currencySettings: this._currencySettings !== UnassignedValue ? this._currencySettings : maybe(exports.aCurrencySettings().build({ buildersVisited: buildersVisited })),
            productPrices: this._productPrices !== UnassignedValue ? this._productPrices : maybe(manyOf(function () { return exports.aProductPrices().build({ buildersVisited: buildersVisited }); })),
            taxSettings: this._taxSettings !== UnassignedValue ? this._taxSettings : maybe(exports.aTaxSettings().build({ buildersVisited: buildersVisited })),
        };
    };
    return ListProductPricesResponseDTOBuilder;
}());
exports.ListProductPricesResponseDTOBuilder = ListProductPricesResponseDTOBuilder;
var ListTpaPricesRequestDTOBuilder = /** @class */ (function () {
    function ListTpaPricesRequestDTOBuilder() {
        this._countryCode = UnassignedValue;
        this._currency = UnassignedValue;
        this._requestedApplications = UnassignedValue;
    }
    ListTpaPricesRequestDTOBuilder.prototype.withRequestedApplications = function (_requestedApplications) {
        this._requestedApplications = _requestedApplications;
        return this;
    };
    ListTpaPricesRequestDTOBuilder.prototype.withCountryCode = function (_countryCode) {
        this._countryCode = _countryCode;
        return this;
    };
    ListTpaPricesRequestDTOBuilder.prototype.withCurrency = function (_currency) {
        this._currency = _currency;
        return this;
    };
    ListTpaPricesRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListTpaPricesRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            countryCode: this._countryCode !== UnassignedValue ? this._countryCode : maybe(someString()),
            currency: this._currency !== UnassignedValue ? this._currency : maybe(someString()),
            requestedApplications: this._requestedApplications !== UnassignedValue ? this._requestedApplications : maybe(boundedManyOf(1, 3, function () { return exports.aRequestedApplication().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ListTpaPricesRequestDTOBuilder;
}());
exports.ListTpaPricesRequestDTOBuilder = ListTpaPricesRequestDTOBuilder;
var ListTpaPricesResponseDTOBuilder = /** @class */ (function () {
    function ListTpaPricesResponseDTOBuilder() {
        this._applicationPrices = UnassignedValue;
        this._currencySettings = UnassignedValue;
    }
    ListTpaPricesResponseDTOBuilder.prototype.withApplicationPrices = function (_applicationPrices) {
        this._applicationPrices = _applicationPrices;
        return this;
    };
    ListTpaPricesResponseDTOBuilder.prototype.withCurrencySettings = function (_currencySettings) {
        this._currencySettings = _currencySettings;
        return this;
    };
    ListTpaPricesResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ListTpaPricesResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            applicationPrices: this._applicationPrices !== UnassignedValue ? this._applicationPrices : maybe(manyOf(function () { return exports.anApplicationPrices().build({ buildersVisited: buildersVisited }); })),
            currencySettings: this._currencySettings !== UnassignedValue ? this._currencySettings : maybe(exports.aCurrencySettings().build({ buildersVisited: buildersVisited })),
        };
    };
    return ListTpaPricesResponseDTOBuilder;
}());
exports.ListTpaPricesResponseDTOBuilder = ListTpaPricesResponseDTOBuilder;
var MailboxOldSaleTypeDTOBuilder = /** @class */ (function () {
    function MailboxOldSaleTypeDTOBuilder() {
    }
    MailboxOldSaleTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.MailboxOldSaleType.NO_SALE, types_1.MailboxOldSaleType.SEASONAL_SALE, types_1.MailboxOldSaleType.PERSONAL_SALE]);
    };
    return MailboxOldSaleTypeDTOBuilder;
}());
exports.MailboxOldSaleTypeDTOBuilder = MailboxOldSaleTypeDTOBuilder;
var MailboxSaleTypeDTOBuilder = /** @class */ (function () {
    function MailboxSaleTypeDTOBuilder() {
    }
    MailboxSaleTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.MailboxSaleType.UNKNOWN_SALE_TYPE, types_1.MailboxSaleType.NO_SALE, types_1.MailboxSaleType.SEASONAL_SALE, types_1.MailboxSaleType.PERSONAL_SALE, types_1.MailboxSaleType.MIGRATION]);
    };
    return MailboxSaleTypeDTOBuilder;
}());
exports.MailboxSaleTypeDTOBuilder = MailboxSaleTypeDTOBuilder;
var MultiLingualTextDTOBuilder = /** @class */ (function () {
    function MultiLingualTextDTOBuilder() {
        this._original = UnassignedValue;
        this._translated = UnassignedValue;
    }
    MultiLingualTextDTOBuilder.prototype.withOriginal = function (_original) {
        this._original = _original;
        return this;
    };
    MultiLingualTextDTOBuilder.prototype.withTranslated = function (_translated) {
        this._translated = _translated;
        return this;
    };
    MultiLingualTextDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'MultiLingualText', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            original: this._original !== UnassignedValue ? this._original : maybe(boundedString(1, 100)),
            translated: this._translated !== UnassignedValue ? this._translated : maybe(boundedString(1, 100)),
        };
    };
    return MultiLingualTextDTOBuilder;
}());
exports.MultiLingualTextDTOBuilder = MultiLingualTextDTOBuilder;
var NewSubscriptionDTOBuilder = /** @class */ (function () {
    function NewSubscriptionDTOBuilder() {
        this._msid = UnassignedValue;
    }
    NewSubscriptionDTOBuilder.prototype.withMsid = function (_msid) {
        this._msid = _msid;
        return this;
    };
    NewSubscriptionDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'NewSubscription', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            msid: this._msid !== UnassignedValue ? this._msid : maybe(someGuid()),
        };
    };
    return NewSubscriptionDTOBuilder;
}());
exports.NewSubscriptionDTOBuilder = NewSubscriptionDTOBuilder;
var NonCouponUsageDTOBuilder = /** @class */ (function () {
    function NonCouponUsageDTOBuilder() {
    }
    NonCouponUsageDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'NonCouponUsage', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return NonCouponUsageDTOBuilder;
}());
exports.NonCouponUsageDTOBuilder = NonCouponUsageDTOBuilder;
var OneTimeDTOBuilder = /** @class */ (function () {
    function OneTimeDTOBuilder() {
    }
    OneTimeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'OneTime', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return OneTimeDTOBuilder;
}());
exports.OneTimeDTOBuilder = OneTimeDTOBuilder;
var OrderPreviewDTOBuilder = /** @class */ (function () {
    function OrderPreviewDTOBuilder() {
        this._amounts = UnassignedValue;
        this._currency = UnassignedValue;
        this._items = UnassignedValue;
    }
    OrderPreviewDTOBuilder.prototype.withCurrency = function (_currency) {
        this._currency = _currency;
        return this;
    };
    OrderPreviewDTOBuilder.prototype.withItems = function (_items) {
        this._items = _items;
        return this;
    };
    OrderPreviewDTOBuilder.prototype.withAmounts = function (_amounts) {
        this._amounts = _amounts;
        return this;
    };
    OrderPreviewDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'OrderPreview', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            amounts: this._amounts !== UnassignedValue ? this._amounts : maybe(exports.anAmounts().build({ buildersVisited: buildersVisited })),
            currency: this._currency !== UnassignedValue ? this._currency : maybe(currencyString()),
            items: this._items !== UnassignedValue ? this._items : maybe(manyOf(function () { return exports.anOrderPreviewItem().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return OrderPreviewDTOBuilder;
}());
exports.OrderPreviewDTOBuilder = OrderPreviewDTOBuilder;
var OrderPreviewItemDTOBuilder = /** @class */ (function () {
    function OrderPreviewItemDTOBuilder() {
        this._amounts = UnassignedValue;
        this._coupon = UnassignedValue;
        this._cycle = UnassignedValue;
        this._externalCharge = UnassignedValue;
        this._freeTrialDurationInDays = UnassignedValue;
        this._metadata = UnassignedValue;
        this._nextRecurringPayment = UnassignedValue;
        this._orderPreviewItemId = UnassignedValue;
        this._overridePeriodStart = UnassignedValue;
        this._productId = UnassignedValue;
        this._quantity = UnassignedValue;
        this._unitPrice = UnassignedValue;
    }
    OrderPreviewItemDTOBuilder.prototype.withOrderPreviewItemId = function (_orderPreviewItemId) {
        this._orderPreviewItemId = _orderPreviewItemId;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withQuantity = function (_quantity) {
        this._quantity = _quantity;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withUnitPrice = function (_unitPrice) {
        this._unitPrice = _unitPrice;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withCycle = function (_cycle) {
        this._cycle = _cycle;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withAmounts = function (_amounts) {
        this._amounts = _amounts;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withNextRecurringPayment = function (_nextRecurringPayment) {
        this._nextRecurringPayment = _nextRecurringPayment;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withCoupon = function (_coupon) {
        this._coupon = _coupon;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withOverridePeriodStart = function (_overridePeriodStart) {
        this._overridePeriodStart = _overridePeriodStart;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withMetadata = function (_metadata) {
        this._metadata = _metadata;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withExternalCharge = function (_externalCharge) {
        this._externalCharge = _externalCharge;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.withFreeTrialDurationInDays = function (_freeTrialDurationInDays) {
        this._freeTrialDurationInDays = _freeTrialDurationInDays;
        return this;
    };
    OrderPreviewItemDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'OrderPreviewItem', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            amounts: this._amounts !== UnassignedValue ? this._amounts : maybe(exports.anAmounts().build({ buildersVisited: buildersVisited })),
            coupon: this._coupon !== UnassignedValue ? this._coupon : maybe(exports.aCoupon().build({ buildersVisited: buildersVisited })),
            cycle: this._cycle !== UnassignedValue ? this._cycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            externalCharge: this._externalCharge !== UnassignedValue ? this._externalCharge : maybe(someBoolean()),
            freeTrialDurationInDays: this._freeTrialDurationInDays !== UnassignedValue ? this._freeTrialDurationInDays : maybe(someInt()),
            metadata: this._metadata !== UnassignedValue ? this._metadata : maybe(jsonMapOf(function () { return someString(); })),
            nextRecurringPayment: this._nextRecurringPayment !== UnassignedValue ? this._nextRecurringPayment : maybe(exports.aRecurringPayment().build({ buildersVisited: buildersVisited })),
            orderPreviewItemId: this._orderPreviewItemId !== UnassignedValue ? this._orderPreviewItemId : maybe(someGuid()),
            overridePeriodStart: this._overridePeriodStart !== UnassignedValue ? this._overridePeriodStart : maybe(someDateString()),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
            quantity: this._quantity !== UnassignedValue ? this._quantity : maybe(someInt()),
            unitPrice: this._unitPrice !== UnassignedValue ? this._unitPrice : maybe(someInt()),
        };
    };
    return OrderPreviewItemDTOBuilder;
}());
exports.OrderPreviewItemDTOBuilder = OrderPreviewItemDTOBuilder;
var PaymentCycleDTOBuilder = /** @class */ (function () {
    function PaymentCycleDTOBuilder() {
    }
    PaymentCycleDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.PaymentCycle.DAILY,
            types_1.PaymentCycle.WEEKLY,
            types_1.PaymentCycle.MONTHLY,
            types_1.PaymentCycle.QUARTERLY,
            types_1.PaymentCycle.SEMIANNUALLY,
            types_1.PaymentCycle.YEARLY,
            types_1.PaymentCycle.YEAR2,
            types_1.PaymentCycle.YEAR3,
            types_1.PaymentCycle.YEAR4,
            types_1.PaymentCycle.YEAR5,
            types_1.PaymentCycle.YEAR10,
            types_1.PaymentCycle.ONE_TIME,
        ]);
    };
    return PaymentCycleDTOBuilder;
}());
exports.PaymentCycleDTOBuilder = PaymentCycleDTOBuilder;
var PaymentFiltersDTOBuilder = /** @class */ (function () {
    function PaymentFiltersDTOBuilder() {
        this._paymentType = UnassignedValue;
    }
    PaymentFiltersDTOBuilder.prototype.withPaymentType = function (_paymentType) {
        this._paymentType = _paymentType;
        return this;
    };
    PaymentFiltersDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PaymentFilters', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            paymentType: this._paymentType !== UnassignedValue ? this._paymentType : maybe(manyOf(function () { return exports.aPaymentType().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return PaymentFiltersDTOBuilder;
}());
exports.PaymentFiltersDTOBuilder = PaymentFiltersDTOBuilder;
var PaymentTypeDTOBuilder = /** @class */ (function () {
    function PaymentTypeDTOBuilder() {
    }
    PaymentTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.PaymentType.UNKNOWN, types_1.PaymentType.RECURRING, types_1.PaymentType.REAL_TIME]);
    };
    return PaymentTypeDTOBuilder;
}());
exports.PaymentTypeDTOBuilder = PaymentTypeDTOBuilder;
var PersonalCouponDTOBuilder = /** @class */ (function () {
    function PersonalCouponDTOBuilder() {
        this._personalCoupon = UnassignedValue;
    }
    PersonalCouponDTOBuilder.prototype.withPersonalCoupon = function (_personalCoupon) {
        this._personalCoupon = _personalCoupon;
        return this;
    };
    PersonalCouponDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PersonalCoupon', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            personalCoupon: this._personalCoupon !== UnassignedValue ? this._personalCoupon : maybe(boundedString(0, 50)),
        };
    };
    return PersonalCouponDTOBuilder;
}());
exports.PersonalCouponDTOBuilder = PersonalCouponDTOBuilder;
var PremiumCurrencySettingsDTOBuilder = /** @class */ (function () {
    function PremiumCurrencySettingsDTOBuilder() {
        this._decimalSep = UnassignedValue;
        this._fractionSize = UnassignedValue;
        this._groupSep = UnassignedValue;
        this._negPrefix = UnassignedValue;
        this._negSuffix = UnassignedValue;
        this._posPrefix = UnassignedValue;
        this._posSuffix = UnassignedValue;
        this._symbol = UnassignedValue;
    }
    PremiumCurrencySettingsDTOBuilder.prototype.withPosSuffix = function (_posSuffix) {
        this._posSuffix = _posSuffix;
        return this;
    };
    PremiumCurrencySettingsDTOBuilder.prototype.withPosPrefix = function (_posPrefix) {
        this._posPrefix = _posPrefix;
        return this;
    };
    PremiumCurrencySettingsDTOBuilder.prototype.withNegSuffix = function (_negSuffix) {
        this._negSuffix = _negSuffix;
        return this;
    };
    PremiumCurrencySettingsDTOBuilder.prototype.withGroupSep = function (_groupSep) {
        this._groupSep = _groupSep;
        return this;
    };
    PremiumCurrencySettingsDTOBuilder.prototype.withFractionSize = function (_fractionSize) {
        this._fractionSize = _fractionSize;
        return this;
    };
    PremiumCurrencySettingsDTOBuilder.prototype.withSymbol = function (_symbol) {
        this._symbol = _symbol;
        return this;
    };
    PremiumCurrencySettingsDTOBuilder.prototype.withNegPrefix = function (_negPrefix) {
        this._negPrefix = _negPrefix;
        return this;
    };
    PremiumCurrencySettingsDTOBuilder.prototype.withDecimalSep = function (_decimalSep) {
        this._decimalSep = _decimalSep;
        return this;
    };
    PremiumCurrencySettingsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PremiumCurrencySettings', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            decimalSep: this._decimalSep !== UnassignedValue ? this._decimalSep : someString(),
            fractionSize: this._fractionSize !== UnassignedValue ? this._fractionSize : someInt(),
            groupSep: this._groupSep !== UnassignedValue ? this._groupSep : someString(),
            negPrefix: this._negPrefix !== UnassignedValue ? this._negPrefix : someString(),
            negSuffix: this._negSuffix !== UnassignedValue ? this._negSuffix : someString(),
            posPrefix: this._posPrefix !== UnassignedValue ? this._posPrefix : someString(),
            posSuffix: this._posSuffix !== UnassignedValue ? this._posSuffix : someString(),
            symbol: this._symbol !== UnassignedValue ? this._symbol : someString(),
        };
    };
    return PremiumCurrencySettingsDTOBuilder;
}());
exports.PremiumCurrencySettingsDTOBuilder = PremiumCurrencySettingsDTOBuilder;
var PremiumProductDTOBuilder = /** @class */ (function () {
    function PremiumProductDTOBuilder() {
        this._existingSbsServiceId = UnassignedValue;
        this._paymentCycle = UnassignedValue;
        this._productId = UnassignedValue;
    }
    PremiumProductDTOBuilder.prototype.withExistingSbsServiceId = function (_existingSbsServiceId) {
        this._existingSbsServiceId = _existingSbsServiceId;
        return this;
    };
    PremiumProductDTOBuilder.prototype.withPaymentCycle = function (_paymentCycle) {
        this._paymentCycle = _paymentCycle;
        return this;
    };
    PremiumProductDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    PremiumProductDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PremiumProduct', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            existingSbsServiceId: this._existingSbsServiceId !== UnassignedValue ? this._existingSbsServiceId : maybe(someGuid()),
            paymentCycle: this._paymentCycle !== UnassignedValue ? this._paymentCycle : exports.aPaymentCycle().build({ buildersVisited: buildersVisited }),
            productId: this._productId !== UnassignedValue ? this._productId : someGuid(),
        };
    };
    return PremiumProductDTOBuilder;
}());
exports.PremiumProductDTOBuilder = PremiumProductDTOBuilder;
var PremiumProductCatalogProductPricesDTOBuilder = /** @class */ (function () {
    function PremiumProductCatalogProductPricesDTOBuilder() {
        this._discountInfo = UnassignedValue;
        this._discountedPrices = UnassignedValue;
        this._fullPrices = UnassignedValue;
        this._productId = UnassignedValue;
    }
    PremiumProductCatalogProductPricesDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    PremiumProductCatalogProductPricesDTOBuilder.prototype.withFullPrices = function (_fullPrices) {
        this._fullPrices = _fullPrices;
        return this;
    };
    PremiumProductCatalogProductPricesDTOBuilder.prototype.withDiscountedPrices = function (_discountedPrices) {
        this._discountedPrices = _discountedPrices;
        return this;
    };
    PremiumProductCatalogProductPricesDTOBuilder.prototype.withDiscountInfo = function (_discountInfo) {
        this._discountInfo = _discountInfo;
        return this;
    };
    PremiumProductCatalogProductPricesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PremiumProductCatalogProductPrices', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            discountInfo: this._discountInfo !== UnassignedValue ? this._discountInfo : maybe(exports.aDiscountInfo().build({ buildersVisited: buildersVisited })),
            discountedPrices: this._discountedPrices !== UnassignedValue ? this._discountedPrices : maybe(manyOf(function () { return exports.aDiscountedPricing().build({ buildersVisited: buildersVisited }); })),
            fullPrices: this._fullPrices !== UnassignedValue ? this._fullPrices : maybe(manyOf(function () { return exports.aProductCyclePrice().build({ buildersVisited: buildersVisited }); })),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
        };
    };
    return PremiumProductCatalogProductPricesDTOBuilder;
}());
exports.PremiumProductCatalogProductPricesDTOBuilder = PremiumProductCatalogProductPricesDTOBuilder;
var PremiumProductPriceDTOBuilder = /** @class */ (function () {
    function PremiumProductPriceDTOBuilder() {
        this._hasCoupon = UnassignedValue;
        this._monthlyPrice = UnassignedValue;
        this._paymentCycle = UnassignedValue;
        this._productId = UnassignedValue;
        this._totalPrice = UnassignedValue;
    }
    PremiumProductPriceDTOBuilder.prototype.withMonthlyPrice = function (_monthlyPrice) {
        this._monthlyPrice = _monthlyPrice;
        return this;
    };
    PremiumProductPriceDTOBuilder.prototype.withPaymentCycle = function (_paymentCycle) {
        this._paymentCycle = _paymentCycle;
        return this;
    };
    PremiumProductPriceDTOBuilder.prototype.withTotalPrice = function (_totalPrice) {
        this._totalPrice = _totalPrice;
        return this;
    };
    PremiumProductPriceDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    PremiumProductPriceDTOBuilder.prototype.withHasCoupon = function (_hasCoupon) {
        this._hasCoupon = _hasCoupon;
        return this;
    };
    PremiumProductPriceDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PremiumProductPrice', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            hasCoupon: this._hasCoupon !== UnassignedValue ? this._hasCoupon : someBoolean(),
            monthlyPrice: this._monthlyPrice !== UnassignedValue ? this._monthlyPrice : maybe(someNumber()),
            paymentCycle: this._paymentCycle !== UnassignedValue ? this._paymentCycle : exports.aPaymentCycle().build({ buildersVisited: buildersVisited }),
            productId: this._productId !== UnassignedValue ? this._productId : someGuid(),
            totalPrice: this._totalPrice !== UnassignedValue ? this._totalPrice : someNumber(),
        };
    };
    return PremiumProductPriceDTOBuilder;
}());
exports.PremiumProductPriceDTOBuilder = PremiumProductPriceDTOBuilder;
var PriceAmountsDTOBuilder = /** @class */ (function () {
    function PriceAmountsDTOBuilder() {
        this._beforeTaxAmount = UnassignedValue;
        this._creditAmount = UnassignedValue;
        this._discountAmount = UnassignedValue;
        this._subTotalAmount = UnassignedValue;
        this._totalAmount = UnassignedValue;
        this._totalAmountWithoutDiscount = UnassignedValue;
        this._totalTaxAmount = UnassignedValue;
    }
    PriceAmountsDTOBuilder.prototype.withSubTotalAmount = function (_subTotalAmount) {
        this._subTotalAmount = _subTotalAmount;
        return this;
    };
    PriceAmountsDTOBuilder.prototype.withCreditAmount = function (_creditAmount) {
        this._creditAmount = _creditAmount;
        return this;
    };
    PriceAmountsDTOBuilder.prototype.withDiscountAmount = function (_discountAmount) {
        this._discountAmount = _discountAmount;
        return this;
    };
    PriceAmountsDTOBuilder.prototype.withBeforeTaxAmount = function (_beforeTaxAmount) {
        this._beforeTaxAmount = _beforeTaxAmount;
        return this;
    };
    PriceAmountsDTOBuilder.prototype.withTotalAmount = function (_totalAmount) {
        this._totalAmount = _totalAmount;
        return this;
    };
    PriceAmountsDTOBuilder.prototype.withTotalTaxAmount = function (_totalTaxAmount) {
        this._totalTaxAmount = _totalTaxAmount;
        return this;
    };
    PriceAmountsDTOBuilder.prototype.withTotalAmountWithoutDiscount = function (_totalAmountWithoutDiscount) {
        this._totalAmountWithoutDiscount = _totalAmountWithoutDiscount;
        return this;
    };
    PriceAmountsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PriceAmounts', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            beforeTaxAmount: this._beforeTaxAmount !== UnassignedValue ? this._beforeTaxAmount : maybe(decimalValueString()),
            creditAmount: this._creditAmount !== UnassignedValue ? this._creditAmount : maybe(decimalValueString()),
            discountAmount: this._discountAmount !== UnassignedValue ? this._discountAmount : maybe(decimalValueString()),
            subTotalAmount: this._subTotalAmount !== UnassignedValue ? this._subTotalAmount : maybe(decimalValueString()),
            totalAmount: this._totalAmount !== UnassignedValue ? this._totalAmount : maybe(decimalValueString()),
            totalAmountWithoutDiscount: this._totalAmountWithoutDiscount !== UnassignedValue ? this._totalAmountWithoutDiscount : maybe(decimalValueString()),
            totalTaxAmount: this._totalTaxAmount !== UnassignedValue ? this._totalTaxAmount : maybe(decimalValueString()),
        };
    };
    return PriceAmountsDTOBuilder;
}());
exports.PriceAmountsDTOBuilder = PriceAmountsDTOBuilder;
var PricingInfoDTOBuilder = /** @class */ (function () {
    function PricingInfoDTOBuilder() {
        this._catalogPricing = UnassignedValue;
        this._couponsPricing = UnassignedValue;
        this._cyclePricing = UnassignedValue;
        this._salePricing = UnassignedValue;
        this._showPriceWithTax = UnassignedValue;
    }
    PricingInfoDTOBuilder.prototype.withCyclePricing = function (_cyclePricing) {
        this._cyclePricing = _cyclePricing;
        return this;
    };
    PricingInfoDTOBuilder.prototype.withCatalogPricing = function (_catalogPricing) {
        this._catalogPricing = _catalogPricing;
        return this;
    };
    PricingInfoDTOBuilder.prototype.withSalePricing = function (_salePricing) {
        this._salePricing = _salePricing;
        return this;
    };
    PricingInfoDTOBuilder.prototype.withCouponsPricing = function (_couponsPricing) {
        this._couponsPricing = _couponsPricing;
        return this;
    };
    PricingInfoDTOBuilder.prototype.withShowPriceWithTax = function (_showPriceWithTax) {
        this._showPriceWithTax = _showPriceWithTax;
        return this;
    };
    PricingInfoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PricingInfo', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            catalogPricing: this._catalogPricing !== UnassignedValue ? this._catalogPricing : maybe(manyOf(function () { return exports.aCyclePricing().build({ buildersVisited: buildersVisited }); })),
            couponsPricing: this._couponsPricing !== UnassignedValue ? this._couponsPricing : maybe(manyOf(function () { return exports.aCouponPricing().build({ buildersVisited: buildersVisited }); })),
            cyclePricing: this._cyclePricing !== UnassignedValue ? this._cyclePricing : maybe(manyOf(function () { return exports.aCyclePricingOld().build({ buildersVisited: buildersVisited }); })),
            salePricing: this._salePricing !== UnassignedValue ? this._salePricing : maybe(exports.aSalePricing().build({ buildersVisited: buildersVisited })),
            showPriceWithTax: this._showPriceWithTax !== UnassignedValue ? this._showPriceWithTax : maybe(someBoolean()),
        };
    };
    return PricingInfoDTOBuilder;
}());
exports.PricingInfoDTOBuilder = PricingInfoDTOBuilder;
var ProductDTOBuilder = /** @class */ (function () {
    function ProductDTOBuilder() {
        this._existingBillingServiceId = UnassignedValue;
        this._overridePrice = UnassignedValue;
        this._paymentCycles = UnassignedValue;
        this._productId = UnassignedValue;
    }
    ProductDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    ProductDTOBuilder.prototype.withPaymentCycles = function (_paymentCycles) {
        this._paymentCycles = _paymentCycles;
        return this;
    };
    ProductDTOBuilder.prototype.withExistingBillingServiceId = function (_existingBillingServiceId) {
        this._existingBillingServiceId = _existingBillingServiceId;
        return this;
    };
    ProductDTOBuilder.prototype.withOverridePrice = function (_overridePrice) {
        this._overridePrice = _overridePrice;
        return this;
    };
    ProductDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Product', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            existingBillingServiceId: this._existingBillingServiceId !== UnassignedValue ? this._existingBillingServiceId : maybe(someGuid()),
            overridePrice: this._overridePrice !== UnassignedValue ? this._overridePrice : maybe(decimalValueString()),
            paymentCycles: this._paymentCycles !== UnassignedValue ? this._paymentCycles : maybe(manyOf(function () { return exports.anApiV1Cycle().build({ buildersVisited: buildersVisited }); })),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
        };
    };
    return ProductDTOBuilder;
}());
exports.ProductDTOBuilder = ProductDTOBuilder;
var ProductChangeDTOBuilder = /** @class */ (function () {
    function ProductChangeDTOBuilder() {
        this._productId = UnassignedValue;
    }
    ProductChangeDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    ProductChangeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ProductChange', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
        };
    };
    return ProductChangeDTOBuilder;
}());
exports.ProductChangeDTOBuilder = ProductChangeDTOBuilder;
var ProductCouponDTOBuilder = /** @class */ (function () {
    function ProductCouponDTOBuilder() {
        this._couponCode = UnassignedValue;
    }
    ProductCouponDTOBuilder.prototype.withCouponCode = function (_couponCode) {
        this._couponCode = _couponCode;
        return this;
    };
    ProductCouponDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ProductCoupon', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            couponCode: this._couponCode !== UnassignedValue ? this._couponCode : maybe(someString()),
        };
    };
    return ProductCouponDTOBuilder;
}());
exports.ProductCouponDTOBuilder = ProductCouponDTOBuilder;
var ProductCyclePriceDTOBuilder = /** @class */ (function () {
    function ProductCyclePriceDTOBuilder() {
        this._monthlyPriceBeforeTax = UnassignedValue;
        this._monthlyPriceWithTax = UnassignedValue;
        this._paymentCycle = UnassignedValue;
        this._priceBeforeTax = UnassignedValue;
        this._priceWithTax = UnassignedValue;
    }
    ProductCyclePriceDTOBuilder.prototype.withPaymentCycle = function (_paymentCycle) {
        this._paymentCycle = _paymentCycle;
        return this;
    };
    ProductCyclePriceDTOBuilder.prototype.withPriceBeforeTax = function (_priceBeforeTax) {
        this._priceBeforeTax = _priceBeforeTax;
        return this;
    };
    ProductCyclePriceDTOBuilder.prototype.withPriceWithTax = function (_priceWithTax) {
        this._priceWithTax = _priceWithTax;
        return this;
    };
    ProductCyclePriceDTOBuilder.prototype.withMonthlyPriceBeforeTax = function (_monthlyPriceBeforeTax) {
        this._monthlyPriceBeforeTax = _monthlyPriceBeforeTax;
        return this;
    };
    ProductCyclePriceDTOBuilder.prototype.withMonthlyPriceWithTax = function (_monthlyPriceWithTax) {
        this._monthlyPriceWithTax = _monthlyPriceWithTax;
        return this;
    };
    ProductCyclePriceDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ProductCyclePrice', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            monthlyPriceBeforeTax: this._monthlyPriceBeforeTax !== UnassignedValue ? this._monthlyPriceBeforeTax : maybe(decimalValueString()),
            monthlyPriceWithTax: this._monthlyPriceWithTax !== UnassignedValue ? this._monthlyPriceWithTax : maybe(decimalValueString()),
            paymentCycle: this._paymentCycle !== UnassignedValue ? this._paymentCycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            priceBeforeTax: this._priceBeforeTax !== UnassignedValue ? this._priceBeforeTax : maybe(decimalValueString()),
            priceWithTax: this._priceWithTax !== UnassignedValue ? this._priceWithTax : maybe(decimalValueString()),
        };
    };
    return ProductCyclePriceDTOBuilder;
}());
exports.ProductCyclePriceDTOBuilder = ProductCyclePriceDTOBuilder;
var ProductDataDTOBuilder = /** @class */ (function () {
    function ProductDataDTOBuilder() {
        this._enabled = UnassignedValue;
        this._groupId = UnassignedValue;
        this._productClassName = UnassignedValue;
        this._productId = UnassignedValue;
        this._productName = UnassignedValue;
        this._shippable = UnassignedValue;
        this._vendorGuid = UnassignedValue;
    }
    ProductDataDTOBuilder.prototype.withVendorGuid = function (_vendorGuid) {
        this._vendorGuid = _vendorGuid;
        return this;
    };
    ProductDataDTOBuilder.prototype.withEnabled = function (_enabled) {
        this._enabled = _enabled;
        return this;
    };
    ProductDataDTOBuilder.prototype.withProductClassName = function (_productClassName) {
        this._productClassName = _productClassName;
        return this;
    };
    ProductDataDTOBuilder.prototype.withShippable = function (_shippable) {
        this._shippable = _shippable;
        return this;
    };
    ProductDataDTOBuilder.prototype.withGroupId = function (_groupId) {
        this._groupId = _groupId;
        return this;
    };
    ProductDataDTOBuilder.prototype.withProductName = function (_productName) {
        this._productName = _productName;
        return this;
    };
    ProductDataDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    ProductDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ProductData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            enabled: this._enabled !== UnassignedValue ? this._enabled : someBoolean(),
            groupId: this._groupId !== UnassignedValue ? this._groupId : someGuid(),
            productClassName: this._productClassName !== UnassignedValue ? this._productClassName : someString(),
            productId: this._productId !== UnassignedValue ? this._productId : someGuid(),
            productName: this._productName !== UnassignedValue ? this._productName : someString(),
            shippable: this._shippable !== UnassignedValue ? this._shippable : someBoolean(),
            vendorGuid: this._vendorGuid !== UnassignedValue ? this._vendorGuid : someGuid(),
        };
    };
    return ProductDataDTOBuilder;
}());
exports.ProductDataDTOBuilder = ProductDataDTOBuilder;
var ProductDisplayAttributesDTOBuilder = /** @class */ (function () {
    function ProductDisplayAttributesDTOBuilder() {
        this._featureDisplayAttributes = UnassignedValue;
        this._metaData = UnassignedValue;
        this._productDescription = UnassignedValue;
        this._productId = UnassignedValue;
        this._productName = UnassignedValue;
    }
    ProductDisplayAttributesDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    ProductDisplayAttributesDTOBuilder.prototype.withFeatureDisplayAttributes = function (_featureDisplayAttributes) {
        this._featureDisplayAttributes = _featureDisplayAttributes;
        return this;
    };
    ProductDisplayAttributesDTOBuilder.prototype.withProductName = function (_productName) {
        this._productName = _productName;
        return this;
    };
    ProductDisplayAttributesDTOBuilder.prototype.withProductDescription = function (_productDescription) {
        this._productDescription = _productDescription;
        return this;
    };
    ProductDisplayAttributesDTOBuilder.prototype.withMetaData = function (_metaData) {
        this._metaData = _metaData;
        return this;
    };
    ProductDisplayAttributesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ProductDisplayAttributes', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            featureDisplayAttributes: this._featureDisplayAttributes !== UnassignedValue ? this._featureDisplayAttributes : maybe(manyOf(function () { return exports.aFeatureDisplayAttributes().build({ buildersVisited: buildersVisited }); })),
            metaData: this._metaData !== UnassignedValue ? this._metaData : maybe(jsonMapOf(function () { return someString(); })),
            productDescription: this._productDescription !== UnassignedValue ? this._productDescription : maybe(someString()),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someString()),
            productName: this._productName !== UnassignedValue ? this._productName : maybe(someString()),
        };
    };
    return ProductDisplayAttributesDTOBuilder;
}());
exports.ProductDisplayAttributesDTOBuilder = ProductDisplayAttributesDTOBuilder;
var ProductInfoDTOBuilder = /** @class */ (function () {
    function ProductInfoDTOBuilder() {
        this._cycleDisplayProperties = UnassignedValue;
        this._disclaimerInfo = UnassignedValue;
        this._displayProperties = UnassignedValue;
        this._downgradePurchasableCycles = UnassignedValue;
        this._downgradePurchasablePremiumCycles = UnassignedValue;
        this._features = UnassignedValue;
        this._freeTrial = UnassignedValue;
        this._name = UnassignedValue;
        this._pricingInfo = UnassignedValue;
        this._productFamilyId = UnassignedValue;
        this._productId = UnassignedValue;
        this._productTypeId = UnassignedValue;
        this._purchasableCycles = UnassignedValue;
        this._purchasablePremiumCycles = UnassignedValue;
        this._sbsProductIdPoc = UnassignedValue;
    }
    ProductInfoDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withFeatures = function (_features) {
        this._features = _features;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withPricingInfo = function (_pricingInfo) {
        this._pricingInfo = _pricingInfo;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withDisplayProperties = function (_displayProperties) {
        this._displayProperties = _displayProperties;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withPurchasableCycles = function (_purchasableCycles) {
        this._purchasableCycles = _purchasableCycles;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withDisclaimerInfo = function (_disclaimerInfo) {
        this._disclaimerInfo = _disclaimerInfo;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withCycleDisplayProperties = function (_cycleDisplayProperties) {
        this._cycleDisplayProperties = _cycleDisplayProperties;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withSbsProductIdPoc = function (_sbsProductIdPoc) {
        this._sbsProductIdPoc = _sbsProductIdPoc;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withDowngradePurchasableCycles = function (_downgradePurchasableCycles) {
        this._downgradePurchasableCycles = _downgradePurchasableCycles;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withProductTypeId = function (_productTypeId) {
        this._productTypeId = _productTypeId;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withProductFamilyId = function (_productFamilyId) {
        this._productFamilyId = _productFamilyId;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withFreeTrial = function (_freeTrial) {
        this._freeTrial = _freeTrial;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withPurchasablePremiumCycles = function (_purchasablePremiumCycles) {
        this._purchasablePremiumCycles = _purchasablePremiumCycles;
        return this;
    };
    ProductInfoDTOBuilder.prototype.withDowngradePurchasablePremiumCycles = function (_downgradePurchasablePremiumCycles) {
        this._downgradePurchasablePremiumCycles = _downgradePurchasablePremiumCycles;
        return this;
    };
    ProductInfoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ProductInfo', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            cycleDisplayProperties: this._cycleDisplayProperties !== UnassignedValue ? this._cycleDisplayProperties : maybe(manyOf(function () { return exports.aCycleDisplayProperties().build({ buildersVisited: buildersVisited }); })),
            disclaimerInfo: this._disclaimerInfo !== UnassignedValue ? this._disclaimerInfo : maybe(exports.aDisclaimerInfo().build({ buildersVisited: buildersVisited })),
            displayProperties: this._displayProperties !== UnassignedValue ? this._displayProperties : maybe(jsonMapOf(function () { return someString(); })),
            downgradePurchasableCycles: this._downgradePurchasableCycles !== UnassignedValue ? this._downgradePurchasableCycles : maybe(manyOf(function () { return exports.anApiV1Cycle().build({ buildersVisited: buildersVisited }); })),
            downgradePurchasablePremiumCycles: this._downgradePurchasablePremiumCycles !== UnassignedValue
                ? this._downgradePurchasablePremiumCycles
                : maybe(boundedManyOf(0, 3, function () { return exports.aCommonV1Cycle().build({ buildersVisited: buildersVisited }); })),
            features: this._features !== UnassignedValue ? this._features : maybe(manyOf(function () { return exports.aFeature().build({ buildersVisited: buildersVisited }); })),
            freeTrial: this._freeTrial !== UnassignedValue ? this._freeTrial : maybe(exports.aFreeTrial().build({ buildersVisited: buildersVisited })),
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            pricingInfo: this._pricingInfo !== UnassignedValue ? this._pricingInfo : maybe(exports.aPricingInfo().build({ buildersVisited: buildersVisited })),
            productFamilyId: this._productFamilyId !== UnassignedValue ? this._productFamilyId : maybe(someGuid()),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
            productTypeId: this._productTypeId !== UnassignedValue ? this._productTypeId : maybe(someGuid()),
            purchasableCycles: this._purchasableCycles !== UnassignedValue ? this._purchasableCycles : maybe(manyOf(function () { return exports.anApiV1Cycle().build({ buildersVisited: buildersVisited }); })),
            purchasablePremiumCycles: this._purchasablePremiumCycles !== UnassignedValue ? this._purchasablePremiumCycles : maybe(boundedManyOf(0, 3, function () { return exports.aCommonV1Cycle().build({ buildersVisited: buildersVisited }); })),
            sbsProductIdPoc: this._sbsProductIdPoc !== UnassignedValue ? this._sbsProductIdPoc : maybe(someString()),
        };
    };
    return ProductInfoDTOBuilder;
}());
exports.ProductInfoDTOBuilder = ProductInfoDTOBuilder;
var ProductPricesDTOBuilder = /** @class */ (function () {
    function ProductPricesDTOBuilder() {
        this._discountInfo = UnassignedValue;
        this._discountedPrices = UnassignedValue;
        this._fullPrices = UnassignedValue;
        this._productId = UnassignedValue;
    }
    ProductPricesDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    ProductPricesDTOBuilder.prototype.withFullPrices = function (_fullPrices) {
        this._fullPrices = _fullPrices;
        return this;
    };
    ProductPricesDTOBuilder.prototype.withDiscountedPrices = function (_discountedPrices) {
        this._discountedPrices = _discountedPrices;
        return this;
    };
    ProductPricesDTOBuilder.prototype.withDiscountInfo = function (_discountInfo) {
        this._discountInfo = _discountInfo;
        return this;
    };
    ProductPricesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ProductPrices', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            discountInfo: this._discountInfo !== UnassignedValue ? this._discountInfo : maybe(exports.aDiscountInfo().build({ buildersVisited: buildersVisited })),
            discountedPrices: this._discountedPrices !== UnassignedValue ? this._discountedPrices : maybe(manyOf(function () { return exports.aDiscountedPricing().build({ buildersVisited: buildersVisited }); })),
            fullPrices: this._fullPrices !== UnassignedValue ? this._fullPrices : maybe(manyOf(function () { return exports.aProductCyclePrice().build({ buildersVisited: buildersVisited }); })),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
        };
    };
    return ProductPricesDTOBuilder;
}());
exports.ProductPricesDTOBuilder = ProductPricesDTOBuilder;
var ProductPricingResultDTOBuilder = /** @class */ (function () {
    function ProductPricingResultDTOBuilder() {
        this._currencyCode = UnassignedValue;
        this._currencyFormatSettings = UnassignedValue;
        this._productPrices = UnassignedValue;
    }
    ProductPricingResultDTOBuilder.prototype.withProductPrices = function (_productPrices) {
        this._productPrices = _productPrices;
        return this;
    };
    ProductPricingResultDTOBuilder.prototype.withCurrencyFormatSettings = function (_currencyFormatSettings) {
        this._currencyFormatSettings = _currencyFormatSettings;
        return this;
    };
    ProductPricingResultDTOBuilder.prototype.withCurrencyCode = function (_currencyCode) {
        this._currencyCode = _currencyCode;
        return this;
    };
    ProductPricingResultDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ProductPricingResult', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currencyCode: this._currencyCode !== UnassignedValue ? this._currencyCode : someString(),
            currencyFormatSettings: this._currencyFormatSettings !== UnassignedValue ? this._currencyFormatSettings : exports.aPremiumCurrencySettings().build({ buildersVisited: buildersVisited }),
            productPrices: this._productPrices !== UnassignedValue ? this._productPrices : manyOf(function () { return exports.aPremiumProductPrice().build({ buildersVisited: buildersVisited }); }),
        };
    };
    return ProductPricingResultDTOBuilder;
}());
exports.ProductPricingResultDTOBuilder = ProductPricingResultDTOBuilder;
var ProvisionProductsRequestDTOBuilder = /** @class */ (function () {
    function ProvisionProductsRequestDTOBuilder() {
        this._countryCode = UnassignedValue;
        this._eventAggregator = UnassignedValue;
        this._lineItems = UnassignedValue;
    }
    ProvisionProductsRequestDTOBuilder.prototype.withLineItems = function (_lineItems) {
        this._lineItems = _lineItems;
        return this;
    };
    ProvisionProductsRequestDTOBuilder.prototype.withCountryCode = function (_countryCode) {
        this._countryCode = _countryCode;
        return this;
    };
    ProvisionProductsRequestDTOBuilder.prototype.withEventAggregator = function (_eventAggregator) {
        this._eventAggregator = _eventAggregator;
        return this;
    };
    ProvisionProductsRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ProvisionProductsRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            countryCode: this._countryCode !== UnassignedValue ? this._countryCode : maybe(countryString()),
            eventAggregator: this._eventAggregator !== UnassignedValue ? this._eventAggregator : maybe(someString()),
            lineItems: this._lineItems !== UnassignedValue ? this._lineItems : maybe(boundedManyOf(1, 3, function () { return exports.aLineItem().build({ buildersVisited: buildersVisited }); })),
        };
    };
    return ProvisionProductsRequestDTOBuilder;
}());
exports.ProvisionProductsRequestDTOBuilder = ProvisionProductsRequestDTOBuilder;
var ProvisionProductsResponseDTOBuilder = /** @class */ (function () {
    function ProvisionProductsResponseDTOBuilder() {
        this._eventAggregator = UnassignedValue;
    }
    ProvisionProductsResponseDTOBuilder.prototype.withEventAggregator = function (_eventAggregator) {
        this._eventAggregator = _eventAggregator;
        return this;
    };
    ProvisionProductsResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ProvisionProductsResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            eventAggregator: this._eventAggregator !== UnassignedValue ? this._eventAggregator : maybe(someString()),
        };
    };
    return ProvisionProductsResponseDTOBuilder;
}());
exports.ProvisionProductsResponseDTOBuilder = ProvisionProductsResponseDTOBuilder;
var PurchaseDetailsDTOBuilder = /** @class */ (function () {
    function PurchaseDetailsDTOBuilder() {
        this._currencyCode = UnassignedValue;
        this._orderParams = UnassignedValue;
        this._purchaseLineItems = UnassignedValue;
        this._purchaseReturnUrls = UnassignedValue;
    }
    PurchaseDetailsDTOBuilder.prototype.withCurrencyCode = function (_currencyCode) {
        this._currencyCode = _currencyCode;
        return this;
    };
    PurchaseDetailsDTOBuilder.prototype.withPurchaseLineItems = function (_purchaseLineItems) {
        this._purchaseLineItems = _purchaseLineItems;
        return this;
    };
    PurchaseDetailsDTOBuilder.prototype.withPurchaseReturnUrls = function (_purchaseReturnUrls) {
        this._purchaseReturnUrls = _purchaseReturnUrls;
        return this;
    };
    PurchaseDetailsDTOBuilder.prototype.withOrderParams = function (_orderParams) {
        this._orderParams = _orderParams;
        return this;
    };
    PurchaseDetailsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PurchaseDetails', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            currencyCode: this._currencyCode !== UnassignedValue ? this._currencyCode : maybe(someString()),
            orderParams: this._orderParams !== UnassignedValue ? this._orderParams : maybe(jsonMapOf(function () { return someString(); })),
            purchaseLineItems: this._purchaseLineItems !== UnassignedValue ? this._purchaseLineItems : maybe(manyOf(function () { return exports.aPurchaseLineItem().build({ buildersVisited: buildersVisited }); })),
            purchaseReturnUrls: this._purchaseReturnUrls !== UnassignedValue ? this._purchaseReturnUrls : maybe(exports.aPurchaseReturnUrls().build({ buildersVisited: buildersVisited })),
        };
    };
    return PurchaseDetailsDTOBuilder;
}());
exports.PurchaseDetailsDTOBuilder = PurchaseDetailsDTOBuilder;
var PurchaseDisclaimerDTOBuilder = /** @class */ (function () {
    function PurchaseDisclaimerDTOBuilder() {
        this._links = UnassignedValue;
        this._texts = UnassignedValue;
    }
    PurchaseDisclaimerDTOBuilder.prototype.withTexts = function (_texts) {
        this._texts = _texts;
        return this;
    };
    PurchaseDisclaimerDTOBuilder.prototype.withLinks = function (_links) {
        this._links = _links;
        return this;
    };
    PurchaseDisclaimerDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PurchaseDisclaimer', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            links: this._links !== UnassignedValue ? this._links : maybe(manyOf(function () { return someString(); })),
            texts: this._texts !== UnassignedValue ? this._texts : maybe(manyOf(function () { return someString(); })),
        };
    };
    return PurchaseDisclaimerDTOBuilder;
}());
exports.PurchaseDisclaimerDTOBuilder = PurchaseDisclaimerDTOBuilder;
var PurchaseDisplayPropertiesDTOBuilder = /** @class */ (function () {
    function PurchaseDisplayPropertiesDTOBuilder() {
        this._allowPromoCode = UnassignedValue;
        this._disclaimerInfo = UnassignedValue;
        this._discountLabel = UnassignedValue;
        this._displayPreviews = UnassignedValue;
        this._summaryCustomTexts = UnassignedValue;
        this._translationsUrl = UnassignedValue;
    }
    PurchaseDisplayPropertiesDTOBuilder.prototype.withSummaryCustomTexts = function (_summaryCustomTexts) {
        this._summaryCustomTexts = _summaryCustomTexts;
        return this;
    };
    PurchaseDisplayPropertiesDTOBuilder.prototype.withDisclaimerInfo = function (_disclaimerInfo) {
        this._disclaimerInfo = _disclaimerInfo;
        return this;
    };
    PurchaseDisplayPropertiesDTOBuilder.prototype.withTranslationsUrl = function (_translationsUrl) {
        this._translationsUrl = _translationsUrl;
        return this;
    };
    PurchaseDisplayPropertiesDTOBuilder.prototype.withDisplayPreviews = function (_displayPreviews) {
        this._displayPreviews = _displayPreviews;
        return this;
    };
    PurchaseDisplayPropertiesDTOBuilder.prototype.withDiscountLabel = function (_discountLabel) {
        this._discountLabel = _discountLabel;
        return this;
    };
    PurchaseDisplayPropertiesDTOBuilder.prototype.withAllowPromoCode = function (_allowPromoCode) {
        this._allowPromoCode = _allowPromoCode;
        return this;
    };
    PurchaseDisplayPropertiesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PurchaseDisplayProperties', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            allowPromoCode: this._allowPromoCode !== UnassignedValue ? this._allowPromoCode : maybe(someBoolean()),
            disclaimerInfo: this._disclaimerInfo !== UnassignedValue ? this._disclaimerInfo : maybe(exports.aPurchaseDisclaimer().build({ buildersVisited: buildersVisited })),
            discountLabel: this._discountLabel !== UnassignedValue ? this._discountLabel : maybe(someString()),
            displayPreviews: this._displayPreviews !== UnassignedValue ? this._displayPreviews : maybe(manyOf(function () { return exports.aDisplayPreview().build({ buildersVisited: buildersVisited }); })),
            summaryCustomTexts: this._summaryCustomTexts !== UnassignedValue ? this._summaryCustomTexts : maybe(manyOf(function () { return someString(); })),
            translationsUrl: this._translationsUrl !== UnassignedValue ? this._translationsUrl : maybe(webUrlString()),
        };
    };
    return PurchaseDisplayPropertiesDTOBuilder;
}());
exports.PurchaseDisplayPropertiesDTOBuilder = PurchaseDisplayPropertiesDTOBuilder;
var PurchaseLineItemDTOBuilder = /** @class */ (function () {
    function PurchaseLineItemDTOBuilder() {
        this._billingServiceId = UnassignedValue;
        this._couponCode = UnassignedValue;
        this._displayName = UnassignedValue;
        this._existingPackageId = UnassignedValue;
        this._externalOrderItemId = UnassignedValue;
        this._overridePrice = UnassignedValue;
        this._paymentCycle = UnassignedValue;
        this._productId = UnassignedValue;
        this._quantity = UnassignedValue;
    }
    PurchaseLineItemDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    PurchaseLineItemDTOBuilder.prototype.withQuantity = function (_quantity) {
        this._quantity = _quantity;
        return this;
    };
    PurchaseLineItemDTOBuilder.prototype.withPaymentCycle = function (_paymentCycle) {
        this._paymentCycle = _paymentCycle;
        return this;
    };
    PurchaseLineItemDTOBuilder.prototype.withDisplayName = function (_displayName) {
        this._displayName = _displayName;
        return this;
    };
    PurchaseLineItemDTOBuilder.prototype.withCouponCode = function (_couponCode) {
        this._couponCode = _couponCode;
        return this;
    };
    PurchaseLineItemDTOBuilder.prototype.withExistingPackageId = function (_existingPackageId) {
        this._existingPackageId = _existingPackageId;
        return this;
    };
    PurchaseLineItemDTOBuilder.prototype.withOverridePrice = function (_overridePrice) {
        this._overridePrice = _overridePrice;
        return this;
    };
    PurchaseLineItemDTOBuilder.prototype.withBillingServiceId = function (_billingServiceId) {
        this._billingServiceId = _billingServiceId;
        return this;
    };
    PurchaseLineItemDTOBuilder.prototype.withExternalOrderItemId = function (_externalOrderItemId) {
        this._externalOrderItemId = _externalOrderItemId;
        return this;
    };
    PurchaseLineItemDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PurchaseLineItem', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            billingServiceId: this._billingServiceId !== UnassignedValue ? this._billingServiceId : maybe(someGuid()),
            couponCode: this._couponCode !== UnassignedValue ? this._couponCode : maybe(someString()),
            displayName: this._displayName !== UnassignedValue ? this._displayName : maybe(someString()),
            existingPackageId: this._existingPackageId !== UnassignedValue ? this._existingPackageId : maybe(someGuid()),
            externalOrderItemId: this._externalOrderItemId !== UnassignedValue ? this._externalOrderItemId : maybe(someGuid()),
            overridePrice: this._overridePrice !== UnassignedValue ? this._overridePrice : maybe(decimalValueString()),
            paymentCycle: this._paymentCycle !== UnassignedValue ? this._paymentCycle : maybe(exports.aBillingCycle().build({ buildersVisited: buildersVisited })),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
            quantity: this._quantity !== UnassignedValue ? this._quantity : maybe(someInt()),
        };
    };
    return PurchaseLineItemDTOBuilder;
}());
exports.PurchaseLineItemDTOBuilder = PurchaseLineItemDTOBuilder;
var PurchaseReturnUrlsDTOBuilder = /** @class */ (function () {
    function PurchaseReturnUrlsDTOBuilder() {
        this._purchaseCancellation = UnassignedValue;
        this._purchaseError = UnassignedValue;
        this._purchasePending = UnassignedValue;
        this._purchaseSuccess = UnassignedValue;
    }
    PurchaseReturnUrlsDTOBuilder.prototype.withPurchaseSuccess = function (_purchaseSuccess) {
        this._purchaseSuccess = _purchaseSuccess;
        return this;
    };
    PurchaseReturnUrlsDTOBuilder.prototype.withPurchaseError = function (_purchaseError) {
        this._purchaseError = _purchaseError;
        return this;
    };
    PurchaseReturnUrlsDTOBuilder.prototype.withPurchaseCancellation = function (_purchaseCancellation) {
        this._purchaseCancellation = _purchaseCancellation;
        return this;
    };
    PurchaseReturnUrlsDTOBuilder.prototype.withPurchasePending = function (_purchasePending) {
        this._purchasePending = _purchasePending;
        return this;
    };
    PurchaseReturnUrlsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PurchaseReturnUrls', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            purchaseCancellation: this._purchaseCancellation !== UnassignedValue ? this._purchaseCancellation : maybe(webUrlString()),
            purchaseError: this._purchaseError !== UnassignedValue ? this._purchaseError : maybe(webUrlString()),
            purchasePending: this._purchasePending !== UnassignedValue ? this._purchasePending : maybe(webUrlString()),
            purchaseSuccess: this._purchaseSuccess !== UnassignedValue ? this._purchaseSuccess : maybe(webUrlString()),
        };
    };
    return PurchaseReturnUrlsDTOBuilder;
}());
exports.PurchaseReturnUrlsDTOBuilder = PurchaseReturnUrlsDTOBuilder;
var PurchaseRuleDTOBuilder = /** @class */ (function () {
    function PurchaseRuleDTOBuilder() {
        this._discountId = UnassignedValue;
    }
    PurchaseRuleDTOBuilder.prototype.withDiscountId = function (_discountId) {
        this._discountId = _discountId;
        return this;
    };
    PurchaseRuleDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'PurchaseRule', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            discountId: this._discountId !== UnassignedValue ? this._discountId : maybe(someGuid()),
        };
    };
    return PurchaseRuleDTOBuilder;
}());
exports.PurchaseRuleDTOBuilder = PurchaseRuleDTOBuilder;
var PurchaseScenarioDTOBuilder = /** @class */ (function () {
    function PurchaseScenarioDTOBuilder() {
    }
    PurchaseScenarioDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.PurchaseScenario.UNAUTHORIZED,
            types_1.PurchaseScenario.ACCOUNT_LEVEL,
            types_1.PurchaseScenario.PURCHASE,
            types_1.PurchaseScenario.VIEW,
            types_1.PurchaseScenario.EMPTY_OFFERING,
            types_1.PurchaseScenario.ANONYMOUS,
        ]);
    };
    return PurchaseScenarioDTOBuilder;
}());
exports.PurchaseScenarioDTOBuilder = PurchaseScenarioDTOBuilder;
var QuotaFeatureDTOBuilder = /** @class */ (function () {
    function QuotaFeatureDTOBuilder() {
        this._limit = UnassignedValue;
        this._period = UnassignedValue;
        this._units = UnassignedValue;
    }
    QuotaFeatureDTOBuilder.prototype.withLimit = function (_limit) {
        this._limit = _limit;
        return this;
    };
    QuotaFeatureDTOBuilder.prototype.withPeriod = function (_period) {
        this._period = _period;
        return this;
    };
    QuotaFeatureDTOBuilder.prototype.withUnits = function (_units) {
        this._units = _units;
        return this;
    };
    QuotaFeatureDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'QuotaFeature', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            limit: this._limit !== UnassignedValue ? this._limit : maybe(someInt()),
            period: this._period !== UnassignedValue ? this._period : maybe(exports.aFeaturePeriod().build({ buildersVisited: buildersVisited })),
            units: this._units !== UnassignedValue ? this._units : maybe(someString()),
        };
    };
    return QuotaFeatureDTOBuilder;
}());
exports.QuotaFeatureDTOBuilder = QuotaFeatureDTOBuilder;
var RecurringPaymentDTOBuilder = /** @class */ (function () {
    function RecurringPaymentDTOBuilder() {
        this._amounts = UnassignedValue;
        this._date = UnassignedValue;
    }
    RecurringPaymentDTOBuilder.prototype.withDate = function (_date) {
        this._date = _date;
        return this;
    };
    RecurringPaymentDTOBuilder.prototype.withAmounts = function (_amounts) {
        this._amounts = _amounts;
        return this;
    };
    RecurringPaymentDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RecurringPayment', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            amounts: this._amounts !== UnassignedValue ? this._amounts : maybe(exports.anAmounts().build({ buildersVisited: buildersVisited })),
            date: this._date !== UnassignedValue ? this._date : maybe(someDateString()),
        };
    };
    return RecurringPaymentDTOBuilder;
}());
exports.RecurringPaymentDTOBuilder = RecurringPaymentDTOBuilder;
var RequestedApplicationDTOBuilder = /** @class */ (function () {
    function RequestedApplicationDTOBuilder() {
        this._appDefinitionId = UnassignedValue;
        this._vendorProductIds = UnassignedValue;
    }
    RequestedApplicationDTOBuilder.prototype.withAppDefinitionId = function (_appDefinitionId) {
        this._appDefinitionId = _appDefinitionId;
        return this;
    };
    RequestedApplicationDTOBuilder.prototype.withVendorProductIds = function (_vendorProductIds) {
        this._vendorProductIds = _vendorProductIds;
        return this;
    };
    RequestedApplicationDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RequestedApplication', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            appDefinitionId: this._appDefinitionId !== UnassignedValue ? this._appDefinitionId : maybe(someString()),
            vendorProductIds: this._vendorProductIds !== UnassignedValue ? this._vendorProductIds : maybe(boundedManyOf(0, 3, function () { return someString(); })),
        };
    };
    return RequestedApplicationDTOBuilder;
}());
exports.RequestedApplicationDTOBuilder = RequestedApplicationDTOBuilder;
var RequestedProductDTOBuilder = /** @class */ (function () {
    function RequestedProductDTOBuilder() {
        this._existingBillingServiceId = UnassignedValue;
        this._overridePrice = UnassignedValue;
        this._paymentCycles = UnassignedValue;
        this._productId = UnassignedValue;
    }
    RequestedProductDTOBuilder.prototype.withProductId = function (_productId) {
        this._productId = _productId;
        return this;
    };
    RequestedProductDTOBuilder.prototype.withPaymentCycles = function (_paymentCycles) {
        this._paymentCycles = _paymentCycles;
        return this;
    };
    RequestedProductDTOBuilder.prototype.withExistingBillingServiceId = function (_existingBillingServiceId) {
        this._existingBillingServiceId = _existingBillingServiceId;
        return this;
    };
    RequestedProductDTOBuilder.prototype.withOverridePrice = function (_overridePrice) {
        this._overridePrice = _overridePrice;
        return this;
    };
    RequestedProductDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'RequestedProduct', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            existingBillingServiceId: this._existingBillingServiceId !== UnassignedValue ? this._existingBillingServiceId : maybe(someGuid()),
            overridePrice: this._overridePrice !== UnassignedValue ? this._overridePrice : maybe(decimalValueString()),
            paymentCycles: this._paymentCycles !== UnassignedValue ? this._paymentCycles : maybe(manyOf(function () { return exports.anApiV1Cycle().build({ buildersVisited: buildersVisited }); })),
            productId: this._productId !== UnassignedValue ? this._productId : maybe(someGuid()),
        };
    };
    return RequestedProductDTOBuilder;
}());
exports.RequestedProductDTOBuilder = RequestedProductDTOBuilder;
var SaleDTOBuilder = /** @class */ (function () {
    function SaleDTOBuilder() {
        this._saleType = UnassignedValue;
    }
    SaleDTOBuilder.prototype.withSaleType = function (_saleType) {
        this._saleType = _saleType;
        return this;
    };
    SaleDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Sale', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            saleType: this._saleType !== UnassignedValue ? this._saleType : maybe(boundedString(0, 50)),
        };
    };
    return SaleDTOBuilder;
}());
exports.SaleDTOBuilder = SaleDTOBuilder;
var SaleCouponDTOBuilder = /** @class */ (function () {
    function SaleCouponDTOBuilder() {
    }
    SaleCouponDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SaleCoupon', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return SaleCouponDTOBuilder;
}());
exports.SaleCouponDTOBuilder = SaleCouponDTOBuilder;
var SaleDetailsDTOBuilder = /** @class */ (function () {
    function SaleDetailsDTOBuilder() {
        this._remainingDays = UnassignedValue;
        this._saleDiscount = UnassignedValue;
        this._saleEndDate = UnassignedValue;
        this._saleType = UnassignedValue;
    }
    SaleDetailsDTOBuilder.prototype.withSaleType = function (_saleType) {
        this._saleType = _saleType;
        return this;
    };
    SaleDetailsDTOBuilder.prototype.withSaleDiscount = function (_saleDiscount) {
        this._saleDiscount = _saleDiscount;
        return this;
    };
    SaleDetailsDTOBuilder.prototype.withSaleEndDate = function (_saleEndDate) {
        this._saleEndDate = _saleEndDate;
        return this;
    };
    SaleDetailsDTOBuilder.prototype.withRemainingDays = function (_remainingDays) {
        this._remainingDays = _remainingDays;
        return this;
    };
    SaleDetailsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SaleDetails', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            remainingDays: this._remainingDays !== UnassignedValue ? this._remainingDays : maybe(someInt()),
            saleDiscount: this._saleDiscount !== UnassignedValue ? this._saleDiscount : maybe(someInt()),
            saleEndDate: this._saleEndDate !== UnassignedValue ? this._saleEndDate : maybe(someDateString()),
            saleType: this._saleType !== UnassignedValue ? this._saleType : maybe(someString()),
        };
    };
    return SaleDetailsDTOBuilder;
}());
exports.SaleDetailsDTOBuilder = SaleDetailsDTOBuilder;
var SalePricingDTOBuilder = /** @class */ (function () {
    function SalePricingDTOBuilder() {
        this._discountPrices = UnassignedValue;
        this._saleCouponMetadata = UnassignedValue;
    }
    SalePricingDTOBuilder.prototype.withDiscountPrices = function (_discountPrices) {
        this._discountPrices = _discountPrices;
        return this;
    };
    SalePricingDTOBuilder.prototype.withSaleCouponMetadata = function (_saleCouponMetadata) {
        this._saleCouponMetadata = _saleCouponMetadata;
        return this;
    };
    SalePricingDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SalePricing', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            discountPrices: this._discountPrices !== UnassignedValue ? this._discountPrices : maybe(manyOf(function () { return exports.aCyclePricing().build({ buildersVisited: buildersVisited }); })),
            saleCouponMetadata: this._saleCouponMetadata !== UnassignedValue ? this._saleCouponMetadata : maybe(jsonMapOf(function () { return someString(); })),
        };
    };
    return SalePricingDTOBuilder;
}());
exports.SalePricingDTOBuilder = SalePricingDTOBuilder;
var ServiceCouponDataDTOBuilder = /** @class */ (function () {
    function ServiceCouponDataDTOBuilder() {
        this._couponGuid = UnassignedValue;
        this._lastCouponCode = UnassignedValue;
    }
    ServiceCouponDataDTOBuilder.prototype.withLastCouponCode = function (_lastCouponCode) {
        this._lastCouponCode = _lastCouponCode;
        return this;
    };
    ServiceCouponDataDTOBuilder.prototype.withCouponGuid = function (_couponGuid) {
        this._couponGuid = _couponGuid;
        return this;
    };
    ServiceCouponDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ServiceCouponData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            couponGuid: this._couponGuid !== UnassignedValue ? this._couponGuid : someGuid(),
            lastCouponCode: this._lastCouponCode !== UnassignedValue ? this._lastCouponCode : maybe(someString()),
        };
    };
    return ServiceCouponDataDTOBuilder;
}());
exports.ServiceCouponDataDTOBuilder = ServiceCouponDataDTOBuilder;
var ServiceDataDTOBuilder = /** @class */ (function () {
    function ServiceDataDTOBuilder() {
        this._billingAccountGuid = UnassignedValue;
        this._billingCyclesLastUpgrade = UnassignedValue;
        this._billingCyclesTotal = UnassignedValue;
        this._couponData = UnassignedValue;
        this._creationDate = UnassignedValue;
        this._currencyCode = UnassignedValue;
        this._customerGuid = UnassignedValue;
        this._cycleUnitAmount = UnassignedValue;
        this._cycleUnitType = UnassignedValue;
        this._freeTrialData = UnassignedValue;
        this._hasExternalCharges = UnassignedValue;
        this._lastInvoiceId = UnassignedValue;
        this._lastRenewalDate = UnassignedValue;
        this._lastSuccessfulInvoiceId = UnassignedValue;
        this._metadata = UnassignedValue;
        this._nextRenewalDate = UnassignedValue;
        this._pendingChanges = UnassignedValue;
        this._periodEndDate = UnassignedValue;
        this._pricingPlanGuid = UnassignedValue;
        this._productGuid = UnassignedValue;
        this._quantity = UnassignedValue;
        this._recurringType = UnassignedValue;
        this._serviceExternalId = UnassignedValue;
        this._serviceGuid = UnassignedValue;
        this._serviceName = UnassignedValue;
        this._serviceStatus = UnassignedValue;
        this._transferData = UnassignedValue;
    }
    ServiceDataDTOBuilder.prototype.withServiceExternalId = function (_serviceExternalId) {
        this._serviceExternalId = _serviceExternalId;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withCycleUnitAmount = function (_cycleUnitAmount) {
        this._cycleUnitAmount = _cycleUnitAmount;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withQuantity = function (_quantity) {
        this._quantity = _quantity;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withBillingAccountGuid = function (_billingAccountGuid) {
        this._billingAccountGuid = _billingAccountGuid;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withServiceGuid = function (_serviceGuid) {
        this._serviceGuid = _serviceGuid;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withCouponData = function (_couponData) {
        this._couponData = _couponData;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withServiceName = function (_serviceName) {
        this._serviceName = _serviceName;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withBillingCyclesTotal = function (_billingCyclesTotal) {
        this._billingCyclesTotal = _billingCyclesTotal;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withHasExternalCharges = function (_hasExternalCharges) {
        this._hasExternalCharges = _hasExternalCharges;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withPricingPlanGuid = function (_pricingPlanGuid) {
        this._pricingPlanGuid = _pricingPlanGuid;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withServiceStatus = function (_serviceStatus) {
        this._serviceStatus = _serviceStatus;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withTransferData = function (_transferData) {
        this._transferData = _transferData;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withNextRenewalDate = function (_nextRenewalDate) {
        this._nextRenewalDate = _nextRenewalDate;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withCustomerGuid = function (_customerGuid) {
        this._customerGuid = _customerGuid;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withPendingChanges = function (_pendingChanges) {
        this._pendingChanges = _pendingChanges;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withLastRenewalDate = function (_lastRenewalDate) {
        this._lastRenewalDate = _lastRenewalDate;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withCurrencyCode = function (_currencyCode) {
        this._currencyCode = _currencyCode;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withCreationDate = function (_creationDate) {
        this._creationDate = _creationDate;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withLastInvoiceId = function (_lastInvoiceId) {
        this._lastInvoiceId = _lastInvoiceId;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withMetadata = function (_metadata) {
        this._metadata = _metadata;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withCycleUnitType = function (_cycleUnitType) {
        this._cycleUnitType = _cycleUnitType;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withPeriodEndDate = function (_periodEndDate) {
        this._periodEndDate = _periodEndDate;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withFreeTrialData = function (_freeTrialData) {
        this._freeTrialData = _freeTrialData;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withBillingCyclesLastUpgrade = function (_billingCyclesLastUpgrade) {
        this._billingCyclesLastUpgrade = _billingCyclesLastUpgrade;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withRecurringType = function (_recurringType) {
        this._recurringType = _recurringType;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withProductGuid = function (_productGuid) {
        this._productGuid = _productGuid;
        return this;
    };
    ServiceDataDTOBuilder.prototype.withLastSuccessfulInvoiceId = function (_lastSuccessfulInvoiceId) {
        this._lastSuccessfulInvoiceId = _lastSuccessfulInvoiceId;
        return this;
    };
    ServiceDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ServiceData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            billingAccountGuid: this._billingAccountGuid !== UnassignedValue ? this._billingAccountGuid : someGuid(),
            billingCyclesLastUpgrade: this._billingCyclesLastUpgrade !== UnassignedValue ? this._billingCyclesLastUpgrade : someInt(),
            billingCyclesTotal: this._billingCyclesTotal !== UnassignedValue ? this._billingCyclesTotal : someInt(),
            couponData: this._couponData !== UnassignedValue ? this._couponData : maybe(exports.aServiceCouponData().build({ buildersVisited: buildersVisited })),
            creationDate: this._creationDate !== UnassignedValue ? this._creationDate : someDateString(),
            currencyCode: this._currencyCode !== UnassignedValue ? this._currencyCode : exports.aCurrencyCode().build({ buildersVisited: buildersVisited }),
            customerGuid: this._customerGuid !== UnassignedValue ? this._customerGuid : someGuid(),
            cycleUnitAmount: this._cycleUnitAmount !== UnassignedValue ? this._cycleUnitAmount : someInt(),
            cycleUnitType: this._cycleUnitType !== UnassignedValue ? this._cycleUnitType : exports.aCycleUnitType().build({ buildersVisited: buildersVisited }),
            freeTrialData: this._freeTrialData !== UnassignedValue ? this._freeTrialData : maybe(exports.aServicedataFreeTrialData().build({ buildersVisited: buildersVisited })),
            hasExternalCharges: this._hasExternalCharges !== UnassignedValue ? this._hasExternalCharges : someBoolean(),
            lastInvoiceId: this._lastInvoiceId !== UnassignedValue ? this._lastInvoiceId : maybe(someInt()),
            lastRenewalDate: this._lastRenewalDate !== UnassignedValue ? this._lastRenewalDate : maybe(someDateString()),
            lastSuccessfulInvoiceId: this._lastSuccessfulInvoiceId !== UnassignedValue ? this._lastSuccessfulInvoiceId : maybe(someInt()),
            metadata: this._metadata !== UnassignedValue ? this._metadata : jsonMapOf(function () { return someString(); }),
            nextRenewalDate: this._nextRenewalDate !== UnassignedValue ? this._nextRenewalDate : maybe(someDateString()),
            pendingChanges: this._pendingChanges !== UnassignedValue ? this._pendingChanges : maybe(exports.aServicedataPendingChanges().build({ buildersVisited: buildersVisited })),
            periodEndDate: this._periodEndDate !== UnassignedValue ? this._periodEndDate : maybe(someDateString()),
            pricingPlanGuid: this._pricingPlanGuid !== UnassignedValue ? this._pricingPlanGuid : someGuid(),
            productGuid: this._productGuid !== UnassignedValue ? this._productGuid : someGuid(),
            quantity: this._quantity !== UnassignedValue ? this._quantity : someInt(),
            recurringType: this._recurringType !== UnassignedValue ? this._recurringType : exports.aServiceRecurringType().build({ buildersVisited: buildersVisited }),
            serviceExternalId: this._serviceExternalId !== UnassignedValue ? this._serviceExternalId : maybe(someString()),
            serviceGuid: this._serviceGuid !== UnassignedValue ? this._serviceGuid : someGuid(),
            serviceName: this._serviceName !== UnassignedValue ? this._serviceName : maybe(someString()),
            serviceStatus: this._serviceStatus !== UnassignedValue ? this._serviceStatus : exports.aServiceStatus().build({ buildersVisited: buildersVisited }),
            transferData: this._transferData !== UnassignedValue ? this._transferData : maybe(exports.aTransferData().build({ buildersVisited: buildersVisited })),
        };
    };
    return ServiceDataDTOBuilder;
}());
exports.ServiceDataDTOBuilder = ServiceDataDTOBuilder;
var ServiceRecurringTypeDTOBuilder = /** @class */ (function () {
    function ServiceRecurringTypeDTOBuilder() {
    }
    ServiceRecurringTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.ServiceRecurringType.AUTO, types_1.ServiceRecurringType.OFF, types_1.ServiceRecurringType.MANUAL]);
    };
    return ServiceRecurringTypeDTOBuilder;
}());
exports.ServiceRecurringTypeDTOBuilder = ServiceRecurringTypeDTOBuilder;
var ServiceStatusDTOBuilder = /** @class */ (function () {
    function ServiceStatusDTOBuilder() {
    }
    ServiceStatusDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.ServiceStatus.ACTIVE,
            types_1.ServiceStatus.PENDING,
            types_1.ServiceStatus.CANCELED,
            types_1.ServiceStatus.FRAUDULENT,
            types_1.ServiceStatus.COLLECTIONS,
            types_1.ServiceStatus.WORK_IN_PROGRESS,
            types_1.ServiceStatus.SUSPENDED,
            types_1.ServiceStatus.FAILED,
            types_1.ServiceStatus.PENDING_RENEWAL,
            types_1.ServiceStatus.EXPIRED,
            types_1.ServiceStatus.STOPPED,
            types_1.ServiceStatus.STARTED,
            types_1.ServiceStatus.SUBMITTED,
            types_1.ServiceStatus.COMPLETED,
            types_1.ServiceStatus.TRANSFERRED,
            types_1.ServiceStatus.DRAFT,
        ]);
    };
    return ServiceStatusDTOBuilder;
}());
exports.ServiceStatusDTOBuilder = ServiceStatusDTOBuilder;
var ServicedataFreeTrialDataDTOBuilder = /** @class */ (function () {
    function ServicedataFreeTrialDataDTOBuilder() {
        this._endDate = UnassignedValue;
        this._numberOfDays = UnassignedValue;
    }
    ServicedataFreeTrialDataDTOBuilder.prototype.withNumberOfDays = function (_numberOfDays) {
        this._numberOfDays = _numberOfDays;
        return this;
    };
    ServicedataFreeTrialDataDTOBuilder.prototype.withEndDate = function (_endDate) {
        this._endDate = _endDate;
        return this;
    };
    ServicedataFreeTrialDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ServicedataFreeTrialData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            endDate: this._endDate !== UnassignedValue ? this._endDate : someDateString(),
            numberOfDays: this._numberOfDays !== UnassignedValue ? this._numberOfDays : someInt(),
        };
    };
    return ServicedataFreeTrialDataDTOBuilder;
}());
exports.ServicedataFreeTrialDataDTOBuilder = ServicedataFreeTrialDataDTOBuilder;
var ServicedataPendingChangesDTOBuilder = /** @class */ (function () {
    function ServicedataPendingChangesDTOBuilder() {
        this._cycleUnitType = UnassignedValue;
        this._productGuid = UnassignedValue;
    }
    ServicedataPendingChangesDTOBuilder.prototype.withProductGuid = function (_productGuid) {
        this._productGuid = _productGuid;
        return this;
    };
    ServicedataPendingChangesDTOBuilder.prototype.withCycleUnitType = function (_cycleUnitType) {
        this._cycleUnitType = _cycleUnitType;
        return this;
    };
    ServicedataPendingChangesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ServicedataPendingChanges', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            cycleUnitType: this._cycleUnitType !== UnassignedValue ? this._cycleUnitType : maybe(exports.aCycleUnitType().build({ buildersVisited: buildersVisited })),
            productGuid: this._productGuid !== UnassignedValue ? this._productGuid : maybe(someGuid()),
        };
    };
    return ServicedataPendingChangesDTOBuilder;
}());
exports.ServicedataPendingChangesDTOBuilder = ServicedataPendingChangesDTOBuilder;
var StoreMailboxProductPriceDtoDTOBuilder = /** @class */ (function () {
    function StoreMailboxProductPriceDtoDTOBuilder() {
        this._id = UnassignedValue;
        this._priceMonthly = UnassignedValue;
        this._priceYearly = UnassignedValue;
        this._priceYearlyPerMonth = UnassignedValue;
    }
    StoreMailboxProductPriceDtoDTOBuilder.prototype.withId = function (_id) {
        this._id = _id;
        return this;
    };
    StoreMailboxProductPriceDtoDTOBuilder.prototype.withPriceYearly = function (_priceYearly) {
        this._priceYearly = _priceYearly;
        return this;
    };
    StoreMailboxProductPriceDtoDTOBuilder.prototype.withPriceYearlyPerMonth = function (_priceYearlyPerMonth) {
        this._priceYearlyPerMonth = _priceYearlyPerMonth;
        return this;
    };
    StoreMailboxProductPriceDtoDTOBuilder.prototype.withPriceMonthly = function (_priceMonthly) {
        this._priceMonthly = _priceMonthly;
        return this;
    };
    StoreMailboxProductPriceDtoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'StoreMailboxProductPriceDto', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            id: this._id !== UnassignedValue ? this._id : maybe(someGuid()),
            priceMonthly: this._priceMonthly !== UnassignedValue ? this._priceMonthly : maybe(someNumber()),
            priceYearly: this._priceYearly !== UnassignedValue ? this._priceYearly : maybe(someNumber()),
            priceYearlyPerMonth: this._priceYearlyPerMonth !== UnassignedValue ? this._priceYearlyPerMonth : maybe(someNumber()),
        };
    };
    return StoreMailboxProductPriceDtoDTOBuilder;
}());
exports.StoreMailboxProductPriceDtoDTOBuilder = StoreMailboxProductPriceDtoDTOBuilder;
var StoreMailboxProductPricesDtoDTOBuilder = /** @class */ (function () {
    function StoreMailboxProductPricesDtoDTOBuilder() {
        this._price = UnassignedValue;
        this._priceAfterDiscount = UnassignedValue;
    }
    StoreMailboxProductPricesDtoDTOBuilder.prototype.withPrice = function (_price) {
        this._price = _price;
        return this;
    };
    StoreMailboxProductPricesDtoDTOBuilder.prototype.withPriceAfterDiscount = function (_priceAfterDiscount) {
        this._priceAfterDiscount = _priceAfterDiscount;
        return this;
    };
    StoreMailboxProductPricesDtoDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'StoreMailboxProductPricesDto', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            price: this._price !== UnassignedValue ? this._price : maybe(exports.aStoreMailboxProductPriceDto().build({ buildersVisited: buildersVisited })),
            priceAfterDiscount: this._priceAfterDiscount !== UnassignedValue ? this._priceAfterDiscount : maybe(exports.aStoreMailboxProductPriceDto().build({ buildersVisited: buildersVisited })),
        };
    };
    return StoreMailboxProductPricesDtoDTOBuilder;
}());
exports.StoreMailboxProductPricesDtoDTOBuilder = StoreMailboxProductPricesDtoDTOBuilder;
var StreetAddressDTOBuilder = /** @class */ (function () {
    function StreetAddressDTOBuilder() {
        this._name = UnassignedValue;
        this._number = UnassignedValue;
    }
    StreetAddressDTOBuilder.prototype.withNumber = function (_number) {
        this._number = _number;
        return this;
    };
    StreetAddressDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    StreetAddressDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'StreetAddress', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            number: this._number !== UnassignedValue ? this._number : maybe(someString()),
        };
    };
    return StreetAddressDTOBuilder;
}());
exports.StreetAddressDTOBuilder = StreetAddressDTOBuilder;
var SubmitRequestDTOBuilder = /** @class */ (function () {
    function SubmitRequestDTOBuilder() {
        this._selectedCycle = UnassignedValue;
        this._selectedProductId = UnassignedValue;
        this._subscriptionId = UnassignedValue;
    }
    SubmitRequestDTOBuilder.prototype.withSubscriptionId = function (_subscriptionId) {
        this._subscriptionId = _subscriptionId;
        return this;
    };
    SubmitRequestDTOBuilder.prototype.withSelectedCycle = function (_selectedCycle) {
        this._selectedCycle = _selectedCycle;
        return this;
    };
    SubmitRequestDTOBuilder.prototype.withSelectedProductId = function (_selectedProductId) {
        this._selectedProductId = _selectedProductId;
        return this;
    };
    SubmitRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SubmitRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            selectedCycle: this._selectedCycle !== UnassignedValue ? this._selectedCycle : maybe(exports.anApiV1Cycle().build({ buildersVisited: buildersVisited })),
            selectedProductId: this._selectedProductId !== UnassignedValue ? this._selectedProductId : maybe(someString()),
            subscriptionId: this._subscriptionId !== UnassignedValue ? this._subscriptionId : maybe(someGuid()),
        };
    };
    return SubmitRequestDTOBuilder;
}());
exports.SubmitRequestDTOBuilder = SubmitRequestDTOBuilder;
var SubmitResponseDTOBuilder = /** @class */ (function () {
    function SubmitResponseDTOBuilder() {
    }
    SubmitResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SubmitResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {};
    };
    return SubmitResponseDTOBuilder;
}());
exports.SubmitResponseDTOBuilder = SubmitResponseDTOBuilder;
var SubscriptionUpgradeTypeDTOBuilder = /** @class */ (function () {
    function SubscriptionUpgradeTypeDTOBuilder() {
    }
    SubscriptionUpgradeTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.SubscriptionUpgradeType.UNKNOWN, types_1.SubscriptionUpgradeType.CREDIT_UNUSED_PERIOD, types_1.SubscriptionUpgradeType.EXTEND]);
    };
    return SubscriptionUpgradeTypeDTOBuilder;
}());
exports.SubscriptionUpgradeTypeDTOBuilder = SubscriptionUpgradeTypeDTOBuilder;
var SupportedPaymentTypesFilterDTOBuilder = /** @class */ (function () {
    function SupportedPaymentTypesFilterDTOBuilder() {
        this._paymentFilters = UnassignedValue;
    }
    SupportedPaymentTypesFilterDTOBuilder.prototype.withPaymentFilters = function (_paymentFilters) {
        this._paymentFilters = _paymentFilters;
        return this;
    };
    SupportedPaymentTypesFilterDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SupportedPaymentTypesFilter', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            paymentFilters: this._paymentFilters !== UnassignedValue ? this._paymentFilters : maybe(exports.aPaymentFilters().build({ buildersVisited: buildersVisited })),
        };
    };
    return SupportedPaymentTypesFilterDTOBuilder;
}());
exports.SupportedPaymentTypesFilterDTOBuilder = SupportedPaymentTypesFilterDTOBuilder;
var SwitchContractDTOBuilder = /** @class */ (function () {
    function SwitchContractDTOBuilder() {
        this._contractSwitchType = UnassignedValue;
        this._existingSubscriptionId = UnassignedValue;
        this._msid = UnassignedValue;
    }
    SwitchContractDTOBuilder.prototype.withExistingSubscriptionId = function (_existingSubscriptionId) {
        this._existingSubscriptionId = _existingSubscriptionId;
        return this;
    };
    SwitchContractDTOBuilder.prototype.withContractSwitchType = function (_contractSwitchType) {
        this._contractSwitchType = _contractSwitchType;
        return this;
    };
    SwitchContractDTOBuilder.prototype.withMsid = function (_msid) {
        this._msid = _msid;
        return this;
    };
    SwitchContractDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'SwitchContract', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            contractSwitchType: this._contractSwitchType !== UnassignedValue ? this._contractSwitchType : maybe(exports.aContractSwitchType().build({ buildersVisited: buildersVisited })),
            existingSubscriptionId: this._existingSubscriptionId !== UnassignedValue ? this._existingSubscriptionId : maybe(someGuid()),
            msid: this._msid !== UnassignedValue ? this._msid : maybe(someGuid()),
        };
    };
    return SwitchContractDTOBuilder;
}());
exports.SwitchContractDTOBuilder = SwitchContractDTOBuilder;
var TaxDTOBuilder = /** @class */ (function () {
    function TaxDTOBuilder() {
        this._isTaxExempt = UnassignedValue;
        this._name = UnassignedValue;
        this._percent = UnassignedValue;
    }
    TaxDTOBuilder.prototype.withName = function (_name) {
        this._name = _name;
        return this;
    };
    TaxDTOBuilder.prototype.withPercent = function (_percent) {
        this._percent = _percent;
        return this;
    };
    TaxDTOBuilder.prototype.withIsTaxExempt = function (_isTaxExempt) {
        this._isTaxExempt = _isTaxExempt;
        return this;
    };
    TaxDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'Tax', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            isTaxExempt: this._isTaxExempt !== UnassignedValue ? this._isTaxExempt : maybe(someBoolean()),
            name: this._name !== UnassignedValue ? this._name : maybe(someString()),
            percent: this._percent !== UnassignedValue ? this._percent : maybe(randomNumber(0, 100)),
        };
    };
    return TaxDTOBuilder;
}());
exports.TaxDTOBuilder = TaxDTOBuilder;
var TaxAmountDTOBuilder = /** @class */ (function () {
    function TaxAmountDTOBuilder() {
        this._amount = UnassignedValue;
        this._tax = UnassignedValue;
    }
    TaxAmountDTOBuilder.prototype.withTax = function (_tax) {
        this._tax = _tax;
        return this;
    };
    TaxAmountDTOBuilder.prototype.withAmount = function (_amount) {
        this._amount = _amount;
        return this;
    };
    TaxAmountDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'TaxAmount', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            amount: this._amount !== UnassignedValue ? this._amount : maybe(someInt()),
            tax: this._tax !== UnassignedValue ? this._tax : maybe(exports.aTax().build({ buildersVisited: buildersVisited })),
        };
    };
    return TaxAmountDTOBuilder;
}());
exports.TaxAmountDTOBuilder = TaxAmountDTOBuilder;
var TaxSettingsDTOBuilder = /** @class */ (function () {
    function TaxSettingsDTOBuilder() {
        this._displayTaxType = UnassignedValue;
        this._percent = UnassignedValue;
        this._showPricesWithTax = UnassignedValue;
        this._taxType = UnassignedValue;
    }
    TaxSettingsDTOBuilder.prototype.withShowPricesWithTax = function (_showPricesWithTax) {
        this._showPricesWithTax = _showPricesWithTax;
        return this;
    };
    TaxSettingsDTOBuilder.prototype.withPercent = function (_percent) {
        this._percent = _percent;
        return this;
    };
    TaxSettingsDTOBuilder.prototype.withTaxType = function (_taxType) {
        this._taxType = _taxType;
        return this;
    };
    TaxSettingsDTOBuilder.prototype.withDisplayTaxType = function (_displayTaxType) {
        this._displayTaxType = _displayTaxType;
        return this;
    };
    TaxSettingsDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'TaxSettings', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            displayTaxType: this._displayTaxType !== UnassignedValue ? this._displayTaxType : maybe(exports.aTaxSettingsTaxType().build({ buildersVisited: buildersVisited })),
            percent: this._percent !== UnassignedValue ? this._percent : maybe(decimalValueString()),
            showPricesWithTax: this._showPricesWithTax !== UnassignedValue ? this._showPricesWithTax : maybe(someBoolean()),
            taxType: this._taxType !== UnassignedValue ? this._taxType : maybe(exports.aTaxTypeConfigurationTaxType().build({ buildersVisited: buildersVisited })),
        };
    };
    return TaxSettingsDTOBuilder;
}());
exports.TaxSettingsDTOBuilder = TaxSettingsDTOBuilder;
var TaxSettingsTaxTypeDTOBuilder = /** @class */ (function () {
    function TaxSettingsTaxTypeDTOBuilder() {
    }
    TaxSettingsTaxTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([types_1.TaxSettingsTaxType.NOT_APPLICABLE, types_1.TaxSettingsTaxType.VAT, types_1.TaxSettingsTaxType.GST]);
    };
    return TaxSettingsTaxTypeDTOBuilder;
}());
exports.TaxSettingsTaxTypeDTOBuilder = TaxSettingsTaxTypeDTOBuilder;
var TaxTypeConfigurationTaxTypeDTOBuilder = /** @class */ (function () {
    function TaxTypeConfigurationTaxTypeDTOBuilder() {
    }
    TaxTypeConfigurationTaxTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.TaxTypeConfigurationTaxType.NOT_APPLICABLE,
            types_1.TaxTypeConfigurationTaxType.REGULAR,
            types_1.TaxTypeConfigurationTaxType.EU_VAT,
            types_1.TaxTypeConfigurationTaxType.JAPAN_JCT,
            types_1.TaxTypeConfigurationTaxType.AU_GST,
            types_1.TaxTypeConfigurationTaxType.BR_CNPJ,
            types_1.TaxTypeConfigurationTaxType.RU_TIN,
            types_1.TaxTypeConfigurationTaxType.IN_RNR,
            types_1.TaxTypeConfigurationTaxType.IL_VAT,
            types_1.TaxTypeConfigurationTaxType.US_TAX,
            types_1.TaxTypeConfigurationTaxType.SG_GST,
            types_1.TaxTypeConfigurationTaxType.CA_GST,
            types_1.TaxTypeConfigurationTaxType.CA_HST,
            types_1.TaxTypeConfigurationTaxType.CA_PST,
            types_1.TaxTypeConfigurationTaxType.CA_QST,
            types_1.TaxTypeConfigurationTaxType.NZ_GST,
            types_1.TaxTypeConfigurationTaxType.MD_VAT,
            types_1.TaxTypeConfigurationTaxType.CL_VAT,
            types_1.TaxTypeConfigurationTaxType.MY_VAT,
            types_1.TaxTypeConfigurationTaxType.KR_VAT,
            types_1.TaxTypeConfigurationTaxType.TW_VAT,
            types_1.TaxTypeConfigurationTaxType.AE_VAT,
            types_1.TaxTypeConfigurationTaxType.NG_VAT,
            types_1.TaxTypeConfigurationTaxType.IS_VAT,
            types_1.TaxTypeConfigurationTaxType.GE_VAT,
            types_1.TaxTypeConfigurationTaxType.TH_VAT,
            types_1.TaxTypeConfigurationTaxType.TR_VAT,
            types_1.TaxTypeConfigurationTaxType.NO_VAT,
            types_1.TaxTypeConfigurationTaxType.UA_VAT,
            types_1.TaxTypeConfigurationTaxType.IN_GST,
            types_1.TaxTypeConfigurationTaxType.KZ_VAT,
            types_1.TaxTypeConfigurationTaxType.TZ_VAT,
            types_1.TaxTypeConfigurationTaxType.IGIC_VAT,
            types_1.TaxTypeConfigurationTaxType.KE_VAT,
        ]);
    };
    return TaxTypeConfigurationTaxTypeDTOBuilder;
}());
exports.TaxTypeConfigurationTaxTypeDTOBuilder = TaxTypeConfigurationTaxTypeDTOBuilder;
var TransferDataDTOBuilder = /** @class */ (function () {
    function TransferDataDTOBuilder() {
        this._destinationServiceGuid = UnassignedValue;
        this._sourceServiceGuid = UnassignedValue;
    }
    TransferDataDTOBuilder.prototype.withDestinationServiceGuid = function (_destinationServiceGuid) {
        this._destinationServiceGuid = _destinationServiceGuid;
        return this;
    };
    TransferDataDTOBuilder.prototype.withSourceServiceGuid = function (_sourceServiceGuid) {
        this._sourceServiceGuid = _sourceServiceGuid;
        return this;
    };
    TransferDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'TransferData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            destinationServiceGuid: this._destinationServiceGuid !== UnassignedValue ? this._destinationServiceGuid : maybe(someGuid()),
            sourceServiceGuid: this._sourceServiceGuid !== UnassignedValue ? this._sourceServiceGuid : maybe(someGuid()),
        };
    };
    return TransferDataDTOBuilder;
}());
exports.TransferDataDTOBuilder = TransferDataDTOBuilder;
var UnknownFieldSetDTOBuilder = /** @class */ (function () {
    function UnknownFieldSetDTOBuilder() {
        this._fields$access$0 = UnassignedValue;
    }
    UnknownFieldSetDTOBuilder.prototype.withFields$access$0 = function (_fields$access$0) {
        this._fields$access$0 = _fields$access$0;
        return this;
    };
    UnknownFieldSetDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UnknownFieldSet', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            fields$access$0: this._fields$access$0 !== UnassignedValue ? this._fields$access$0 : jsonMapOf(function () { return exports.aField().build({ buildersVisited: buildersVisited }); }),
        };
    };
    return UnknownFieldSetDTOBuilder;
}());
exports.UnknownFieldSetDTOBuilder = UnknownFieldSetDTOBuilder;
var UpgradeSubscriptionDTOBuilder = /** @class */ (function () {
    function UpgradeSubscriptionDTOBuilder() {
        this._existingSubscriptionId = UnassignedValue;
        this._subscriptionUpgradeType = UnassignedValue;
    }
    UpgradeSubscriptionDTOBuilder.prototype.withExistingSubscriptionId = function (_existingSubscriptionId) {
        this._existingSubscriptionId = _existingSubscriptionId;
        return this;
    };
    UpgradeSubscriptionDTOBuilder.prototype.withSubscriptionUpgradeType = function (_subscriptionUpgradeType) {
        this._subscriptionUpgradeType = _subscriptionUpgradeType;
        return this;
    };
    UpgradeSubscriptionDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UpgradeSubscription', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            existingSubscriptionId: this._existingSubscriptionId !== UnassignedValue ? this._existingSubscriptionId : maybe(someGuid()),
            subscriptionUpgradeType: this._subscriptionUpgradeType !== UnassignedValue ? this._subscriptionUpgradeType : maybe(exports.aSubscriptionUpgradeType().build({ buildersVisited: buildersVisited })),
        };
    };
    return UpgradeSubscriptionDTOBuilder;
}());
exports.UpgradeSubscriptionDTOBuilder = UpgradeSubscriptionDTOBuilder;
var UserCouponDTOBuilder = /** @class */ (function () {
    function UserCouponDTOBuilder() {
        this._couponId = UnassignedValue;
    }
    UserCouponDTOBuilder.prototype.withCouponId = function (_couponId) {
        this._couponId = _couponId;
        return this;
    };
    UserCouponDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'UserCoupon', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            couponId: this._couponId !== UnassignedValue ? this._couponId : maybe(someString()),
        };
    };
    return UserCouponDTOBuilder;
}());
exports.UserCouponDTOBuilder = UserCouponDTOBuilder;
var V1FreeTrialDataDTOBuilder = /** @class */ (function () {
    function V1FreeTrialDataDTOBuilder() {
        this._endDate = UnassignedValue;
        this._inFreeTrialPeriod = UnassignedValue;
    }
    V1FreeTrialDataDTOBuilder.prototype.withEndDate = function (_endDate) {
        this._endDate = _endDate;
        return this;
    };
    V1FreeTrialDataDTOBuilder.prototype.withInFreeTrialPeriod = function (_inFreeTrialPeriod) {
        this._inFreeTrialPeriod = _inFreeTrialPeriod;
        return this;
    };
    V1FreeTrialDataDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'V1FreeTrialData', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            endDate: this._endDate !== UnassignedValue ? this._endDate : maybe(someDateString()),
            inFreeTrialPeriod: this._inFreeTrialPeriod !== UnassignedValue ? this._inFreeTrialPeriod : maybe(someBoolean()),
        };
    };
    return V1FreeTrialDataDTOBuilder;
}());
exports.V1FreeTrialDataDTOBuilder = V1FreeTrialDataDTOBuilder;
var V1PendingChangesDTOBuilder = /** @class */ (function () {
    function V1PendingChangesDTOBuilder() {
        this._cycleChange = UnassignedValue;
        this._productChange = UnassignedValue;
    }
    V1PendingChangesDTOBuilder.prototype.withCycleChange = function (_cycleChange) {
        this._cycleChange = _cycleChange;
        return this;
    };
    V1PendingChangesDTOBuilder.prototype.withProductChange = function (_productChange) {
        this._productChange = _productChange;
        return this;
    };
    V1PendingChangesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'V1PendingChanges', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            cycleChange: this._cycleChange !== UnassignedValue ? this._cycleChange : maybe(exports.aCycleChange().build({ buildersVisited: buildersVisited })),
            productChange: this._productChange !== UnassignedValue ? this._productChange : maybe(exports.aProductChange().build({ buildersVisited: buildersVisited })),
        };
    };
    return V1PendingChangesDTOBuilder;
}());
exports.V1PendingChangesDTOBuilder = V1PendingChangesDTOBuilder;
var ValidateNoPreviousPurchaseRequestDTOBuilder = /** @class */ (function () {
    function ValidateNoPreviousPurchaseRequestDTOBuilder() {
        this._eventAggregator = UnassignedValue;
        this._msid = UnassignedValue;
        this._productTypeId = UnassignedValue;
    }
    ValidateNoPreviousPurchaseRequestDTOBuilder.prototype.withMsid = function (_msid) {
        this._msid = _msid;
        return this;
    };
    ValidateNoPreviousPurchaseRequestDTOBuilder.prototype.withProductTypeId = function (_productTypeId) {
        this._productTypeId = _productTypeId;
        return this;
    };
    ValidateNoPreviousPurchaseRequestDTOBuilder.prototype.withEventAggregator = function (_eventAggregator) {
        this._eventAggregator = _eventAggregator;
        return this;
    };
    ValidateNoPreviousPurchaseRequestDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ValidateNoPreviousPurchaseRequest', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            eventAggregator: this._eventAggregator !== UnassignedValue ? this._eventAggregator : maybe(someString()),
            msid: this._msid !== UnassignedValue ? this._msid : maybe(someGuid()),
            productTypeId: this._productTypeId !== UnassignedValue ? this._productTypeId : maybe(someGuid()),
        };
    };
    return ValidateNoPreviousPurchaseRequestDTOBuilder;
}());
exports.ValidateNoPreviousPurchaseRequestDTOBuilder = ValidateNoPreviousPurchaseRequestDTOBuilder;
var ValidateNoPreviousPurchaseResponseDTOBuilder = /** @class */ (function () {
    function ValidateNoPreviousPurchaseResponseDTOBuilder() {
        this._status = UnassignedValue;
    }
    ValidateNoPreviousPurchaseResponseDTOBuilder.prototype.withStatus = function (_status) {
        this._status = _status;
        return this;
    };
    ValidateNoPreviousPurchaseResponseDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'ValidateNoPreviousPurchaseResponse', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            status: this._status !== UnassignedValue ? this._status : maybe(exports.aValidateNoPreviousPurchaseType().build({ buildersVisited: buildersVisited })),
        };
    };
    return ValidateNoPreviousPurchaseResponseDTOBuilder;
}());
exports.ValidateNoPreviousPurchaseResponseDTOBuilder = ValidateNoPreviousPurchaseResponseDTOBuilder;
var ValidateNoPreviousPurchaseTypeDTOBuilder = /** @class */ (function () {
    function ValidateNoPreviousPurchaseTypeDTOBuilder() {
    }
    ValidateNoPreviousPurchaseTypeDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        return oneOf([
            types_1.ValidateNoPreviousPurchaseType.UNKNOWN,
            types_1.ValidateNoPreviousPurchaseType.OK,
            types_1.ValidateNoPreviousPurchaseType.PENDING,
            types_1.ValidateNoPreviousPurchaseType.DELIVERED,
            types_1.ValidateNoPreviousPurchaseType.SERVER_ERROR,
        ]);
    };
    return ValidateNoPreviousPurchaseTypeDTOBuilder;
}());
exports.ValidateNoPreviousPurchaseTypeDTOBuilder = ValidateNoPreviousPurchaseTypeDTOBuilder;
var VendorProductPricesDTOBuilder = /** @class */ (function () {
    function VendorProductPricesDTOBuilder() {
        this._cyclePrices = UnassignedValue;
        this._isDynamicPricing = UnassignedValue;
        this._vendorProductId = UnassignedValue;
    }
    VendorProductPricesDTOBuilder.prototype.withVendorProductId = function (_vendorProductId) {
        this._vendorProductId = _vendorProductId;
        return this;
    };
    VendorProductPricesDTOBuilder.prototype.withCyclePrices = function (_cyclePrices) {
        this._cyclePrices = _cyclePrices;
        return this;
    };
    VendorProductPricesDTOBuilder.prototype.withIsDynamicPricing = function (_isDynamicPricing) {
        this._isDynamicPricing = _isDynamicPricing;
        return this;
    };
    VendorProductPricesDTOBuilder.prototype.build = function (buildInput) {
        if (buildInput === void 0) { buildInput = createDefaultBuildInput(); }
        var buildersVisited = increaseVisit({ caseClassName: 'VendorProductPrices', buildersVisited: buildInput.buildersVisited });
        if (buildersVisited._isDone) {
            return null;
        }
        return {
            cyclePrices: this._cyclePrices !== UnassignedValue ? this._cyclePrices : maybe(manyOf(function () { return exports.aCyclePrice().build({ buildersVisited: buildersVisited }); })),
            isDynamicPricing: this._isDynamicPricing !== UnassignedValue ? this._isDynamicPricing : maybe(someBoolean()),
            vendorProductId: this._vendorProductId !== UnassignedValue ? this._vendorProductId : maybe(someString()),
        };
    };
    return VendorProductPricesDTOBuilder;
}());
exports.VendorProductPricesDTOBuilder = VendorProductPricesDTOBuilder;
var anAllCurrenciesFormattingRequest = function () { return new AllCurrenciesFormattingRequestDTOBuilder(); };
exports.anAllCurrenciesFormattingRequest = anAllCurrenciesFormattingRequest;
var anAllCurrenciesFormattingResponse = function () { return new AllCurrenciesFormattingResponseDTOBuilder(); };
exports.anAllCurrenciesFormattingResponse = anAllCurrenciesFormattingResponse;
var anAllowedActions = function () { return new AllowedActionsDTOBuilder(); };
exports.anAllowedActions = anAllowedActions;
var anAmounts = function () { return new AmountsDTOBuilder(); };
exports.anAmounts = anAmounts;
var anApiV1Cycle = function () { return new ApiV1CycleDTOBuilder(); };
exports.anApiV1Cycle = anApiV1Cycle;
var anApplicationPrices = function () { return new ApplicationPricesDTOBuilder(); };
exports.anApplicationPrices = anApplicationPrices;
var aBillingAddress = function () { return new BillingAddressDTOBuilder(); };
exports.aBillingAddress = aBillingAddress;
var aBillingCycle = function () { return new BillingCycleDTOBuilder(); };
exports.aBillingCycle = aBillingCycle;
var aBillingReference = function () { return new BillingReferenceDTOBuilder(); };
exports.aBillingReference = aBillingReference;
var aBoSbsCatalogProduct = function () { return new BoSbsCatalogProductDTOBuilder(); };
exports.aBoSbsCatalogProduct = aBoSbsCatalogProduct;
var aBooleanFeature = function () { return new BooleanFeatureDTOBuilder(); };
exports.aBooleanFeature = aBooleanFeature;
var aCancelRequest = function () { return new CancelRequestDTOBuilder(); };
exports.aCancelRequest = aCancelRequest;
var aCancelResponse = function () { return new CancelResponseDTOBuilder(); };
exports.aCancelResponse = aCancelResponse;
var aCandidateSubscription = function () { return new CandidateSubscriptionDTOBuilder(); };
exports.aCandidateSubscription = aCandidateSubscription;
var aCatalogReference = function () { return new CatalogReferenceDTOBuilder(); };
exports.aCatalogReference = aCatalogReference;
var aCommonV1Cycle = function () { return new CommonV1CycleDTOBuilder(); };
exports.aCommonV1Cycle = aCommonV1Cycle;
var aContractSwitchType = function () { return new ContractSwitchTypeDTOBuilder(); };
exports.aContractSwitchType = aContractSwitchType;
var aCoupon = function () { return new CouponDTOBuilder(); };
exports.aCoupon = aCoupon;
var aCouponInfo = function () { return new CouponInfoDTOBuilder(); };
exports.aCouponInfo = aCouponInfo;
var aCouponPricing = function () { return new CouponPricingDTOBuilder(); };
exports.aCouponPricing = aCouponPricing;
var aCouponsTypeEligibility = function () { return new CouponsTypeEligibilityDTOBuilder(); };
exports.aCouponsTypeEligibility = aCouponsTypeEligibility;
var aCreateOrderPageRequest = function () { return new CreateOrderPageRequestDTOBuilder(); };
exports.aCreateOrderPageRequest = aCreateOrderPageRequest;
var aCreateOrderPageResponse = function () { return new CreateOrderPageResponseDTOBuilder(); };
exports.aCreateOrderPageResponse = aCreateOrderPageResponse;
var aCreateWixCheckoutRequest = function () { return new CreateWixCheckoutRequestDTOBuilder(); };
exports.aCreateWixCheckoutRequest = aCreateWixCheckoutRequest;
var aCreateWixCheckoutResponse = function () { return new CreateWixCheckoutResponseDTOBuilder(); };
exports.aCreateWixCheckoutResponse = aCreateWixCheckoutResponse;
var aCurrencyCode = function () { return new CurrencyCodeDTOBuilder(); };
exports.aCurrencyCode = aCurrencyCode;
var aCurrencyFormattingKey = function () { return new CurrencyFormattingKeyDTOBuilder(); };
exports.aCurrencyFormattingKey = aCurrencyFormattingKey;
var aCurrencyFormattingKeyValue = function () { return new CurrencyFormattingKeyValueDTOBuilder(); };
exports.aCurrencyFormattingKeyValue = aCurrencyFormattingKeyValue;
var aCurrencySettings = function () { return new CurrencySettingsDTOBuilder(); };
exports.aCurrencySettings = aCurrencySettings;
var aCurrentSubscriptionInfo = function () { return new CurrentSubscriptionInfoDTOBuilder(); };
exports.aCurrentSubscriptionInfo = aCurrentSubscriptionInfo;
var aCycleChange = function () { return new CycleChangeDTOBuilder(); };
exports.aCycleChange = aCycleChange;
var aCycleDisplayProperties = function () { return new CycleDisplayPropertiesDTOBuilder(); };
exports.aCycleDisplayProperties = aCycleDisplayProperties;
var aCyclePrice = function () { return new CyclePriceDTOBuilder(); };
exports.aCyclePrice = aCyclePrice;
var aCyclePricing = function () { return new CyclePricingDTOBuilder(); };
exports.aCyclePricing = aCyclePricing;
var aCyclePricingOld = function () { return new CyclePricingOldDTOBuilder(); };
exports.aCyclePricingOld = aCyclePricingOld;
var aCycleType = function () { return new CycleTypeDTOBuilder(); };
exports.aCycleType = aCycleType;
var aCycleUnitType = function () { return new CycleUnitTypeDTOBuilder(); };
exports.aCycleUnitType = aCycleUnitType;
var aDigitalGoodsPrice = function () { return new DigitalGoodsPriceDTOBuilder(); };
exports.aDigitalGoodsPrice = aDigitalGoodsPrice;
var aDisclaimerInfo = function () { return new DisclaimerInfoDTOBuilder(); };
exports.aDisclaimerInfo = aDisclaimerInfo;
var aDiscountInfo = function () { return new DiscountInfoDTOBuilder(); };
exports.aDiscountInfo = aDiscountInfo;
var aDiscountedPricing = function () { return new DiscountedPricingDTOBuilder(); };
exports.aDiscountedPricing = aDiscountedPricing;
var aDisplayPreview = function () { return new DisplayPreviewDTOBuilder(); };
exports.aDisplayPreview = aDisplayPreview;
var aDuration = function () { return new DurationDTOBuilder(); };
exports.aDuration = aDuration;
var aDurationUnit = function () { return new DurationUnitDTOBuilder(); };
exports.aDurationUnit = aDurationUnit;
var anEligible = function () { return new EligibleDTOBuilder(); };
exports.anEligible = anEligible;
var anEmailSkuDto = function () { return new EmailSkuDtoDTOBuilder(); };
exports.anEmailSkuDto = anEmailSkuDto;
var aFeature = function () { return new FeatureDTOBuilder(); };
exports.aFeature = aFeature;
var aFeatureDisplayAttributes = function () { return new FeatureDisplayAttributesDTOBuilder(); };
exports.aFeatureDisplayAttributes = aFeatureDisplayAttributes;
var aFeaturePeriod = function () { return new FeaturePeriodDTOBuilder(); };
exports.aFeaturePeriod = aFeaturePeriod;
var aField = function () { return new FieldDTOBuilder(); };
exports.aField = aField;
var aFreeTrial = function () { return new FreeTrialDTOBuilder(); };
exports.aFreeTrial = aFreeTrial;
var aFreeTrialEligibility = function () { return new FreeTrialEligibilityDTOBuilder(); };
exports.aFreeTrialEligibility = aFreeTrialEligibility;
var aFreeTrialIneligibilityReasonEnum = function () { return new FreeTrialIneligibilityReasonEnumDTOBuilder(); };
exports.aFreeTrialIneligibilityReasonEnum = aFreeTrialIneligibilityReasonEnum;
var aGetAllowedActionsV2Request = function () { return new GetAllowedActionsV2RequestDTOBuilder(); };
exports.aGetAllowedActionsV2Request = aGetAllowedActionsV2Request;
var aGetB2BUserOfferingRequest = function () { return new GetB2BUserOfferingRequestDTOBuilder(); };
exports.aGetB2BUserOfferingRequest = aGetB2BUserOfferingRequest;
var aGetB2BUserOfferingResponse = function () { return new GetB2BUserOfferingResponseDTOBuilder(); };
exports.aGetB2BUserOfferingResponse = aGetB2BUserOfferingResponse;
var aGetCurrencySettingsRequest = function () { return new GetCurrencySettingsRequestDTOBuilder(); };
exports.aGetCurrencySettingsRequest = aGetCurrencySettingsRequest;
var aGetCurrencySettingsResponse = function () { return new GetCurrencySettingsResponseDTOBuilder(); };
exports.aGetCurrencySettingsResponse = aGetCurrencySettingsResponse;
var aGetFreeTrialEligibilityRequest = function () { return new GetFreeTrialEligibilityRequestDTOBuilder(); };
exports.aGetFreeTrialEligibilityRequest = aGetFreeTrialEligibilityRequest;
var aGetFreeTrialEligibilityResponse = function () { return new GetFreeTrialEligibilityResponseDTOBuilder(); };
exports.aGetFreeTrialEligibilityResponse = aGetFreeTrialEligibilityResponse;
var aGetInfoRequest = function () { return new GetInfoRequestDTOBuilder(); };
exports.aGetInfoRequest = aGetInfoRequest;
var aGetInfoResponse = function () { return new GetInfoResponseDTOBuilder(); };
exports.aGetInfoResponse = aGetInfoResponse;
var aGetItemsRequest = function () { return new GetItemsRequestDTOBuilder(); };
exports.aGetItemsRequest = aGetItemsRequest;
var aGetItemsResponse = function () { return new GetItemsResponseDTOBuilder(); };
exports.aGetItemsResponse = aGetItemsResponse;
var aGetMailboxSaleTypeForDomainRequest = function () { return new GetMailboxSaleTypeForDomainRequestDTOBuilder(); };
exports.aGetMailboxSaleTypeForDomainRequest = aGetMailboxSaleTypeForDomainRequest;
var aGetMailboxSaleTypeForSiteRequest = function () { return new GetMailboxSaleTypeForSiteRequestDTOBuilder(); };
exports.aGetMailboxSaleTypeForSiteRequest = aGetMailboxSaleTypeForSiteRequest;
var aGetMailboxSaleTypeForUserRequest = function () { return new GetMailboxSaleTypeForUserRequestDTOBuilder(); };
exports.aGetMailboxSaleTypeForUserRequest = aGetMailboxSaleTypeForUserRequest;
var aGetMailboxSaleTypeResponse = function () { return new GetMailboxSaleTypeResponseDTOBuilder(); };
exports.aGetMailboxSaleTypeResponse = aGetMailboxSaleTypeResponse;
var aGetOrderPreviewRequest = function () { return new GetOrderPreviewRequestDTOBuilder(); };
exports.aGetOrderPreviewRequest = aGetOrderPreviewRequest;
var aGetOrderPreviewResponse = function () { return new GetOrderPreviewResponseDTOBuilder(); };
exports.aGetOrderPreviewResponse = aGetOrderPreviewResponse;
var aGetPackagePickerPricingRequest = function () { return new GetPackagePickerPricingRequestDTOBuilder(); };
exports.aGetPackagePickerPricingRequest = aGetPackagePickerPricingRequest;
var aGetPackagePickerPricingResponse = function () { return new GetPackagePickerPricingResponseDTOBuilder(); };
exports.aGetPackagePickerPricingResponse = aGetPackagePickerPricingResponse;
var aGetProductDisplayAttributesRequest = function () { return new GetProductDisplayAttributesRequestDTOBuilder(); };
exports.aGetProductDisplayAttributesRequest = aGetProductDisplayAttributesRequest;
var aGetProductDisplayAttributesResponse = function () { return new GetProductDisplayAttributesResponseDTOBuilder(); };
exports.aGetProductDisplayAttributesResponse = aGetProductDisplayAttributesResponse;
var aGetProductInfoRequest = function () { return new GetProductInfoRequestDTOBuilder(); };
exports.aGetProductInfoRequest = aGetProductInfoRequest;
var aGetProductInfoResponse = function () { return new GetProductInfoResponseDTOBuilder(); };
exports.aGetProductInfoResponse = aGetProductInfoResponse;
var aGetSaleRequest = function () { return new GetSaleRequestDTOBuilder(); };
exports.aGetSaleRequest = aGetSaleRequest;
var aGetSaleResponse = function () { return new GetSaleResponseDTOBuilder(); };
exports.aGetSaleResponse = aGetSaleResponse;
var aGetTaxSettingsRequest = function () { return new GetTaxSettingsRequestDTOBuilder(); };
exports.aGetTaxSettingsRequest = aGetTaxSettingsRequest;
var aGetTaxSettingsResponse = function () { return new GetTaxSettingsResponseDTOBuilder(); };
exports.aGetTaxSettingsResponse = aGetTaxSettingsResponse;
var aGetUserCouponsTypeEligibilityRequest = function () { return new GetUserCouponsTypeEligibilityRequestDTOBuilder(); };
exports.aGetUserCouponsTypeEligibilityRequest = aGetUserCouponsTypeEligibilityRequest;
var aGetUserCouponsTypeEligibilityResponse = function () { return new GetUserCouponsTypeEligibilityResponseDTOBuilder(); };
exports.aGetUserCouponsTypeEligibilityResponse = aGetUserCouponsTypeEligibilityResponse;
var aGetUserOfferingRequest = function () { return new GetUserOfferingRequestDTOBuilder(); };
exports.aGetUserOfferingRequest = aGetUserOfferingRequest;
var aGetUserOfferingResponse = function () { return new GetUserOfferingResponseDTOBuilder(); };
exports.aGetUserOfferingResponse = aGetUserOfferingResponse;
var anImage = function () { return new ImageDTOBuilder(); };
exports.anImage = anImage;
var anInterval = function () { return new IntervalDTOBuilder(); };
exports.anInterval = anInterval;
var anIntervalUnit = function () { return new IntervalUnitDTOBuilder(); };
exports.anIntervalUnit = anIntervalUnit;
var anItem = function () { return new ItemDTOBuilder(); };
exports.anItem = anItem;
var anItemData = function () { return new ItemDataDTOBuilder(); };
exports.anItemData = anItemData;
var aLineItem = function () { return new LineItemDTOBuilder(); };
exports.aLineItem = aLineItem;
var aLineItemEntry = function () { return new LineItemEntryDTOBuilder(); };
exports.aLineItemEntry = aLineItemEntry;
var aLineItemPrices = function () { return new LineItemPricesDTOBuilder(); };
exports.aLineItemPrices = aLineItemPrices;
var aListDigitalGoodsPricesRequest = function () { return new ListDigitalGoodsPricesRequestDTOBuilder(); };
exports.aListDigitalGoodsPricesRequest = aListDigitalGoodsPricesRequest;
var aListDigitalGoodsPricesResponse = function () { return new ListDigitalGoodsPricesResponseDTOBuilder(); };
exports.aListDigitalGoodsPricesResponse = aListDigitalGoodsPricesResponse;
var aListLineItemsPricesRequest = function () { return new ListLineItemsPricesRequestDTOBuilder(); };
exports.aListLineItemsPricesRequest = aListLineItemsPricesRequest;
var aListLineItemsPricesResponse = function () { return new ListLineItemsPricesResponseDTOBuilder(); };
exports.aListLineItemsPricesResponse = aListLineItemsPricesResponse;
var aListPremiumProductCatalogPricesRequest = function () { return new ListPremiumProductCatalogPricesRequestDTOBuilder(); };
exports.aListPremiumProductCatalogPricesRequest = aListPremiumProductCatalogPricesRequest;
var aListPremiumProductCatalogPricesResponse = function () { return new ListPremiumProductCatalogPricesResponseDTOBuilder(); };
exports.aListPremiumProductCatalogPricesResponse = aListPremiumProductCatalogPricesResponse;
var aListProductPricesRequest = function () { return new ListProductPricesRequestDTOBuilder(); };
exports.aListProductPricesRequest = aListProductPricesRequest;
var aListProductPricesResponse = function () { return new ListProductPricesResponseDTOBuilder(); };
exports.aListProductPricesResponse = aListProductPricesResponse;
var aListTpaPricesRequest = function () { return new ListTpaPricesRequestDTOBuilder(); };
exports.aListTpaPricesRequest = aListTpaPricesRequest;
var aListTpaPricesResponse = function () { return new ListTpaPricesResponseDTOBuilder(); };
exports.aListTpaPricesResponse = aListTpaPricesResponse;
var aMailboxOldSaleType = function () { return new MailboxOldSaleTypeDTOBuilder(); };
exports.aMailboxOldSaleType = aMailboxOldSaleType;
var aMailboxSaleType = function () { return new MailboxSaleTypeDTOBuilder(); };
exports.aMailboxSaleType = aMailboxSaleType;
var aMultiLingualText = function () { return new MultiLingualTextDTOBuilder(); };
exports.aMultiLingualText = aMultiLingualText;
var aNewSubscription = function () { return new NewSubscriptionDTOBuilder(); };
exports.aNewSubscription = aNewSubscription;
var aNonCouponUsage = function () { return new NonCouponUsageDTOBuilder(); };
exports.aNonCouponUsage = aNonCouponUsage;
var anOneTime = function () { return new OneTimeDTOBuilder(); };
exports.anOneTime = anOneTime;
var anOrderPreview = function () { return new OrderPreviewDTOBuilder(); };
exports.anOrderPreview = anOrderPreview;
var anOrderPreviewItem = function () { return new OrderPreviewItemDTOBuilder(); };
exports.anOrderPreviewItem = anOrderPreviewItem;
var aPaymentCycle = function () { return new PaymentCycleDTOBuilder(); };
exports.aPaymentCycle = aPaymentCycle;
var aPaymentFilters = function () { return new PaymentFiltersDTOBuilder(); };
exports.aPaymentFilters = aPaymentFilters;
var aPaymentType = function () { return new PaymentTypeDTOBuilder(); };
exports.aPaymentType = aPaymentType;
var aPersonalCoupon = function () { return new PersonalCouponDTOBuilder(); };
exports.aPersonalCoupon = aPersonalCoupon;
var aPremiumCurrencySettings = function () { return new PremiumCurrencySettingsDTOBuilder(); };
exports.aPremiumCurrencySettings = aPremiumCurrencySettings;
var aPremiumProduct = function () { return new PremiumProductDTOBuilder(); };
exports.aPremiumProduct = aPremiumProduct;
var aPremiumProductCatalogProductPrices = function () { return new PremiumProductCatalogProductPricesDTOBuilder(); };
exports.aPremiumProductCatalogProductPrices = aPremiumProductCatalogProductPrices;
var aPremiumProductPrice = function () { return new PremiumProductPriceDTOBuilder(); };
exports.aPremiumProductPrice = aPremiumProductPrice;
var aPriceAmounts = function () { return new PriceAmountsDTOBuilder(); };
exports.aPriceAmounts = aPriceAmounts;
var aPricingInfo = function () { return new PricingInfoDTOBuilder(); };
exports.aPricingInfo = aPricingInfo;
var aProduct = function () { return new ProductDTOBuilder(); };
exports.aProduct = aProduct;
var aProductChange = function () { return new ProductChangeDTOBuilder(); };
exports.aProductChange = aProductChange;
var aProductCoupon = function () { return new ProductCouponDTOBuilder(); };
exports.aProductCoupon = aProductCoupon;
var aProductCyclePrice = function () { return new ProductCyclePriceDTOBuilder(); };
exports.aProductCyclePrice = aProductCyclePrice;
var aProductData = function () { return new ProductDataDTOBuilder(); };
exports.aProductData = aProductData;
var aProductDisplayAttributes = function () { return new ProductDisplayAttributesDTOBuilder(); };
exports.aProductDisplayAttributes = aProductDisplayAttributes;
var aProductInfo = function () { return new ProductInfoDTOBuilder(); };
exports.aProductInfo = aProductInfo;
var aProductPrices = function () { return new ProductPricesDTOBuilder(); };
exports.aProductPrices = aProductPrices;
var aProductPricingResult = function () { return new ProductPricingResultDTOBuilder(); };
exports.aProductPricingResult = aProductPricingResult;
var aProvisionProductsRequest = function () { return new ProvisionProductsRequestDTOBuilder(); };
exports.aProvisionProductsRequest = aProvisionProductsRequest;
var aProvisionProductsResponse = function () { return new ProvisionProductsResponseDTOBuilder(); };
exports.aProvisionProductsResponse = aProvisionProductsResponse;
var aPurchaseDetails = function () { return new PurchaseDetailsDTOBuilder(); };
exports.aPurchaseDetails = aPurchaseDetails;
var aPurchaseDisclaimer = function () { return new PurchaseDisclaimerDTOBuilder(); };
exports.aPurchaseDisclaimer = aPurchaseDisclaimer;
var aPurchaseDisplayProperties = function () { return new PurchaseDisplayPropertiesDTOBuilder(); };
exports.aPurchaseDisplayProperties = aPurchaseDisplayProperties;
var aPurchaseLineItem = function () { return new PurchaseLineItemDTOBuilder(); };
exports.aPurchaseLineItem = aPurchaseLineItem;
var aPurchaseReturnUrls = function () { return new PurchaseReturnUrlsDTOBuilder(); };
exports.aPurchaseReturnUrls = aPurchaseReturnUrls;
var aPurchaseRule = function () { return new PurchaseRuleDTOBuilder(); };
exports.aPurchaseRule = aPurchaseRule;
var aPurchaseScenario = function () { return new PurchaseScenarioDTOBuilder(); };
exports.aPurchaseScenario = aPurchaseScenario;
var aQuotaFeature = function () { return new QuotaFeatureDTOBuilder(); };
exports.aQuotaFeature = aQuotaFeature;
var aRecurringPayment = function () { return new RecurringPaymentDTOBuilder(); };
exports.aRecurringPayment = aRecurringPayment;
var aRequestedApplication = function () { return new RequestedApplicationDTOBuilder(); };
exports.aRequestedApplication = aRequestedApplication;
var aRequestedProduct = function () { return new RequestedProductDTOBuilder(); };
exports.aRequestedProduct = aRequestedProduct;
var aSale = function () { return new SaleDTOBuilder(); };
exports.aSale = aSale;
var aSaleCoupon = function () { return new SaleCouponDTOBuilder(); };
exports.aSaleCoupon = aSaleCoupon;
var aSaleDetails = function () { return new SaleDetailsDTOBuilder(); };
exports.aSaleDetails = aSaleDetails;
var aSalePricing = function () { return new SalePricingDTOBuilder(); };
exports.aSalePricing = aSalePricing;
var aServiceCouponData = function () { return new ServiceCouponDataDTOBuilder(); };
exports.aServiceCouponData = aServiceCouponData;
var aServiceData = function () { return new ServiceDataDTOBuilder(); };
exports.aServiceData = aServiceData;
var aServiceRecurringType = function () { return new ServiceRecurringTypeDTOBuilder(); };
exports.aServiceRecurringType = aServiceRecurringType;
var aServiceStatus = function () { return new ServiceStatusDTOBuilder(); };
exports.aServiceStatus = aServiceStatus;
var aServicedataFreeTrialData = function () { return new ServicedataFreeTrialDataDTOBuilder(); };
exports.aServicedataFreeTrialData = aServicedataFreeTrialData;
var aServicedataPendingChanges = function () { return new ServicedataPendingChangesDTOBuilder(); };
exports.aServicedataPendingChanges = aServicedataPendingChanges;
var aStoreMailboxProductPriceDto = function () { return new StoreMailboxProductPriceDtoDTOBuilder(); };
exports.aStoreMailboxProductPriceDto = aStoreMailboxProductPriceDto;
var aStoreMailboxProductPricesDto = function () { return new StoreMailboxProductPricesDtoDTOBuilder(); };
exports.aStoreMailboxProductPricesDto = aStoreMailboxProductPricesDto;
var aStreetAddress = function () { return new StreetAddressDTOBuilder(); };
exports.aStreetAddress = aStreetAddress;
var aSubmitRequest = function () { return new SubmitRequestDTOBuilder(); };
exports.aSubmitRequest = aSubmitRequest;
var aSubmitResponse = function () { return new SubmitResponseDTOBuilder(); };
exports.aSubmitResponse = aSubmitResponse;
var aSubscriptionUpgradeType = function () { return new SubscriptionUpgradeTypeDTOBuilder(); };
exports.aSubscriptionUpgradeType = aSubscriptionUpgradeType;
var aSupportedPaymentTypesFilter = function () { return new SupportedPaymentTypesFilterDTOBuilder(); };
exports.aSupportedPaymentTypesFilter = aSupportedPaymentTypesFilter;
var aSwitchContract = function () { return new SwitchContractDTOBuilder(); };
exports.aSwitchContract = aSwitchContract;
var aTax = function () { return new TaxDTOBuilder(); };
exports.aTax = aTax;
var aTaxAmount = function () { return new TaxAmountDTOBuilder(); };
exports.aTaxAmount = aTaxAmount;
var aTaxSettings = function () { return new TaxSettingsDTOBuilder(); };
exports.aTaxSettings = aTaxSettings;
var aTaxSettingsTaxType = function () { return new TaxSettingsTaxTypeDTOBuilder(); };
exports.aTaxSettingsTaxType = aTaxSettingsTaxType;
var aTaxTypeConfigurationTaxType = function () { return new TaxTypeConfigurationTaxTypeDTOBuilder(); };
exports.aTaxTypeConfigurationTaxType = aTaxTypeConfigurationTaxType;
var aTransferData = function () { return new TransferDataDTOBuilder(); };
exports.aTransferData = aTransferData;
var anUnknownFieldSet = function () { return new UnknownFieldSetDTOBuilder(); };
exports.anUnknownFieldSet = anUnknownFieldSet;
var anUpgradeSubscription = function () { return new UpgradeSubscriptionDTOBuilder(); };
exports.anUpgradeSubscription = anUpgradeSubscription;
var anUserCoupon = function () { return new UserCouponDTOBuilder(); };
exports.anUserCoupon = anUserCoupon;
var aV1FreeTrialData = function () { return new V1FreeTrialDataDTOBuilder(); };
exports.aV1FreeTrialData = aV1FreeTrialData;
var aV1PendingChanges = function () { return new V1PendingChangesDTOBuilder(); };
exports.aV1PendingChanges = aV1PendingChanges;
var aValidateNoPreviousPurchaseRequest = function () { return new ValidateNoPreviousPurchaseRequestDTOBuilder(); };
exports.aValidateNoPreviousPurchaseRequest = aValidateNoPreviousPurchaseRequest;
var aValidateNoPreviousPurchaseResponse = function () { return new ValidateNoPreviousPurchaseResponseDTOBuilder(); };
exports.aValidateNoPreviousPurchaseResponse = aValidateNoPreviousPurchaseResponse;
var aValidateNoPreviousPurchaseType = function () { return new ValidateNoPreviousPurchaseTypeDTOBuilder(); };
exports.aValidateNoPreviousPurchaseType = aValidateNoPreviousPurchaseType;
var aVendorProductPrices = function () { return new VendorProductPricesDTOBuilder(); };
exports.aVendorProductPrices = aVendorProductPrices;
//# sourceMappingURL=builders.js.map